/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.9.0
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
(function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)})(function(i){"use strict";var e=window.Slick||{};e=function(){function e(e,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(e),appendDots:i(e),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(e),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(e).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,"undefined"!=typeof document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):"undefined"!=typeof document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=t++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}var t=0;return e}(),e.prototype.activateADA=function(){var i=this;i.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):o===!0?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&i.options.adaptiveHeight===!0&&i.options.vertical===!1){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),s.options.rtl===!0&&s.options.vertical===!1&&(e=-e),s.transformsEnabled===!1?s.options.vertical===!1?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):s.cssTransitions===!1?(s.options.rtl===!0&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),s.options.vertical===!1?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),s.options.vertical===!1?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this,o=t.getNavTarget();null!==o&&"object"==typeof o&&o.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};e.options.fade===!1?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,e.options.fade===!1?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(i.options.infinite===!1&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1===0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;e.options.arrows===!0&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),e.options.infinite!==!0&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(o.options.dots===!0&&o.slideCount>o.options.slidesToShow){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),e.options.centerMode!==!0&&e.options.swipeToSlide!==!0||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.options.draggable===!0&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>0){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(r.originalSettings.mobileFirst===!1?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),e===!0&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),e===!0&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,e===!0&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||l===!1||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!==0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t,o=this;if(e=o.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var s in e){if(i<e[s]){i=t;break}t=e[s]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),e.options.accessibility===!0&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),e.options.arrows===!0&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),e.options.accessibility===!0&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),e.options.accessibility===!0&&e.$list.off("keydown.slick",e.keyHandler),e.options.focusOnSelect===!0&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>0&&(i=e.$slides.children().children(),i.removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){var e=this;e.shouldClick===!1&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",e.options.fade===!1?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;t.cssTransitions===!1?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;e.cssTransitions===!1?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick","*",function(t){var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&o.is(":focus")&&(e.focussed=!0,e.autoPlay())},0)}).on("blur.slick","*",function(t){i(this);e.options.pauseOnFocus&&(e.focussed=!1,e.autoPlay())})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){var i=this;return i.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(i.options.infinite===!0)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(i.options.centerMode===!0)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),n.options.infinite===!0?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,n.options.vertical===!0&&n.options.centerMode===!0&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!==0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),n.options.centerMode===!0&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:n.options.centerMode===!0&&n.options.infinite===!0?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:n.options.centerMode===!0&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=n.options.vertical===!1?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,n.options.variableWidth===!0&&(o=n.slideCount<=n.options.slidesToShow||n.options.infinite===!1?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=n.options.rtl===!0?o[0]?(n.$slideTrack.width()-o[0].offsetLeft-o.width())*-1:0:o[0]?o[0].offsetLeft*-1:0,n.options.centerMode===!0&&(o=n.slideCount<=n.options.slidesToShow||n.options.infinite===!1?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=n.options.rtl===!0?o[0]?(n.$slideTrack.width()-o[0].offsetLeft-o.width())*-1:0:o[0]?o[0].offsetLeft*-1:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){var e=this;return e.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(e.options.infinite===!1?i=e.slideCount:(t=e.options.slidesToScroll*-1,o=e.options.slidesToScroll*-1,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o,s,n=this;return s=n.options.centerMode===!0?Math.floor(n.$list.width()/2):0,o=n.swipeLeft*-1+s,n.options.swipeToSlide===!0?(n.$slideTrack.find(".slick-slide").each(function(e,s){var r,l,d;if(r=i(s).outerWidth(),l=s.offsetLeft,n.options.centerMode!==!0&&(l+=r/2),d=l+r,o<d)return t=s,!1}),e=Math.abs(i(t).attr("data-slick-index")-n.currentSlide)||1):n.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){var t=this;t.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),t.options.accessibility===!0&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);if(i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),s!==-1){var n="slick-slide-control"+e.instanceUid+s;i("#"+n).length&&i(this).attr({"aria-describedby":n})}}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.options.focusOnChange?e.$slides.eq(s).attr({tabindex:"0"}):e.$slides.eq(s).removeAttr("tabindex");e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;i.options.arrows===!0&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),i.options.accessibility===!0&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;e.options.dots===!0&&e.slideCount>e.options.slidesToShow&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),e.options.accessibility===!0&&e.$dots.on("keydown.slick",e.keyHandler)),e.options.dots===!0&&e.options.pauseOnDotsHover===!0&&e.slideCount>e.options.slidesToShow&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),e.options.accessibility===!0&&e.$list.on("keydown.slick",e.keyHandler),e.options.focusOnSelect===!0&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;i.options.arrows===!0&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),i.options.dots===!0&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&e.options.accessibility===!0?e.changeSlide({data:{message:e.options.rtl===!0?"next":"previous"}}):39===i.keyCode&&e.options.accessibility===!0&&e.changeSlide({data:{message:e.options.rtl===!0?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||r.$slider.attr("data-sizes"),n=document.createElement("img");n.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),r.$slider.trigger("lazyLoaded",[r,e,t])})},n.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),r.$slider.trigger("lazyLoadError",[r,e,t])},n.src=t})}var t,o,s,n,r=this;if(r.options.centerMode===!0?r.options.infinite===!0?(s=r.currentSlide+(r.options.slidesToShow/2+1),n=s+r.options.slidesToShow+2):(s=Math.max(0,r.currentSlide-(r.options.slidesToShow/2+1)),n=2+(r.options.slidesToShow/2+1)+r.currentSlide):(s=r.options.infinite?r.options.slidesToShow+r.currentSlide:r.currentSlide,n=Math.ceil(s+r.options.slidesToShow),r.options.fade===!0&&(s>0&&s--,n<=r.slideCount&&n++)),t=r.$slider.find(".slick-slide").slice(s,n),"anticipated"===r.options.lazyLoad)for(var l=s-1,d=n,a=r.$slider.find(".slick-slide"),c=0;c<r.options.slidesToScroll;c++)l<0&&(l=r.slideCount-1),t=t.add(a.eq(l)),t=t.add(a.eq(d)),l--,d++;e(t),r.slideCount<=r.options.slidesToShow?(o=r.$slider.find(".slick-slide"),e(o)):r.currentSlide>=r.slideCount-r.options.slidesToShow?(o=r.$slider.find(".slick-cloned").slice(0,r.options.slidesToShow),e(o)):0===r.currentSlide&&(o=r.$slider.find(".slick-cloned").slice(r.options.slidesToShow*-1),e(o))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){var i=this;i.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;if(!t.unslicked&&(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),t.options.accessibility===!0&&(t.initADA(),t.options.focusOnChange))){var o=i(t.$slides.get(t.currentSlide));o.attr("tabindex",0).focus()}},e.prototype.prev=e.prototype.slickPrev=function(){var i=this;i.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),r=document.createElement("img"),r.onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),l.options.adaptiveHeight===!0&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),e.options.focusOnSelect===!0&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;return"boolean"==typeof i?(e=i,i=e===!0?0:o.slideCount-1):i=e===!0?--i:i,!(o.slideCount<1||i<0||i>o.slideCount-1)&&(o.unload(),t===!0?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,void o.reinit())},e.prototype.setCSS=function(i){var e,t,o=this,s={};o.options.rtl===!0&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,o.transformsEnabled===!1?o.$slideTrack.css(s):(s={},o.cssTransitions===!1?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;i.options.vertical===!1?i.options.centerMode===!0&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),i.options.centerMode===!0&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),i.options.vertical===!1&&i.options.variableWidth===!1?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):i.options.variableWidth===!0?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();i.options.variableWidth===!1&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,t.options.rtl===!0?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&i.options.adaptiveHeight===!0&&i.options.vertical===!1){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":"undefined"!=typeof arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),i.options.fade===!1?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=i.options.vertical===!0?"top":"left",
"top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||i.options.useCSS===!0&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&i.animType!==!1&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&i.animType!==!1},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),n.options.centerMode===!0){var r=n.options.slidesToShow%2===0?1:0;e=Math.floor(n.options.slidesToShow/2),n.options.infinite===!0&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=n.options.infinite===!0?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(s.options.fade===!0&&(s.options.centerMode=!1),s.options.infinite===!0&&s.options.fade===!1&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=s.options.centerMode===!0?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));return s||(s=0),t.slideCount<=t.options.slidesToShow?void t.slideHandler(s,!1,!0):void t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(a.animating===!0&&a.options.waitForAnimate===!0||a.options.fade===!0&&a.currentSlide===i))return e===!1&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,a.options.infinite===!1&&a.options.centerMode===!1&&(i<0||i>a.getDotCount()*a.options.slidesToScroll)?void(a.options.fade===!1&&(o=a.currentSlide,t!==!0&&a.slideCount>a.options.slidesToShow?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o))):a.options.infinite===!1&&a.options.centerMode===!0&&(i<0||i>a.slideCount-a.options.slidesToScroll)?void(a.options.fade===!1&&(o=a.currentSlide,t!==!0&&a.slideCount>a.options.slidesToShow?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o))):(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!==0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!==0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=a.getNavTarget(),l=l.slick("getSlick"),l.slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide)),a.updateDots(),a.updateArrows(),a.options.fade===!0?(t!==!0?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight()):void(t!==!0&&a.slideCount>a.options.slidesToShow?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)))},e.prototype.startLoad=function(){var i=this;i.options.arrows===!0&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),i.options.dots===!0&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),o=Math.round(180*t/Math.PI),o<0&&(o=360-Math.abs(o)),o<=45&&o>=0?s.options.rtl===!1?"left":"right":o<=360&&o>=315?s.options.rtl===!1?"left":"right":o>=135&&o<=225?s.options.rtl===!1?"right":"left":s.options.verticalSwiping===!0?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(o.touchObject.edgeHit===!0&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(e.options.swipe===!1||"ontouchend"in document&&e.options.swipe===!1||e.options.draggable===!1&&i.type.indexOf("mouse")!==-1))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,e.options.verticalSwiping===!0&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(l.options.verticalSwiping===!0&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(l.options.rtl===!1?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),l.options.verticalSwiping===!0&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,l.options.infinite===!1&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),l.options.vertical===!1?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,l.options.verticalSwiping===!0&&(l.swipeLeft=e+o*s),l.options.fade!==!0&&l.options.touchMove!==!1&&(l.animating===!0?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;return t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow?(t.touchObject={},!1):(void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,void(t.dragging=!0))},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i,e=this;i=Math.floor(e.options.slidesToShow/2),e.options.arrows===!0&&e.slideCount>e.options.slidesToShow&&!e.options.infinite&&(e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===e.currentSlide?(e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):e.currentSlide>=e.slideCount-e.options.slidesToShow&&e.options.centerMode===!1?(e.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):e.currentSlide>=e.slideCount-1&&e.options.centerMode===!0&&(e.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||"undefined"==typeof s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),"undefined"!=typeof t)return t;return o}});

/*! @vimeo/player v2.14.1 | (c) 2020 Vimeo | MIT License | https://github.com/vimeo/player.js */
/*
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):((e="undefined"!=typeof globalThis?globalThis:e||self).Vimeo=e.Vimeo||{},e.Vimeo.Player=t())}(this,function(){"use strict";function r(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var e="undefined"!=typeof global&&"[object global]"==={}.toString.call(global);function i(e,t){return 0===e.indexOf(t.toLowerCase())?e:"".concat(t.toLowerCase()).concat(e.substr(0,1).toUpperCase()).concat(e.substr(1))}function c(e){return/^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(e)}function s(e){var t,n=0<arguments.length&&void 0!==e?e:{},r=n.id,o=n.url,i=r||o;if(!i)throw new Error("An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.");if(t=i,!isNaN(parseFloat(t))&&isFinite(t)&&Math.floor(t)==t)return"https://vimeo.com/".concat(i);if(c(i))return i.replace("http:","https:");if(r)throw new TypeError("“".concat(r,"” is not a valid video id."));throw new TypeError("“".concat(i,"” is not a vimeo.com url."))}var t=void 0!==Array.prototype.indexOf,n="undefined"!=typeof window&&void 0!==window.postMessage;if(!(e||t&&n))throw new Error("Sorry, the Vimeo Player API is not available in this browser.");var o,a,u,l="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function f(){if(void 0===this)throw new TypeError("Constructor WeakMap requires 'new'");if(u(this,"_id","_WeakMap_"+h()+"."+h()),0<arguments.length)throw new TypeError("WeakMap iterable is not supported")}function d(e,t){if(!v(e)||!a.call(e,"_id"))throw new TypeError(t+" method called on incompatible receiver "+typeof e)}function h(){return Math.random().toString().substring(2)}function v(e){return Object(e)===e}(o="undefined"!=typeof self?self:"undefined"!=typeof window?window:l).WeakMap||(a=Object.prototype.hasOwnProperty,u=function(e,t,n){Object.defineProperty?Object.defineProperty(e,t,{configurable:!0,writable:!0,value:n}):e[t]=n},o.WeakMap=(u(f.prototype,"delete",function(e){if(d(this,"delete"),!v(e))return!1;var t=e[this._id];return!(!t||t[0]!==e)&&(delete e[this._id],!0)}),u(f.prototype,"get",function(e){if(d(this,"get"),v(e)){var t=e[this._id];return t&&t[0]===e?t[1]:void 0}}),u(f.prototype,"has",function(e){if(d(this,"has"),!v(e))return!1;var t=e[this._id];return!(!t||t[0]!==e)}),u(f.prototype,"set",function(e,t){if(d(this,"set"),!v(e))throw new TypeError("Invalid value used as weak map key");var n=e[this._id];return n&&n[0]===e?n[1]=t:u(e,this._id,[e,t]),this}),u(f,"_polyfill",!0),f));var m,p=(function(e){var t,n,r;r=function(){var t,n,r,o,i,a,e=Object.prototype.toString,u="undefined"!=typeof setImmediate?function(e){return setImmediate(e)}:setTimeout;try{Object.defineProperty({},"x",{}),t=function(e,t,n,r){return Object.defineProperty(e,t,{value:n,writable:!0,configurable:!1!==r})}}catch(e){t=function(e,t,n){return e[t]=n,e}}function l(e,t){this.fn=e,this.self=t,this.next=void 0}function c(e,t){r.add(e,t),n=n||u(r.drain)}function s(e){var t,n=typeof e;return null==e||"object"!=n&&"function"!=n||(t=e.then),"function"==typeof t&&t}function f(){for(var e=0;e<this.chain.length;e++)!function(e,t,n){var r,o;try{!1===t?n.reject(e.msg):(r=!0===t?e.msg:t.call(void 0,e.msg))===n.promise?n.reject(TypeError("Promise-chain cycle")):(o=s(r))?o.call(r,n.resolve,n.reject):n.resolve(r)}catch(e){n.reject(e)}}(this,1===this.state?this.chain[e].success:this.chain[e].failure,this.chain[e]);this.chain.length=0}function d(e){var n,r=this;if(!r.triggered){r.triggered=!0,r.def&&(r=r.def);try{(n=s(e))?c(function(){var t=new m(r);try{n.call(e,function(){d.apply(t,arguments)},function(){h.apply(t,arguments)})}catch(e){h.call(t,e)}}):(r.msg=e,r.state=1,0<r.chain.length&&c(f,r))}catch(e){h.call(new m(r),e)}}}function h(e){var t=this;t.triggered||(t.triggered=!0,t.def&&(t=t.def),t.msg=e,t.state=2,0<t.chain.length&&c(f,t))}function v(e,n,r,o){for(var t=0;t<n.length;t++)!function(t){e.resolve(n[t]).then(function(e){r(t,e)},o)}(t)}function m(e){this.def=e,this.triggered=!1}function p(e){this.promise=e,this.state=0,this.triggered=!1,this.chain=[],this.msg=void 0}function y(e){if("function"!=typeof e)throw TypeError("Not a function");if(0!==this.__NPO__)throw TypeError("Not a promise");this.__NPO__=1;var r=new p(this);this.then=function(e,t){var n={success:"function"!=typeof e||e,failure:"function"==typeof t&&t};return n.promise=new this.constructor(function(e,t){if("function"!=typeof e||"function"!=typeof t)throw TypeError("Not a function");n.resolve=e,n.reject=t}),r.chain.push(n),0!==r.state&&c(f,r),n.promise},this.catch=function(e){return this.then(void 0,e)};try{e.call(void 0,function(e){d.call(r,e)},function(e){h.call(r,e)})}catch(e){h.call(r,e)}}var g=t({},"constructor",y,!(r={add:function(e,t){a=new l(e,t),i?i.next=a:o=a,i=a,a=void 0},drain:function(){var e=o;for(o=i=n=void 0;e;)e.fn.call(e.self),e=e.next}}));return t(y.prototype=g,"__NPO__",0,!1),t(y,"resolve",function(n){return n&&"object"==typeof n&&1===n.__NPO__?n:new this(function(e,t){if("function"!=typeof e||"function"!=typeof t)throw TypeError("Not a function");e(n)})}),t(y,"reject",function(n){return new this(function(e,t){if("function"!=typeof e||"function"!=typeof t)throw TypeError("Not a function");t(n)})}),t(y,"all",function(t){var a=this;return"[object Array]"!=e.call(t)?a.reject(TypeError("Not an array")):0===t.length?a.resolve([]):new a(function(n,e){if("function"!=typeof n||"function"!=typeof e)throw TypeError("Not a function");var r=t.length,o=Array(r),i=0;v(a,t,function(e,t){o[e]=t,++i===r&&n(o)},e)})}),t(y,"race",function(t){var r=this;return"[object Array]"!=e.call(t)?r.reject(TypeError("Not an array")):new r(function(n,e){if("function"!=typeof n||"function"!=typeof e)throw TypeError("Not a function");v(r,t,function(e,t){n(t)},e)})}),y},(n=l)[t="Promise"]=n[t]||r(),e.exports&&(e.exports=n[t])}(m={exports:{}}),m.exports),y=new WeakMap;function g(e,t,n){var r=y.get(e.element)||{};t in r||(r[t]=[]),r[t].push(n),y.set(e.element,r)}function w(e,t){return(y.get(e.element)||{})[t]||[]}function b(e,t,n){var r=y.get(e.element)||{};if(!r[t])return!0;if(!n)return r[t]=[],y.set(e.element,r),!0;var o=r[t].indexOf(n);return-1!==o&&r[t].splice(o,1),y.set(e.element,r),r[t]&&0===r[t].length}var k=["autopause","autoplay","background","byline","color","controls","dnt","height","id","loop","maxheight","maxwidth","muted","playsinline","portrait","responsive","speed","texttrack","title","transparent","url","width"];function E(r,e){var t=1<arguments.length&&void 0!==e?e:{};return k.reduce(function(e,t){var n=r.getAttribute("data-vimeo-".concat(t));return!n&&""!==n||(e[t]=""===n?1:n),e},t)}function T(e,t){var n=e.html;if(!t)throw new TypeError("An element must be provided");if(null!==t.getAttribute("data-vimeo-initialized"))return t.querySelector("iframe");var r=document.createElement("div");return r.innerHTML=n,t.appendChild(r.firstChild),t.setAttribute("data-vimeo-initialized","true"),t.querySelector("iframe")}function F(i,e,t){var a=1<arguments.length&&void 0!==e?e:{},u=2<arguments.length?t:void 0;return new Promise(function(t,n){if(!c(i))throw new TypeError("“".concat(i,"” is not a vimeo.com url."));var e="https://vimeo.com/api/oembed.json?url=".concat(encodeURIComponent(i));for(var r in a)a.hasOwnProperty(r)&&(e+="&".concat(r,"=").concat(encodeURIComponent(a[r])));var o=new("XDomainRequest"in window?XDomainRequest:XMLHttpRequest);o.open("GET",e,!0),o.onload=function(){if(404!==o.status)if(403!==o.status)try{var e=JSON.parse(o.responseText);if(403===e.domain_status_code)return T(e,u),void n(new Error("“".concat(i,"” is not embeddable.")));t(e)}catch(e){n(e)}else n(new Error("“".concat(i,"” is not embeddable.")));else n(new Error("“".concat(i,"” was not found.")))},o.onerror=function(){var e=o.status?" (".concat(o.status,")"):"";n(new Error("There was an error fetching the embed code from Vimeo".concat(e,".")))},o.send()})}function _(e){if("string"==typeof e)try{e=JSON.parse(e)}catch(e){return console.warn(e),{}}return e}function M(e,t,n){var r,o;e.element.contentWindow&&e.element.contentWindow.postMessage&&(r={method:t},void 0!==n&&(r.value=n),8<=(o=parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/,"$1")))&&o<10&&(r=JSON.stringify(r)),e.element.contentWindow.postMessage(r,e.origin))}function P(n,r){var t,e,o=[];(r=_(r)).event?("error"===r.event&&w(n,r.data.method).forEach(function(e){var t=new Error(r.data.message);t.name=r.data.name,e.reject(t),b(n,r.data.method,e)}),o=w(n,"event:".concat(r.event)),t=r.data):!r.method||(e=function(e,t){var n=w(e,t);if(n.length<1)return!1;var r=n.shift();return b(e,t,r),r}(n,r.method))&&(o.push(e),t=r.value),o.forEach(function(e){try{if("function"==typeof e)return void e.call(n,t);e.resolve(t)}catch(e){}})}var x,C,j,N=new WeakMap,A=new WeakMap,S={},Player=function(){function Player(u){var e,t,l=this,n=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{};if(!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,Player),window.jQuery&&u instanceof jQuery&&(1<u.length&&window.console&&console.warn&&console.warn("A jQuery object with multiple elements was passed, using the first element."),u=u[0]),"undefined"!=typeof document&&"string"==typeof u&&(u=document.getElementById(u)),e=u,!Boolean(e&&1===e.nodeType&&"nodeName"in e&&e.ownerDocument&&e.ownerDocument.defaultView))throw new TypeError("You must pass either a valid element or a valid id.");if("IFRAME"===u.nodeName||(t=u.querySelector("iframe"))&&(u=t),"IFRAME"===u.nodeName&&!c(u.getAttribute("src")||""))throw new Error("The player element passed isn’t a Vimeo embed.");if(N.has(u))return N.get(u);this._window=u.ownerDocument.defaultView,this.element=u,this.origin="*";var r,o=new p(function(i,a){var e;l._onMessage=function(e){if(c(e.origin)&&l.element.contentWindow===e.source){"*"===l.origin&&(l.origin=e.origin);var t=_(e.data);if(t&&"error"===t.event&&t.data&&"ready"===t.data.method){var n=new Error(t.data.message);return n.name=t.data.name,void a(n)}var r=t&&"ready"===t.event,o=t&&"ping"===t.method;if(r||o)return l.element.setAttribute("data-ready","true"),void i();P(l,t)}},l._window.addEventListener("message",l._onMessage),"IFRAME"!==l.element.nodeName&&F(s(e=E(u,n)),e,u).then(function(e){var t,n,r,o=T(e,u);return l.element=o,l._originalElement=u,t=u,n=o,r=y.get(t),y.set(n,r),y.delete(t),N.set(l.element,l),e}).catch(a)});return A.set(this,o),N.set(this.element,this),"IFRAME"===this.element.nodeName&&M(this,"ping"),S.isEnabled&&(r=function(){return S.exit()},S.on("fullscreenchange",function(){(S.isFullscreen?g:b)(l,"event:exitFullscreen",r),l.ready().then(function(){M(l,"fullscreenchange",S.isFullscreen)})})),this}var e,t,n;return e=Player,(t=[{key:"callMethod",value:function(n,e){var r=this,o=1<arguments.length&&void 0!==e?e:{};return new p(function(e,t){return r.ready().then(function(){g(r,n,{resolve:e,reject:t}),M(r,n,o)}).catch(t)})}},{key:"get",value:function(n){var r=this;return new p(function(e,t){return n=i(n,"get"),r.ready().then(function(){g(r,n,{resolve:e,reject:t}),M(r,n)}).catch(t)})}},{key:"set",value:function(n,r){var o=this;return new p(function(e,t){if(n=i(n,"set"),null==r)throw new TypeError("There must be a value to set.");return o.ready().then(function(){g(o,n,{resolve:e,reject:t}),M(o,n,r)}).catch(t)})}},{key:"on",value:function(e,t){if(!e)throw new TypeError("You must pass an event name.");if(!t)throw new TypeError("You must pass a callback function.");if("function"!=typeof t)throw new TypeError("The callback must be a function.");0===w(this,"event:".concat(e)).length&&this.callMethod("addEventListener",e).catch(function(){}),g(this,"event:".concat(e),t)}},{key:"off",value:function(e,t){if(!e)throw new TypeError("You must pass an event name.");if(t&&"function"!=typeof t)throw new TypeError("The callback must be a function.");b(this,"event:".concat(e),t)&&this.callMethod("removeEventListener",e).catch(function(e){})}},{key:"loadVideo",value:function(e){return this.callMethod("loadVideo",e)}},{key:"ready",value:function(){var e=A.get(this)||new p(function(e,t){t(new Error("Unknown player. Probably unloaded."))});return p.resolve(e)}},{key:"addCuePoint",value:function(e,t){var n=1<arguments.length&&void 0!==t?t:{};return this.callMethod("addCuePoint",{time:e,data:n})}},{key:"removeCuePoint",value:function(e){return this.callMethod("removeCuePoint",e)}},{key:"enableTextTrack",value:function(e,t){if(!e)throw new TypeError("You must pass a language.");return this.callMethod("enableTextTrack",{language:e,kind:t})}},{key:"disableTextTrack",value:function(){return this.callMethod("disableTextTrack")}},{key:"pause",value:function(){return this.callMethod("pause")}},{key:"play",value:function(){return this.callMethod("play")}},{key:"requestFullscreen",value:function(){return S.isEnabled?S.request(this.element):this.callMethod("requestFullscreen")}},{key:"exitFullscreen",value:function(){return S.isEnabled?S.exit():this.callMethod("exitFullscreen")}},{key:"getFullscreen",value:function(){return S.isEnabled?p.resolve(S.isFullscreen):this.get("fullscreen")}},{key:"unload",value:function(){return this.callMethod("unload")}},{key:"destroy",value:function(){var n=this;return new p(function(e){var t;A.delete(n),N.delete(n.element),n._originalElement&&(N.delete(n._originalElement),n._originalElement.removeAttribute("data-vimeo-initialized")),n.element&&"IFRAME"===n.element.nodeName&&n.element.parentNode&&n.element.parentNode.removeChild(n.element),n.element&&"DIV"===n.element.nodeName&&n.element.parentNode&&(n.element.removeAttribute("data-vimeo-initialized"),(t=n.element.querySelector("iframe"))&&t.parentNode&&t.parentNode.removeChild(t)),n._window.removeEventListener("message",n._onMessage),e()})}},{key:"getAutopause",value:function(){return this.get("autopause")}},{key:"setAutopause",value:function(e){return this.set("autopause",e)}},{key:"getBuffered",value:function(){return this.get("buffered")}},{key:"getCameraProps",value:function(){return this.get("cameraProps")}},{key:"setCameraProps",value:function(e){return this.set("cameraProps",e)}},{key:"getChapters",value:function(){return this.get("chapters")}},{key:"getCurrentChapter",value:function(){return this.get("currentChapter")}},{key:"getColor",value:function(){return this.get("color")}},{key:"setColor",value:function(e){return this.set("color",e)}},{key:"getCuePoints",value:function(){return this.get("cuePoints")}},{key:"getCurrentTime",value:function(){return this.get("currentTime")}},{key:"setCurrentTime",value:function(e){return this.set("currentTime",e)}},{key:"getDuration",value:function(){return this.get("duration")}},{key:"getEnded",value:function(){return this.get("ended")}},{key:"getLoop",value:function(){return this.get("loop")}},{key:"setLoop",value:function(e){return this.set("loop",e)}},{key:"setMuted",value:function(e){return this.set("muted",e)}},{key:"getMuted",value:function(){return this.get("muted")}},{key:"getPaused",value:function(){return this.get("paused")}},{key:"getPlaybackRate",value:function(){return this.get("playbackRate")}},{key:"setPlaybackRate",value:function(e){return this.set("playbackRate",e)}},{key:"getPlayed",value:function(){return this.get("played")}},{key:"getQualities",value:function(){return this.get("qualities")}},{key:"getQuality",value:function(){return this.get("quality")}},{key:"setQuality",value:function(e){return this.set("quality",e)}},{key:"getSeekable",value:function(){return this.get("seekable")}},{key:"getSeeking",value:function(){return this.get("seeking")}},{key:"getTextTracks",value:function(){return this.get("textTracks")}},{key:"getVideoEmbedCode",value:function(){return this.get("videoEmbedCode")}},{key:"getVideoId",value:function(){return this.get("videoId")}},{key:"getVideoTitle",value:function(){return this.get("videoTitle")}},{key:"getVideoWidth",value:function(){return this.get("videoWidth")}},{key:"getVideoHeight",value:function(){return this.get("videoHeight")}},{key:"getVideoUrl",value:function(){return this.get("videoUrl")}},{key:"getVolume",value:function(){return this.get("volume")}},{key:"setVolume",value:function(e){return this.set("volume",e)}}])&&r(e.prototype,t),n&&r(e,n),Player}();return e||(x=function(){for(var e,t=[["requestFullscreen","exitFullscreen","fullscreenElement","fullscreenEnabled","fullscreenchange","fullscreenerror"],["webkitRequestFullscreen","webkitExitFullscreen","webkitFullscreenElement","webkitFullscreenEnabled","webkitfullscreenchange","webkitfullscreenerror"],["webkitRequestFullScreen","webkitCancelFullScreen","webkitCurrentFullScreenElement","webkitCancelFullScreen","webkitfullscreenchange","webkitfullscreenerror"],["mozRequestFullScreen","mozCancelFullScreen","mozFullScreenElement","mozFullScreenEnabled","mozfullscreenchange","mozfullscreenerror"],["msRequestFullscreen","msExitFullscreen","msFullscreenElement","msFullscreenEnabled","MSFullscreenChange","MSFullscreenError"]],n=0,r=t.length,o={};n<r;n++)if((e=t[n])&&e[1]in document){for(n=0;n<e.length;n++)o[t[0][n]]=e[n];return o}return!1}(),C={fullscreenchange:x.fullscreenchange,fullscreenerror:x.fullscreenerror},j={request:function(o){return new Promise(function(e,t){function n(){j.off("fullscreenchange",n),e()}j.on("fullscreenchange",n);var r=(o=o||document.documentElement)[x.requestFullscreen]();r instanceof Promise&&r.then(n).catch(t)})},exit:function(){return new Promise(function(t,e){var n,r;j.isFullscreen?(n=function e(){j.off("fullscreenchange",e),t()},j.on("fullscreenchange",n),(r=document[x.exitFullscreen]())instanceof Promise&&r.then(n).catch(e)):t()})},on:function(e,t){var n=C[e];n&&document.addEventListener(n,t)},off:function(e,t){var n=C[e];n&&document.removeEventListener(n,t)}},Object.defineProperties(j,{isFullscreen:{get:function(){return Boolean(document[x.fullscreenElement])}},element:{enumerable:!0,get:function(){return document[x.fullscreenElement]}},isEnabled:{enumerable:!0,get:function(){return Boolean(document[x.fullscreenEnabled])}}}),S=j,function(e){function n(e){"console"in window&&console.error&&console.error("There was an error creating an embed: ".concat(e))}var t=0<arguments.length&&void 0!==e?e:document;[].slice.call(t.querySelectorAll("[data-vimeo-id], [data-vimeo-url]")).forEach(function(t){try{if(null!==t.getAttribute("data-vimeo-defer"))return;var e=E(t);F(s(e),e,t).then(function(e){return T(e,t)}).catch(n)}catch(e){n(e)}})}(),function(e){var r=0<arguments.length&&void 0!==e?e:document;window.VimeoPlayerResizeEmbeds_||(window.VimeoPlayerResizeEmbeds_=!0,window.addEventListener("message",function(e){if(c(e.origin)&&e.data&&"spacechange"===e.data.event)for(var t=r.querySelectorAll("iframe"),n=0;n<t.length;n++)if(t[n].contentWindow===e.source){t[n].parentElement.style.paddingBottom="".concat(e.data.data[0].bottom,"px");break}}))}()),Player});
*/

/**
 * SimpleBar.js - v5.0.5
 * Scrollbars, simpler.
 * https://grsmto.github.io/simplebar/
 *
 * Made by Adrien Denat from a fork by Jonathan Nicol
 * Under MIT License
 */

!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):(t=t||self).SimpleBar=e()}(this,(function(){"use strict";var t="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function e(t,e){return t(e={exports:{}},e.exports),e.exports}var r,n,i,o="object",s=function(t){return t&&t.Math==Math&&t},a=s(typeof globalThis==o&&globalThis)||s(typeof window==o&&window)||s(typeof self==o&&self)||s(typeof t==o&&t)||Function("return this")(),c=function(t){try{return!!t()}catch(t){return!0}},l=!c((function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})),u={}.propertyIsEnumerable,f=Object.getOwnPropertyDescriptor,h={f:f&&!u.call({1:2},1)?function(t){var e=f(this,t);return!!e&&e.enumerable}:u},d=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}},p={}.toString,v=function(t){return p.call(t).slice(8,-1)},g="".split,y=c((function(){return!Object("z").propertyIsEnumerable(0)}))?function(t){return"String"==v(t)?g.call(t,""):Object(t)}:Object,b=function(t){if(null==t)throw TypeError("Can't call method on "+t);return t},m=function(t){return y(b(t))},x=function(t){return"object"==typeof t?null!==t:"function"==typeof t},E=function(t,e){if(!x(t))return t;var r,n;if(e&&"function"==typeof(r=t.toString)&&!x(n=r.call(t)))return n;if("function"==typeof(r=t.valueOf)&&!x(n=r.call(t)))return n;if(!e&&"function"==typeof(r=t.toString)&&!x(n=r.call(t)))return n;throw TypeError("Can't convert object to primitive value")},w={}.hasOwnProperty,O=function(t,e){return w.call(t,e)},_=a.document,S=x(_)&&x(_.createElement),A=function(t){return S?_.createElement(t):{}},k=!l&&!c((function(){return 7!=Object.defineProperty(A("div"),"a",{get:function(){return 7}}).a})),L=Object.getOwnPropertyDescriptor,M={f:l?L:function(t,e){if(t=m(t),e=E(e,!0),k)try{return L(t,e)}catch(t){}if(O(t,e))return d(!h.f.call(t,e),t[e])}},j=function(t){if(!x(t))throw TypeError(String(t)+" is not an object");return t},T=Object.defineProperty,R={f:l?T:function(t,e,r){if(j(t),e=E(e,!0),j(r),k)try{return T(t,e,r)}catch(t){}if("get"in r||"set"in r)throw TypeError("Accessors not supported");return"value"in r&&(t[e]=r.value),t}},W=l?function(t,e,r){return R.f(t,e,d(1,r))}:function(t,e,r){return t[e]=r,t},z=function(t,e){try{W(a,t,e)}catch(r){a[t]=e}return e},C=e((function(t){var e=a["__core-js_shared__"]||z("__core-js_shared__",{});(t.exports=function(t,r){return e[t]||(e[t]=void 0!==r?r:{})})("versions",[]).push({version:"3.2.1",mode:"global",copyright:"© 2019 Denis Pushkarev (zloirock.ru)"})})),N=C("native-function-to-string",Function.toString),I=a.WeakMap,D="function"==typeof I&&/native code/.test(N.call(I)),P=0,V=Math.random(),F=function(t){return"Symbol("+String(void 0===t?"":t)+")_"+(++P+V).toString(36)},B=C("keys"),H=function(t){return B[t]||(B[t]=F(t))},q={},$=a.WeakMap;if(D){var X=new $,Y=X.get,G=X.has,U=X.set;r=function(t,e){return U.call(X,t,e),e},n=function(t){return Y.call(X,t)||{}},i=function(t){return G.call(X,t)}}else{var Q=H("state");q[Q]=!0,r=function(t,e){return W(t,Q,e),e},n=function(t){return O(t,Q)?t[Q]:{}},i=function(t){return O(t,Q)}}var K={set:r,get:n,has:i,enforce:function(t){return i(t)?n(t):r(t,{})},getterFor:function(t){return function(e){var r;if(!x(e)||(r=n(e)).type!==t)throw TypeError("Incompatible receiver, "+t+" required");return r}}},J=e((function(t){var e=K.get,r=K.enforce,n=String(N).split("toString");C("inspectSource",(function(t){return N.call(t)})),(t.exports=function(t,e,i,o){var s=!!o&&!!o.unsafe,c=!!o&&!!o.enumerable,l=!!o&&!!o.noTargetGet;"function"==typeof i&&("string"!=typeof e||O(i,"name")||W(i,"name",e),r(i).source=n.join("string"==typeof e?e:"")),t!==a?(s?!l&&t[e]&&(c=!0):delete t[e],c?t[e]=i:W(t,e,i)):c?t[e]=i:z(e,i)})(Function.prototype,"toString",(function(){return"function"==typeof this&&e(this).source||N.call(this)}))})),Z=a,tt=function(t){return"function"==typeof t?t:void 0},et=function(t,e){return arguments.length<2?tt(Z[t])||tt(a[t]):Z[t]&&Z[t][e]||a[t]&&a[t][e]},rt=Math.ceil,nt=Math.floor,it=function(t){return isNaN(t=+t)?0:(t>0?nt:rt)(t)},ot=Math.min,st=function(t){return t>0?ot(it(t),9007199254740991):0},at=Math.max,ct=Math.min,lt=function(t){return function(e,r,n){var i,o=m(e),s=st(o.length),a=function(t,e){var r=it(t);return r<0?at(r+e,0):ct(r,e)}(n,s);if(t&&r!=r){for(;s>a;)if((i=o[a++])!=i)return!0}else for(;s>a;a++)if((t||a in o)&&o[a]===r)return t||a||0;return!t&&-1}},ut={includes:lt(!0),indexOf:lt(!1)}.indexOf,ft=function(t,e){var r,n=m(t),i=0,o=[];for(r in n)!O(q,r)&&O(n,r)&&o.push(r);for(;e.length>i;)O(n,r=e[i++])&&(~ut(o,r)||o.push(r));return o},ht=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"],dt=ht.concat("length","prototype"),pt={f:Object.getOwnPropertyNames||function(t){return ft(t,dt)}},vt={f:Object.getOwnPropertySymbols},gt=et("Reflect","ownKeys")||function(t){var e=pt.f(j(t)),r=vt.f;return r?e.concat(r(t)):e},yt=function(t,e){for(var r=gt(e),n=R.f,i=M.f,o=0;o<r.length;o++){var s=r[o];O(t,s)||n(t,s,i(e,s))}},bt=/#|\.prototype\./,mt=function(t,e){var r=Et[xt(t)];return r==Ot||r!=wt&&("function"==typeof e?c(e):!!e)},xt=mt.normalize=function(t){return String(t).replace(bt,".").toLowerCase()},Et=mt.data={},wt=mt.NATIVE="N",Ot=mt.POLYFILL="P",_t=mt,St=M.f,At=function(t,e){var r,n,i,o,s,c=t.target,l=t.global,u=t.stat;if(r=l?a:u?a[c]||z(c,{}):(a[c]||{}).prototype)for(n in e){if(o=e[n],i=t.noTargetGet?(s=St(r,n))&&s.value:r[n],!_t(l?n:c+(u?".":"#")+n,t.forced)&&void 0!==i){if(typeof o==typeof i)continue;yt(o,i)}(t.sham||i&&i.sham)&&W(o,"sham",!0),J(r,n,o,t)}},kt=function(t){if("function"!=typeof t)throw TypeError(String(t)+" is not a function");return t},Lt=function(t,e,r){if(kt(t),void 0===e)return t;switch(r){case 0:return function(){return t.call(e)};case 1:return function(r){return t.call(e,r)};case 2:return function(r,n){return t.call(e,r,n)};case 3:return function(r,n,i){return t.call(e,r,n,i)}}return function(){return t.apply(e,arguments)}},Mt=function(t){return Object(b(t))},jt=Array.isArray||function(t){return"Array"==v(t)},Tt=!!Object.getOwnPropertySymbols&&!c((function(){return!String(Symbol())})),Rt=a.Symbol,Wt=C("wks"),zt=function(t){return Wt[t]||(Wt[t]=Tt&&Rt[t]||(Tt?Rt:F)("Symbol."+t))},Ct=zt("species"),Nt=function(t,e){var r;return jt(t)&&("function"!=typeof(r=t.constructor)||r!==Array&&!jt(r.prototype)?x(r)&&null===(r=r[Ct])&&(r=void 0):r=void 0),new(void 0===r?Array:r)(0===e?0:e)},It=[].push,Dt=function(t){var e=1==t,r=2==t,n=3==t,i=4==t,o=6==t,s=5==t||o;return function(a,c,l,u){for(var f,h,d=Mt(a),p=y(d),v=Lt(c,l,3),g=st(p.length),b=0,m=u||Nt,x=e?m(a,g):r?m(a,0):void 0;g>b;b++)if((s||b in p)&&(h=v(f=p[b],b,d),t))if(e)x[b]=h;else if(h)switch(t){case 3:return!0;case 5:return f;case 6:return b;case 2:It.call(x,f)}else if(i)return!1;return o?-1:n||i?i:x}},Pt={forEach:Dt(0),map:Dt(1),filter:Dt(2),some:Dt(3),every:Dt(4),find:Dt(5),findIndex:Dt(6)},Vt=function(t,e){var r=[][t];return!r||!c((function(){r.call(null,e||function(){throw 1},1)}))},Ft=Pt.forEach,Bt=Vt("forEach")?function(t){return Ft(this,t,arguments.length>1?arguments[1]:void 0)}:[].forEach;At({target:"Array",proto:!0,forced:[].forEach!=Bt},{forEach:Bt});var Ht={CSSRuleList:0,CSSStyleDeclaration:0,CSSValueList:0,ClientRectList:0,DOMRectList:0,DOMStringList:0,DOMTokenList:1,DataTransferItemList:0,FileList:0,HTMLAllCollection:0,HTMLCollection:0,HTMLFormElement:0,HTMLSelectElement:0,MediaList:0,MimeTypeArray:0,NamedNodeMap:0,NodeList:1,PaintRequestList:0,Plugin:0,PluginArray:0,SVGLengthList:0,SVGNumberList:0,SVGPathSegList:0,SVGPointList:0,SVGStringList:0,SVGTransformList:0,SourceBufferList:0,StyleSheetList:0,TextTrackCueList:0,TextTrackList:0,TouchList:0};for(var qt in Ht){var $t=a[qt],Xt=$t&&$t.prototype;if(Xt&&Xt.forEach!==Bt)try{W(Xt,"forEach",Bt)}catch(t){Xt.forEach=Bt}}var Yt=!("undefined"==typeof window||!window.document||!window.document.createElement),Gt=zt("species"),Ut=Pt.filter;At({target:"Array",proto:!0,forced:!function(t){return!c((function(){var e=[];return(e.constructor={})[Gt]=function(){return{foo:1}},1!==e[t](Boolean).foo}))}("filter")},{filter:function(t){return Ut(this,t,arguments.length>1?arguments[1]:void 0)}});var Qt=Object.keys||function(t){return ft(t,ht)},Kt=l?Object.defineProperties:function(t,e){j(t);for(var r,n=Qt(e),i=n.length,o=0;i>o;)R.f(t,r=n[o++],e[r]);return t},Jt=et("document","documentElement"),Zt=H("IE_PROTO"),te=function(){},ee=function(){var t,e=A("iframe"),r=ht.length;for(e.style.display="none",Jt.appendChild(e),e.src=String("javascript:"),(t=e.contentWindow.document).open(),t.write("<script>document.F=Object<\/script>"),t.close(),ee=t.F;r--;)delete ee.prototype[ht[r]];return ee()},re=Object.create||function(t,e){var r;return null!==t?(te.prototype=j(t),r=new te,te.prototype=null,r[Zt]=t):r=ee(),void 0===e?r:Kt(r,e)};q[Zt]=!0;var ne=zt("unscopables"),ie=Array.prototype;null==ie[ne]&&W(ie,ne,re(null));var oe,se,ae,ce=function(t){ie[ne][t]=!0},le={},ue=!c((function(){function t(){}return t.prototype.constructor=null,Object.getPrototypeOf(new t)!==t.prototype})),fe=H("IE_PROTO"),he=Object.prototype,de=ue?Object.getPrototypeOf:function(t){return t=Mt(t),O(t,fe)?t[fe]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?he:null},pe=zt("iterator"),ve=!1;[].keys&&("next"in(ae=[].keys())?(se=de(de(ae)))!==Object.prototype&&(oe=se):ve=!0),null==oe&&(oe={}),O(oe,pe)||W(oe,pe,(function(){return this}));var ge={IteratorPrototype:oe,BUGGY_SAFARI_ITERATORS:ve},ye=R.f,be=zt("toStringTag"),me=function(t,e,r){t&&!O(t=r?t:t.prototype,be)&&ye(t,be,{configurable:!0,value:e})},xe=ge.IteratorPrototype,Ee=function(){return this},we=Object.setPrototypeOf||("__proto__"in{}?function(){var t,e=!1,r={};try{(t=Object.getOwnPropertyDescriptor(Object.prototype,"__proto__").set).call(r,[]),e=r instanceof Array}catch(t){}return function(r,n){return j(r),function(t){if(!x(t)&&null!==t)throw TypeError("Can't set "+String(t)+" as a prototype")}(n),e?t.call(r,n):r.__proto__=n,r}}():void 0),Oe=ge.IteratorPrototype,_e=ge.BUGGY_SAFARI_ITERATORS,Se=zt("iterator"),Ae=function(){return this},ke=function(t,e,r,n,i,o,s){!function(t,e,r){var n=e+" Iterator";t.prototype=re(xe,{next:d(1,r)}),me(t,n,!1),le[n]=Ee}(r,e,n);var a,c,l,u=function(t){if(t===i&&g)return g;if(!_e&&t in p)return p[t];switch(t){case"keys":case"values":case"entries":return function(){return new r(this,t)}}return function(){return new r(this)}},f=e+" Iterator",h=!1,p=t.prototype,v=p[Se]||p["@@iterator"]||i&&p[i],g=!_e&&v||u(i),y="Array"==e&&p.entries||v;if(y&&(a=de(y.call(new t)),Oe!==Object.prototype&&a.next&&(de(a)!==Oe&&(we?we(a,Oe):"function"!=typeof a[Se]&&W(a,Se,Ae)),me(a,f,!0))),"values"==i&&v&&"values"!==v.name&&(h=!0,g=function(){return v.call(this)}),p[Se]!==g&&W(p,Se,g),le[e]=g,i)if(c={values:u("values"),keys:o?g:u("keys"),entries:u("entries")},s)for(l in c)!_e&&!h&&l in p||J(p,l,c[l]);else At({target:e,proto:!0,forced:_e||h},c);return c},Le=K.set,Me=K.getterFor("Array Iterator"),je=ke(Array,"Array",(function(t,e){Le(this,{type:"Array Iterator",target:m(t),index:0,kind:e})}),(function(){var t=Me(this),e=t.target,r=t.kind,n=t.index++;return!e||n>=e.length?(t.target=void 0,{value:void 0,done:!0}):"keys"==r?{value:n,done:!1}:"values"==r?{value:e[n],done:!1}:{value:[n,e[n]],done:!1}}),"values");le.Arguments=le.Array,ce("keys"),ce("values"),ce("entries");var Te=Object.assign,Re=!Te||c((function(){var t={},e={},r=Symbol();return t[r]=7,"abcdefghijklmnopqrst".split("").forEach((function(t){e[t]=t})),7!=Te({},t)[r]||"abcdefghijklmnopqrst"!=Qt(Te({},e)).join("")}))?function(t,e){for(var r=Mt(t),n=arguments.length,i=1,o=vt.f,s=h.f;n>i;)for(var a,c=y(arguments[i++]),u=o?Qt(c).concat(o(c)):Qt(c),f=u.length,d=0;f>d;)a=u[d++],l&&!s.call(c,a)||(r[a]=c[a]);return r}:Te;At({target:"Object",stat:!0,forced:Object.assign!==Re},{assign:Re});var We=zt("toStringTag"),ze="Arguments"==v(function(){return arguments}()),Ce=function(t){var e,r,n;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(r=function(t,e){try{return t[e]}catch(t){}}(e=Object(t),We))?r:ze?v(e):"Object"==(n=v(e))&&"function"==typeof e.callee?"Arguments":n},Ne={};Ne[zt("toStringTag")]="z";var Ie="[object z]"!==String(Ne)?function(){return"[object "+Ce(this)+"]"}:Ne.toString,De=Object.prototype;Ie!==De.toString&&J(De,"toString",Ie,{unsafe:!0});var Pe="\t\n\v\f\r                　\u2028\u2029\ufeff",Ve="["+Pe+"]",Fe=RegExp("^"+Ve+Ve+"*"),Be=RegExp(Ve+Ve+"*$"),He=function(t){return function(e){var r=String(b(e));return 1&t&&(r=r.replace(Fe,"")),2&t&&(r=r.replace(Be,"")),r}},qe={start:He(1),end:He(2),trim:He(3)}.trim,$e=a.parseInt,Xe=/^[+-]?0[Xx]/,Ye=8!==$e(Pe+"08")||22!==$e(Pe+"0x16")?function(t,e){var r=qe(String(t));return $e(r,e>>>0||(Xe.test(r)?16:10))}:$e;At({global:!0,forced:parseInt!=Ye},{parseInt:Ye});var Ge=function(t){return function(e,r){var n,i,o=String(b(e)),s=it(r),a=o.length;return s<0||s>=a?t?"":void 0:(n=o.charCodeAt(s))<55296||n>56319||s+1===a||(i=o.charCodeAt(s+1))<56320||i>57343?t?o.charAt(s):n:t?o.slice(s,s+2):i-56320+(n-55296<<10)+65536}},Ue={codeAt:Ge(!1),charAt:Ge(!0)},Qe=Ue.charAt,Ke=K.set,Je=K.getterFor("String Iterator");ke(String,"String",(function(t){Ke(this,{type:"String Iterator",string:String(t),index:0})}),(function(){var t,e=Je(this),r=e.string,n=e.index;return n>=r.length?{value:void 0,done:!0}:(t=Qe(r,n),e.index+=t.length,{value:t,done:!1})}));var Ze=function(t,e,r){for(var n in e)J(t,n,e[n],r);return t},tr=!c((function(){return Object.isExtensible(Object.preventExtensions({}))})),er=e((function(t){var e=R.f,r=F("meta"),n=0,i=Object.isExtensible||function(){return!0},o=function(t){e(t,r,{value:{objectID:"O"+ ++n,weakData:{}}})},s=t.exports={REQUIRED:!1,fastKey:function(t,e){if(!x(t))return"symbol"==typeof t?t:("string"==typeof t?"S":"P")+t;if(!O(t,r)){if(!i(t))return"F";if(!e)return"E";o(t)}return t[r].objectID},getWeakData:function(t,e){if(!O(t,r)){if(!i(t))return!0;if(!e)return!1;o(t)}return t[r].weakData},onFreeze:function(t){return tr&&s.REQUIRED&&i(t)&&!O(t,r)&&o(t),t}};q[r]=!0})),rr=(er.REQUIRED,er.fastKey,er.getWeakData,er.onFreeze,zt("iterator")),nr=Array.prototype,ir=zt("iterator"),or=function(t,e,r,n){try{return n?e(j(r)[0],r[1]):e(r)}catch(e){var i=t.return;throw void 0!==i&&j(i.call(t)),e}},sr=e((function(t){var e=function(t,e){this.stopped=t,this.result=e};(t.exports=function(t,r,n,i,o){var s,a,c,l,u,f,h,d=Lt(r,n,i?2:1);if(o)s=t;else{if("function"!=typeof(a=function(t){if(null!=t)return t[ir]||t["@@iterator"]||le[Ce(t)]}(t)))throw TypeError("Target is not iterable");if(void 0!==(h=a)&&(le.Array===h||nr[rr]===h)){for(c=0,l=st(t.length);l>c;c++)if((u=i?d(j(f=t[c])[0],f[1]):d(t[c]))&&u instanceof e)return u;return new e(!1)}s=a.call(t)}for(;!(f=s.next()).done;)if((u=or(s,d,f.value,i))&&u instanceof e)return u;return new e(!1)}).stop=function(t){return new e(!0,t)}})),ar=function(t,e,r){if(!(t instanceof e))throw TypeError("Incorrect "+(r?r+" ":"")+"invocation");return t},cr=zt("iterator"),lr=!1;try{var ur=0,fr={next:function(){return{done:!!ur++}},return:function(){lr=!0}};fr[cr]=function(){return this},Array.from(fr,(function(){throw 2}))}catch(t){}var hr=function(t,e,r,n,i){var o=a[t],s=o&&o.prototype,l=o,u=n?"set":"add",f={},h=function(t){var e=s[t];J(s,t,"add"==t?function(t){return e.call(this,0===t?0:t),this}:"delete"==t?function(t){return!(i&&!x(t))&&e.call(this,0===t?0:t)}:"get"==t?function(t){return i&&!x(t)?void 0:e.call(this,0===t?0:t)}:"has"==t?function(t){return!(i&&!x(t))&&e.call(this,0===t?0:t)}:function(t,r){return e.call(this,0===t?0:t,r),this})};if(_t(t,"function"!=typeof o||!(i||s.forEach&&!c((function(){(new o).entries().next()})))))l=r.getConstructor(e,t,n,u),er.REQUIRED=!0;else if(_t(t,!0)){var d=new l,p=d[u](i?{}:-0,1)!=d,v=c((function(){d.has(1)})),g=function(t,e){if(!e&&!lr)return!1;var r=!1;try{var n={};n[cr]=function(){return{next:function(){return{done:r=!0}}}},t(n)}catch(t){}return r}((function(t){new o(t)})),y=!i&&c((function(){for(var t=new o,e=5;e--;)t[u](e,e);return!t.has(-0)}));g||((l=e((function(e,r){ar(e,l,t);var i=function(t,e,r){var n,i;return we&&"function"==typeof(n=e.constructor)&&n!==r&&x(i=n.prototype)&&i!==r.prototype&&we(t,i),t}(new o,e,l);return null!=r&&sr(r,i[u],i,n),i}))).prototype=s,s.constructor=l),(v||y)&&(h("delete"),h("has"),n&&h("get")),(y||p)&&h(u),i&&s.clear&&delete s.clear}return f[t]=l,At({global:!0,forced:l!=o},f),me(l,t),i||r.setStrong(l,t,n),l},dr=er.getWeakData,pr=K.set,vr=K.getterFor,gr=Pt.find,yr=Pt.findIndex,br=0,mr=function(t){return t.frozen||(t.frozen=new xr)},xr=function(){this.entries=[]},Er=function(t,e){return gr(t.entries,(function(t){return t[0]===e}))};xr.prototype={get:function(t){var e=Er(this,t);if(e)return e[1]},has:function(t){return!!Er(this,t)},set:function(t,e){var r=Er(this,t);r?r[1]=e:this.entries.push([t,e])},delete:function(t){var e=yr(this.entries,(function(e){return e[0]===t}));return~e&&this.entries.splice(e,1),!!~e}};var wr={getConstructor:function(t,e,r,n){var i=t((function(t,o){ar(t,i,e),pr(t,{type:e,id:br++,frozen:void 0}),null!=o&&sr(o,t[n],t,r)})),o=vr(e),s=function(t,e,r){var n=o(t),i=dr(j(e),!0);return!0===i?mr(n).set(e,r):i[n.id]=r,t};return Ze(i.prototype,{delete:function(t){var e=o(this);if(!x(t))return!1;var r=dr(t);return!0===r?mr(e).delete(t):r&&O(r,e.id)&&delete r[e.id]},has:function(t){var e=o(this);if(!x(t))return!1;var r=dr(t);return!0===r?mr(e).has(t):r&&O(r,e.id)}}),Ze(i.prototype,r?{get:function(t){var e=o(this);if(x(t)){var r=dr(t);return!0===r?mr(e).get(t):r?r[e.id]:void 0}},set:function(t,e){return s(this,t,e)}}:{add:function(t){return s(this,t,!0)}}),i}},Or=(e((function(t){var e,r=K.enforce,n=!a.ActiveXObject&&"ActiveXObject"in a,i=Object.isExtensible,o=function(t){return function(){return t(this,arguments.length?arguments[0]:void 0)}},s=t.exports=hr("WeakMap",o,wr,!0,!0);if(D&&n){e=wr.getConstructor(o,"WeakMap",!0),er.REQUIRED=!0;var c=s.prototype,l=c.delete,u=c.has,f=c.get,h=c.set;Ze(c,{delete:function(t){if(x(t)&&!i(t)){var n=r(this);return n.frozen||(n.frozen=new e),l.call(this,t)||n.frozen.delete(t)}return l.call(this,t)},has:function(t){if(x(t)&&!i(t)){var n=r(this);return n.frozen||(n.frozen=new e),u.call(this,t)||n.frozen.has(t)}return u.call(this,t)},get:function(t){if(x(t)&&!i(t)){var n=r(this);return n.frozen||(n.frozen=new e),u.call(this,t)?f.call(this,t):n.frozen.get(t)}return f.call(this,t)},set:function(t,n){if(x(t)&&!i(t)){var o=r(this);o.frozen||(o.frozen=new e),u.call(this,t)?h.call(this,t,n):o.frozen.set(t,n)}else h.call(this,t,n);return this}})}})),zt("iterator")),_r=zt("toStringTag"),Sr=je.values;for(var Ar in Ht){var kr=a[Ar],Lr=kr&&kr.prototype;if(Lr){if(Lr[Or]!==Sr)try{W(Lr,Or,Sr)}catch(t){Lr[Or]=Sr}if(Lr[_r]||W(Lr,_r,Ar),Ht[Ar])for(var Mr in je)if(Lr[Mr]!==je[Mr])try{W(Lr,Mr,je[Mr])}catch(t){Lr[Mr]=je[Mr]}}}var jr="Expected a function",Tr=NaN,Rr="[object Symbol]",Wr=/^\s+|\s+$/g,zr=/^[-+]0x[0-9a-f]+$/i,Cr=/^0b[01]+$/i,Nr=/^0o[0-7]+$/i,Ir=parseInt,Dr="object"==typeof t&&t&&t.Object===Object&&t,Pr="object"==typeof self&&self&&self.Object===Object&&self,Vr=Dr||Pr||Function("return this")(),Fr=Object.prototype.toString,Br=Math.max,Hr=Math.min,qr=function(){return Vr.Date.now()};function $r(t,e,r){var n,i,o,s,a,c,l=0,u=!1,f=!1,h=!0;if("function"!=typeof t)throw new TypeError(jr);function d(e){var r=n,o=i;return n=i=void 0,l=e,s=t.apply(o,r)}function p(t){var r=t-c;return void 0===c||r>=e||r<0||f&&t-l>=o}function v(){var t=qr();if(p(t))return g(t);a=setTimeout(v,function(t){var r=e-(t-c);return f?Hr(r,o-(t-l)):r}(t))}function g(t){return a=void 0,h&&n?d(t):(n=i=void 0,s)}function y(){var t=qr(),r=p(t);if(n=arguments,i=this,c=t,r){if(void 0===a)return function(t){return l=t,a=setTimeout(v,e),u?d(t):s}(c);if(f)return a=setTimeout(v,e),d(c)}return void 0===a&&(a=setTimeout(v,e)),s}return e=Yr(e)||0,Xr(r)&&(u=!!r.leading,o=(f="maxWait"in r)?Br(Yr(r.maxWait)||0,e):o,h="trailing"in r?!!r.trailing:h),y.cancel=function(){void 0!==a&&clearTimeout(a),l=0,n=c=i=a=void 0},y.flush=function(){return void 0===a?s:g(qr())},y}function Xr(t){var e=typeof t;return!!t&&("object"==e||"function"==e)}function Yr(t){if("number"==typeof t)return t;if(function(t){return"symbol"==typeof t||function(t){return!!t&&"object"==typeof t}(t)&&Fr.call(t)==Rr}(t))return Tr;if(Xr(t)){var e="function"==typeof t.valueOf?t.valueOf():t;t=Xr(e)?e+"":e}if("string"!=typeof t)return 0===t?t:+t;t=t.replace(Wr,"");var r=Cr.test(t);return r||Nr.test(t)?Ir(t.slice(2),r?2:8):zr.test(t)?Tr:+t}var Gr=function(t,e,r){var n=!0,i=!0;if("function"!=typeof t)throw new TypeError(jr);return Xr(r)&&(n="leading"in r?!!r.leading:n,i="trailing"in r?!!r.trailing:i),$r(t,e,{leading:n,maxWait:e,trailing:i})},Ur="Expected a function",Qr=NaN,Kr="[object Symbol]",Jr=/^\s+|\s+$/g,Zr=/^[-+]0x[0-9a-f]+$/i,tn=/^0b[01]+$/i,en=/^0o[0-7]+$/i,rn=parseInt,nn="object"==typeof t&&t&&t.Object===Object&&t,on="object"==typeof self&&self&&self.Object===Object&&self,sn=nn||on||Function("return this")(),an=Object.prototype.toString,cn=Math.max,ln=Math.min,un=function(){return sn.Date.now()};function fn(t){var e=typeof t;return!!t&&("object"==e||"function"==e)}function hn(t){if("number"==typeof t)return t;if(function(t){return"symbol"==typeof t||function(t){return!!t&&"object"==typeof t}(t)&&an.call(t)==Kr}(t))return Qr;if(fn(t)){var e="function"==typeof t.valueOf?t.valueOf():t;t=fn(e)?e+"":e}if("string"!=typeof t)return 0===t?t:+t;t=t.replace(Jr,"");var r=tn.test(t);return r||en.test(t)?rn(t.slice(2),r?2:8):Zr.test(t)?Qr:+t}var dn=function(t,e,r){var n,i,o,s,a,c,l=0,u=!1,f=!1,h=!0;if("function"!=typeof t)throw new TypeError(Ur);function d(e){var r=n,o=i;return n=i=void 0,l=e,s=t.apply(o,r)}function p(t){var r=t-c;return void 0===c||r>=e||r<0||f&&t-l>=o}function v(){var t=un();if(p(t))return g(t);a=setTimeout(v,function(t){var r=e-(t-c);return f?ln(r,o-(t-l)):r}(t))}function g(t){return a=void 0,h&&n?d(t):(n=i=void 0,s)}function y(){var t=un(),r=p(t);if(n=arguments,i=this,c=t,r){if(void 0===a)return function(t){return l=t,a=setTimeout(v,e),u?d(t):s}(c);if(f)return a=setTimeout(v,e),d(c)}return void 0===a&&(a=setTimeout(v,e)),s}return e=hn(e)||0,fn(r)&&(u=!!r.leading,o=(f="maxWait"in r)?cn(hn(r.maxWait)||0,e):o,h="trailing"in r?!!r.trailing:h),y.cancel=function(){void 0!==a&&clearTimeout(a),l=0,n=c=i=a=void 0},y.flush=function(){return void 0===a?s:g(un())},y},pn="Expected a function",vn="__lodash_hash_undefined__",gn="[object Function]",yn="[object GeneratorFunction]",bn=/^\[object .+?Constructor\]$/,mn="object"==typeof t&&t&&t.Object===Object&&t,xn="object"==typeof self&&self&&self.Object===Object&&self,En=mn||xn||Function("return this")();var wn=Array.prototype,On=Function.prototype,_n=Object.prototype,Sn=En["__core-js_shared__"],An=function(){var t=/[^.]+$/.exec(Sn&&Sn.keys&&Sn.keys.IE_PROTO||"");return t?"Symbol(src)_1."+t:""}(),kn=On.toString,Ln=_n.hasOwnProperty,Mn=_n.toString,jn=RegExp("^"+kn.call(Ln).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),Tn=wn.splice,Rn=Vn(En,"Map"),Wn=Vn(Object,"create");function zn(t){var e=-1,r=t?t.length:0;for(this.clear();++e<r;){var n=t[e];this.set(n[0],n[1])}}function Cn(t){var e=-1,r=t?t.length:0;for(this.clear();++e<r;){var n=t[e];this.set(n[0],n[1])}}function Nn(t){var e=-1,r=t?t.length:0;for(this.clear();++e<r;){var n=t[e];this.set(n[0],n[1])}}function In(t,e){for(var r,n,i=t.length;i--;)if((r=t[i][0])===(n=e)||r!=r&&n!=n)return i;return-1}function Dn(t){return!(!Bn(t)||(e=t,An&&An in e))&&(function(t){var e=Bn(t)?Mn.call(t):"";return e==gn||e==yn}(t)||function(t){var e=!1;if(null!=t&&"function"!=typeof t.toString)try{e=!!(t+"")}catch(t){}return e}(t)?jn:bn).test(function(t){if(null!=t){try{return kn.call(t)}catch(t){}try{return t+""}catch(t){}}return""}(t));var e}function Pn(t,e){var r,n,i=t.__data__;return("string"==(n=typeof(r=e))||"number"==n||"symbol"==n||"boolean"==n?"__proto__"!==r:null===r)?i["string"==typeof e?"string":"hash"]:i.map}function Vn(t,e){var r=function(t,e){return null==t?void 0:t[e]}(t,e);return Dn(r)?r:void 0}function Fn(t,e){if("function"!=typeof t||e&&"function"!=typeof e)throw new TypeError(pn);var r=function(){var n=arguments,i=e?e.apply(this,n):n[0],o=r.cache;if(o.has(i))return o.get(i);var s=t.apply(this,n);return r.cache=o.set(i,s),s};return r.cache=new(Fn.Cache||Nn),r}function Bn(t){var e=typeof t;return!!t&&("object"==e||"function"==e)}zn.prototype.clear=function(){this.__data__=Wn?Wn(null):{}},zn.prototype.delete=function(t){return this.has(t)&&delete this.__data__[t]},zn.prototype.get=function(t){var e=this.__data__;if(Wn){var r=e[t];return r===vn?void 0:r}return Ln.call(e,t)?e[t]:void 0},zn.prototype.has=function(t){var e=this.__data__;return Wn?void 0!==e[t]:Ln.call(e,t)},zn.prototype.set=function(t,e){return this.__data__[t]=Wn&&void 0===e?vn:e,this},Cn.prototype.clear=function(){this.__data__=[]},Cn.prototype.delete=function(t){var e=this.__data__,r=In(e,t);return!(r<0)&&(r==e.length-1?e.pop():Tn.call(e,r,1),!0)},Cn.prototype.get=function(t){var e=this.__data__,r=In(e,t);return r<0?void 0:e[r][1]},Cn.prototype.has=function(t){return In(this.__data__,t)>-1},Cn.prototype.set=function(t,e){var r=this.__data__,n=In(r,t);return n<0?r.push([t,e]):r[n][1]=e,this},Nn.prototype.clear=function(){this.__data__={hash:new zn,map:new(Rn||Cn),string:new zn}},Nn.prototype.delete=function(t){return Pn(this,t).delete(t)},Nn.prototype.get=function(t){return Pn(this,t).get(t)},Nn.prototype.has=function(t){return Pn(this,t).has(t)},Nn.prototype.set=function(t,e){return Pn(this,t).set(t,e),this},Fn.Cache=Nn;var Hn=Fn,qn=function(){if("undefined"!=typeof Map)return Map;function t(t,e){var r=-1;return t.some((function(t,n){return t[0]===e&&(r=n,!0)})),r}return function(){function e(){this.__entries__=[]}return Object.defineProperty(e.prototype,"size",{get:function(){return this.__entries__.length},enumerable:!0,configurable:!0}),e.prototype.get=function(e){var r=t(this.__entries__,e),n=this.__entries__[r];return n&&n[1]},e.prototype.set=function(e,r){var n=t(this.__entries__,e);~n?this.__entries__[n][1]=r:this.__entries__.push([e,r])},e.prototype.delete=function(e){var r=this.__entries__,n=t(r,e);~n&&r.splice(n,1)},e.prototype.has=function(e){return!!~t(this.__entries__,e)},e.prototype.clear=function(){this.__entries__.splice(0)},e.prototype.forEach=function(t,e){void 0===e&&(e=null);for(var r=0,n=this.__entries__;r<n.length;r++){var i=n[r];t.call(e,i[1],i[0])}},e}()}(),$n="undefined"!=typeof window&&"undefined"!=typeof document&&window.document===document,Xn="undefined"!=typeof global&&global.Math===Math?global:"undefined"!=typeof self&&self.Math===Math?self:"undefined"!=typeof window&&window.Math===Math?window:Function("return this")(),Yn="function"==typeof requestAnimationFrame?requestAnimationFrame.bind(Xn):function(t){return setTimeout((function(){return t(Date.now())}),1e3/60)},Gn=2;var Un=20,Qn=["top","right","bottom","left","width","height","size","weight"],Kn="undefined"!=typeof MutationObserver,Jn=function(){function t(){this.connected_=!1,this.mutationEventsAdded_=!1,this.mutationsObserver_=null,this.observers_=[],this.onTransitionEnd_=this.onTransitionEnd_.bind(this),this.refresh=function(t,e){var r=!1,n=!1,i=0;function o(){r&&(r=!1,t()),n&&a()}function s(){Yn(o)}function a(){var t=Date.now();if(r){if(t-i<Gn)return;n=!0}else r=!0,n=!1,setTimeout(s,e);i=t}return a}(this.refresh.bind(this),Un)}return t.prototype.addObserver=function(t){~this.observers_.indexOf(t)||this.observers_.push(t),this.connected_||this.connect_()},t.prototype.removeObserver=function(t){var e=this.observers_,r=e.indexOf(t);~r&&e.splice(r,1),!e.length&&this.connected_&&this.disconnect_()},t.prototype.refresh=function(){this.updateObservers_()&&this.refresh()},t.prototype.updateObservers_=function(){var t=this.observers_.filter((function(t){return t.gatherActive(),t.hasActive()}));return t.forEach((function(t){return t.broadcastActive()})),t.length>0},t.prototype.connect_=function(){$n&&!this.connected_&&(document.addEventListener("transitionend",this.onTransitionEnd_),window.addEventListener("resize",this.refresh),Kn?(this.mutationsObserver_=new MutationObserver(this.refresh),this.mutationsObserver_.observe(document,{attributes:!0,childList:!0,characterData:!0,subtree:!0})):(document.addEventListener("DOMSubtreeModified",this.refresh),this.mutationEventsAdded_=!0),this.connected_=!0)},t.prototype.disconnect_=function(){$n&&this.connected_&&(document.removeEventListener("transitionend",this.onTransitionEnd_),window.removeEventListener("resize",this.refresh),this.mutationsObserver_&&this.mutationsObserver_.disconnect(),this.mutationEventsAdded_&&document.removeEventListener("DOMSubtreeModified",this.refresh),this.mutationsObserver_=null,this.mutationEventsAdded_=!1,this.connected_=!1)},t.prototype.onTransitionEnd_=function(t){var e=t.propertyName,r=void 0===e?"":e;Qn.some((function(t){return!!~r.indexOf(t)}))&&this.refresh()},t.getInstance=function(){return this.instance_||(this.instance_=new t),this.instance_},t.instance_=null,t}(),Zn=function(t,e){for(var r=0,n=Object.keys(e);r<n.length;r++){var i=n[r];Object.defineProperty(t,i,{value:e[i],enumerable:!1,writable:!1,configurable:!0})}return t},ti=function(t){return t&&t.ownerDocument&&t.ownerDocument.defaultView||Xn},ei=ai(0,0,0,0);function ri(t){return parseFloat(t)||0}function ni(t){for(var e=[],r=1;r<arguments.length;r++)e[r-1]=arguments[r];return e.reduce((function(e,r){return e+ri(t["border-"+r+"-width"])}),0)}function ii(t){var e=t.clientWidth,r=t.clientHeight;if(!e&&!r)return ei;var n=ti(t).getComputedStyle(t),i=function(t){for(var e={},r=0,n=["top","right","bottom","left"];r<n.length;r++){var i=n[r],o=t["padding-"+i];e[i]=ri(o)}return e}(n),o=i.left+i.right,s=i.top+i.bottom,a=ri(n.width),c=ri(n.height);if("border-box"===n.boxSizing&&(Math.round(a+o)!==e&&(a-=ni(n,"left","right")+o),Math.round(c+s)!==r&&(c-=ni(n,"top","bottom")+s)),!function(t){return t===ti(t).document.documentElement}(t)){var l=Math.round(a+o)-e,u=Math.round(c+s)-r;1!==Math.abs(l)&&(a-=l),1!==Math.abs(u)&&(c-=u)}return ai(i.left,i.top,a,c)}var oi="undefined"!=typeof SVGGraphicsElement?function(t){return t instanceof ti(t).SVGGraphicsElement}:function(t){return t instanceof ti(t).SVGElement&&"function"==typeof t.getBBox};function si(t){return $n?oi(t)?function(t){var e=t.getBBox();return ai(0,0,e.width,e.height)}(t):ii(t):ei}function ai(t,e,r,n){return{x:t,y:e,width:r,height:n}}var ci=function(){function t(t){this.broadcastWidth=0,this.broadcastHeight=0,this.contentRect_=ai(0,0,0,0),this.target=t}return t.prototype.isActive=function(){var t=si(this.target);return this.contentRect_=t,t.width!==this.broadcastWidth||t.height!==this.broadcastHeight},t.prototype.broadcastRect=function(){var t=this.contentRect_;return this.broadcastWidth=t.width,this.broadcastHeight=t.height,t},t}(),li=function(t,e){var r,n,i,o,s,a,c,l=(n=(r=e).x,i=r.y,o=r.width,s=r.height,a="undefined"!=typeof DOMRectReadOnly?DOMRectReadOnly:Object,c=Object.create(a.prototype),Zn(c,{x:n,y:i,width:o,height:s,top:i,right:n+o,bottom:s+i,left:n}),c);Zn(this,{target:t,contentRect:l})},ui=function(){function t(t,e,r){if(this.activeObservations_=[],this.observations_=new qn,"function"!=typeof t)throw new TypeError("The callback provided as parameter 1 is not a function.");this.callback_=t,this.controller_=e,this.callbackCtx_=r}return t.prototype.observe=function(t){if(!arguments.length)throw new TypeError("1 argument required, but only 0 present.");if("undefined"!=typeof Element&&Element instanceof Object){if(!(t instanceof ti(t).Element))throw new TypeError('parameter 1 is not of type "Element".');var e=this.observations_;e.has(t)||(e.set(t,new ci(t)),this.controller_.addObserver(this),this.controller_.refresh())}},t.prototype.unobserve=function(t){if(!arguments.length)throw new TypeError("1 argument required, but only 0 present.");if("undefined"!=typeof Element&&Element instanceof Object){if(!(t instanceof ti(t).Element))throw new TypeError('parameter 1 is not of type "Element".');var e=this.observations_;e.has(t)&&(e.delete(t),e.size||this.controller_.removeObserver(this))}},t.prototype.disconnect=function(){this.clearActive(),this.observations_.clear(),this.controller_.removeObserver(this)},t.prototype.gatherActive=function(){var t=this;this.clearActive(),this.observations_.forEach((function(e){e.isActive()&&t.activeObservations_.push(e)}))},t.prototype.broadcastActive=function(){if(this.hasActive()){var t=this.callbackCtx_,e=this.activeObservations_.map((function(t){return new li(t.target,t.broadcastRect())}));this.callback_.call(t,e,t),this.clearActive()}},t.prototype.clearActive=function(){this.activeObservations_.splice(0)},t.prototype.hasActive=function(){return this.activeObservations_.length>0},t}(),fi="undefined"!=typeof WeakMap?new WeakMap:new qn,hi=function t(e){if(!(this instanceof t))throw new TypeError("Cannot call a class as a function.");if(!arguments.length)throw new TypeError("1 argument required, but only 0 present.");var r=Jn.getInstance(),n=new ui(e,r,this);fi.set(this,n)};["observe","unobserve","disconnect"].forEach((function(t){hi.prototype[t]=function(){var e;return(e=fi.get(this))[t].apply(e,arguments)}}));var di=void 0!==Xn.ResizeObserver?Xn.ResizeObserver:hi,pi=null,vi=null;Yt&&window.addEventListener("resize",(function(){vi!==window.devicePixelRatio&&(vi=window.devicePixelRatio,pi=null)}));var gi=function(){function t(e,r){var n=this;this.onScroll=function(){n.scrollXTicking||(window.requestAnimationFrame(n.scrollX),n.scrollXTicking=!0),n.scrollYTicking||(window.requestAnimationFrame(n.scrollY),n.scrollYTicking=!0)},this.scrollX=function(){n.axis.x.isOverflowing&&(n.showScrollbar("x"),n.positionScrollbar("x")),n.scrollXTicking=!1},this.scrollY=function(){n.axis.y.isOverflowing&&(n.showScrollbar("y"),n.positionScrollbar("y")),n.scrollYTicking=!1},this.onMouseEnter=function(){n.showScrollbar("x"),n.showScrollbar("y")},this.onMouseMove=function(t){n.mouseX=t.clientX,n.mouseY=t.clientY,(n.axis.x.isOverflowing||n.axis.x.forceVisible)&&n.onMouseMoveForAxis("x"),(n.axis.y.isOverflowing||n.axis.y.forceVisible)&&n.onMouseMoveForAxis("y")},this.onMouseLeave=function(){n.onMouseMove.cancel(),(n.axis.x.isOverflowing||n.axis.x.forceVisible)&&n.onMouseLeaveForAxis("x"),(n.axis.y.isOverflowing||n.axis.y.forceVisible)&&n.onMouseLeaveForAxis("y"),n.mouseX=-1,n.mouseY=-1},this.onWindowResize=function(){n.scrollbarWidth=n.getScrollbarWidth(),n.hideNativeScrollbar()},this.hideScrollbars=function(){n.axis.x.track.rect=n.axis.x.track.el.getBoundingClientRect(),n.axis.y.track.rect=n.axis.y.track.el.getBoundingClientRect(),n.isWithinBounds(n.axis.y.track.rect)||(n.axis.y.scrollbar.el.classList.remove(n.classNames.visible),n.axis.y.isVisible=!1),n.isWithinBounds(n.axis.x.track.rect)||(n.axis.x.scrollbar.el.classList.remove(n.classNames.visible),n.axis.x.isVisible=!1)},this.onPointerEvent=function(t){var e,r;n.axis.x.track.rect=n.axis.x.track.el.getBoundingClientRect(),n.axis.y.track.rect=n.axis.y.track.el.getBoundingClientRect(),(n.axis.x.isOverflowing||n.axis.x.forceVisible)&&(e=n.isWithinBounds(n.axis.x.track.rect)),(n.axis.y.isOverflowing||n.axis.y.forceVisible)&&(r=n.isWithinBounds(n.axis.y.track.rect)),(e||r)&&(t.preventDefault(),t.stopPropagation(),"mousedown"===t.type&&(e&&(n.axis.x.scrollbar.rect=n.axis.x.scrollbar.el.getBoundingClientRect(),n.isWithinBounds(n.axis.x.scrollbar.rect)?n.onDragStart(t,"x"):n.onTrackClick(t,"x")),r&&(n.axis.y.scrollbar.rect=n.axis.y.scrollbar.el.getBoundingClientRect(),n.isWithinBounds(n.axis.y.scrollbar.rect)?n.onDragStart(t,"y"):n.onTrackClick(t,"y"))))},this.drag=function(e){var r=n.axis[n.draggedAxis].track,i=r.rect[n.axis[n.draggedAxis].sizeAttr],o=n.axis[n.draggedAxis].scrollbar,s=n.contentWrapperEl[n.axis[n.draggedAxis].scrollSizeAttr],a=parseInt(n.elStyles[n.axis[n.draggedAxis].sizeAttr],10);e.preventDefault(),e.stopPropagation();var c=(("y"===n.draggedAxis?e.pageY:e.pageX)-r.rect[n.axis[n.draggedAxis].offsetAttr]-n.axis[n.draggedAxis].dragOffset)/(i-o.size)*(s-a);"x"===n.draggedAxis&&(c=n.isRtl&&t.getRtlHelpers().isRtlScrollbarInverted?c-(i+o.size):c,c=n.isRtl&&t.getRtlHelpers().isRtlScrollingInverted?-c:c),n.contentWrapperEl[n.axis[n.draggedAxis].scrollOffsetAttr]=c},this.onEndDrag=function(t){t.preventDefault(),t.stopPropagation(),n.el.classList.remove(n.classNames.dragging),document.removeEventListener("mousemove",n.drag,!0),document.removeEventListener("mouseup",n.onEndDrag,!0),n.removePreventClickId=window.setTimeout((function(){document.removeEventListener("click",n.preventClick,!0),document.removeEventListener("dblclick",n.preventClick,!0),n.removePreventClickId=null}))},this.preventClick=function(t){t.preventDefault(),t.stopPropagation()},this.el=e,this.minScrollbarWidth=20,this.options=Object.assign({},t.defaultOptions,{},r),this.classNames=Object.assign({},t.defaultOptions.classNames,{},this.options.classNames),this.axis={x:{scrollOffsetAttr:"scrollLeft",sizeAttr:"width",scrollSizeAttr:"scrollWidth",offsetSizeAttr:"offsetWidth",offsetAttr:"left",overflowAttr:"overflowX",dragOffset:0,isOverflowing:!0,isVisible:!1,forceVisible:!1,track:{},scrollbar:{}},y:{scrollOffsetAttr:"scrollTop",sizeAttr:"height",scrollSizeAttr:"scrollHeight",offsetSizeAttr:"offsetHeight",offsetAttr:"top",overflowAttr:"overflowY",dragOffset:0,isOverflowing:!0,isVisible:!1,forceVisible:!1,track:{},scrollbar:{}}},this.removePreventClickId=null,t.instances.has(this.el)||(this.recalculate=Gr(this.recalculate.bind(this),64),this.onMouseMove=Gr(this.onMouseMove.bind(this),64),this.hideScrollbars=dn(this.hideScrollbars.bind(this),this.options.timeout),this.onWindowResize=dn(this.onWindowResize.bind(this),64,{leading:!0}),t.getRtlHelpers=Hn(t.getRtlHelpers),this.init())}t.getRtlHelpers=function(){var e=document.createElement("div");e.innerHTML='<div class="hs-dummy-scrollbar-size"><div style="height: 200%; width: 200%; margin: 10px 0;"></div></div>';var r=e.firstElementChild;document.body.appendChild(r);var n=r.firstElementChild;r.scrollLeft=0;var i=t.getOffset(r),o=t.getOffset(n);r.scrollLeft=999;var s=t.getOffset(n);return{isRtlScrollingInverted:i.left!==o.left&&o.left-s.left!=0,isRtlScrollbarInverted:i.left!==o.left}},t.getOffset=function(t){var e=t.getBoundingClientRect();return{top:e.top+(window.pageYOffset||document.documentElement.scrollTop),left:e.left+(window.pageXOffset||document.documentElement.scrollLeft)}};var e=t.prototype;return e.init=function(){t.instances.set(this.el,this),Yt&&(this.initDOM(),this.scrollbarWidth=this.getScrollbarWidth(),this.recalculate(),this.initListeners())},e.initDOM=function(){var t=this;if(Array.prototype.filter.call(this.el.children,(function(e){return e.classList.contains(t.classNames.wrapper)})).length)this.wrapperEl=this.el.querySelector("."+this.classNames.wrapper),this.contentWrapperEl=this.options.scrollableNode||this.el.querySelector("."+this.classNames.contentWrapper),this.contentEl=this.options.contentNode||this.el.querySelector("."+this.classNames.contentEl),this.offsetEl=this.el.querySelector("."+this.classNames.offset),this.maskEl=this.el.querySelector("."+this.classNames.mask),this.placeholderEl=this.findChild(this.wrapperEl,"."+this.classNames.placeholder),this.heightAutoObserverWrapperEl=this.el.querySelector("."+this.classNames.heightAutoObserverWrapperEl),this.heightAutoObserverEl=this.el.querySelector("."+this.classNames.heightAutoObserverEl),this.axis.x.track.el=this.findChild(this.el,"."+this.classNames.track+"."+this.classNames.horizontal),this.axis.y.track.el=this.findChild(this.el,"."+this.classNames.track+"."+this.classNames.vertical);else{for(this.wrapperEl=document.createElement("div"),this.contentWrapperEl=document.createElement("div"),this.offsetEl=document.createElement("div"),this.maskEl=document.createElement("div"),this.contentEl=document.createElement("div"),this.placeholderEl=document.createElement("div"),this.heightAutoObserverWrapperEl=document.createElement("div"),this.heightAutoObserverEl=document.createElement("div"),this.wrapperEl.classList.add(this.classNames.wrapper),this.contentWrapperEl.classList.add(this.classNames.contentWrapper),this.offsetEl.classList.add(this.classNames.offset),this.maskEl.classList.add(this.classNames.mask),this.contentEl.classList.add(this.classNames.contentEl),this.placeholderEl.classList.add(this.classNames.placeholder),this.heightAutoObserverWrapperEl.classList.add(this.classNames.heightAutoObserverWrapperEl),this.heightAutoObserverEl.classList.add(this.classNames.heightAutoObserverEl);this.el.firstChild;)this.contentEl.appendChild(this.el.firstChild);this.contentWrapperEl.appendChild(this.contentEl),this.offsetEl.appendChild(this.contentWrapperEl),this.maskEl.appendChild(this.offsetEl),this.heightAutoObserverWrapperEl.appendChild(this.heightAutoObserverEl),this.wrapperEl.appendChild(this.heightAutoObserverWrapperEl),this.wrapperEl.appendChild(this.maskEl),this.wrapperEl.appendChild(this.placeholderEl),this.el.appendChild(this.wrapperEl)}if(!this.axis.x.track.el||!this.axis.y.track.el){var e=document.createElement("div"),r=document.createElement("div");e.classList.add(this.classNames.track),r.classList.add(this.classNames.scrollbar),e.appendChild(r),this.axis.x.track.el=e.cloneNode(!0),this.axis.x.track.el.classList.add(this.classNames.horizontal),this.axis.y.track.el=e.cloneNode(!0),this.axis.y.track.el.classList.add(this.classNames.vertical),this.el.appendChild(this.axis.x.track.el),this.el.appendChild(this.axis.y.track.el)}this.axis.x.scrollbar.el=this.axis.x.track.el.querySelector("."+this.classNames.scrollbar),this.axis.y.scrollbar.el=this.axis.y.track.el.querySelector("."+this.classNames.scrollbar),this.options.autoHide||(this.axis.x.scrollbar.el.classList.add(this.classNames.visible),this.axis.y.scrollbar.el.classList.add(this.classNames.visible)),this.el.setAttribute("data-simplebar","init")},e.initListeners=function(){var t=this;this.options.autoHide&&this.el.addEventListener("mouseenter",this.onMouseEnter),["mousedown","click","dblclick"].forEach((function(e){t.el.addEventListener(e,t.onPointerEvent,!0)})),["touchstart","touchend","touchmove"].forEach((function(e){t.el.addEventListener(e,t.onPointerEvent,{capture:!0,passive:!0})})),this.el.addEventListener("mousemove",this.onMouseMove),this.el.addEventListener("mouseleave",this.onMouseLeave),this.contentWrapperEl.addEventListener("scroll",this.onScroll),window.addEventListener("resize",this.onWindowResize);var e=0;this.resizeObserver=new di((function(){1!==++e&&t.recalculate()})),this.resizeObserver.observe(this.el),this.resizeObserver.observe(this.contentEl),this.mutationObserver=new MutationObserver(this.recalculate),this.mutationObserver.observe(this.contentEl,{childList:!0,subtree:!0,characterData:!0})},e.recalculate=function(){this.elStyles=window.getComputedStyle(this.el),this.isRtl="rtl"===this.elStyles.direction;var t=this.heightAutoObserverEl.offsetHeight<=1,e=this.heightAutoObserverEl.offsetWidth<=1,r=this.contentEl.offsetWidth,n=this.contentWrapperEl.offsetWidth,i=this.elStyles.overflowX,o=this.elStyles.overflowY;this.contentEl.style.padding=this.elStyles.paddingTop+" "+this.elStyles.paddingRight+" "+this.elStyles.paddingBottom+" "+this.elStyles.paddingLeft,this.wrapperEl.style.margin="-"+this.elStyles.paddingTop+" -"+this.elStyles.paddingRight+" -"+this.elStyles.paddingBottom+" -"+this.elStyles.paddingLeft;var s=this.contentEl.scrollHeight,a=this.contentEl.scrollWidth;this.contentWrapperEl.style.height=t?"auto":"100%",this.placeholderEl.style.width=e?r+"px":"auto",this.placeholderEl.style.height=s+"px";var c=this.contentWrapperEl.offsetHeight;this.axis.x.isOverflowing=a>r,this.axis.y.isOverflowing=s>c,this.axis.x.isOverflowing="hidden"!==i&&this.axis.x.isOverflowing,this.axis.y.isOverflowing="hidden"!==o&&this.axis.y.isOverflowing,this.axis.x.forceVisible="x"===this.options.forceVisible||!0===this.options.forceVisible,this.axis.y.forceVisible="y"===this.options.forceVisible||!0===this.options.forceVisible,this.hideNativeScrollbar();var l=this.axis.x.isOverflowing?this.scrollbarWidth:0,u=this.axis.y.isOverflowing?this.scrollbarWidth:0;this.axis.x.isOverflowing=this.axis.x.isOverflowing&&a>n-u,this.axis.y.isOverflowing=this.axis.y.isOverflowing&&s>c-l,this.axis.x.scrollbar.size=this.getScrollbarSize("x"),this.axis.y.scrollbar.size=this.getScrollbarSize("y"),this.axis.x.scrollbar.el.style.width=this.axis.x.scrollbar.size+"px",this.axis.y.scrollbar.el.style.height=this.axis.y.scrollbar.size+"px",this.positionScrollbar("x"),this.positionScrollbar("y"),this.toggleTrackVisibility("x"),this.toggleTrackVisibility("y")},e.getScrollbarSize=function(t){if(void 0===t&&(t="y"),!this.axis[t].isOverflowing)return 0;var e,r=this.contentEl[this.axis[t].scrollSizeAttr],n=this.axis[t].track.el[this.axis[t].offsetSizeAttr],i=n/r;return e=Math.max(~~(i*n),this.options.scrollbarMinSize),this.options.scrollbarMaxSize&&(e=Math.min(e,this.options.scrollbarMaxSize)),e},e.positionScrollbar=function(e){if(void 0===e&&(e="y"),this.axis[e].isOverflowing){var r=this.contentWrapperEl[this.axis[e].scrollSizeAttr],n=this.axis[e].track.el[this.axis[e].offsetSizeAttr],i=parseInt(this.elStyles[this.axis[e].sizeAttr],10),o=this.axis[e].scrollbar,s=this.contentWrapperEl[this.axis[e].scrollOffsetAttr],a=(s="x"===e&&this.isRtl&&t.getRtlHelpers().isRtlScrollingInverted?-s:s)/(r-i),c=~~((n-o.size)*a);c="x"===e&&this.isRtl&&t.getRtlHelpers().isRtlScrollbarInverted?c+(n-o.size):c,o.el.style.transform="x"===e?"translate3d("+c+"px, 0, 0)":"translate3d(0, "+c+"px, 0)"}},e.toggleTrackVisibility=function(t){void 0===t&&(t="y");var e=this.axis[t].track.el,r=this.axis[t].scrollbar.el;this.axis[t].isOverflowing||this.axis[t].forceVisible?(e.style.visibility="visible",this.contentWrapperEl.style[this.axis[t].overflowAttr]="scroll"):(e.style.visibility="hidden",this.contentWrapperEl.style[this.axis[t].overflowAttr]="hidden"),this.axis[t].isOverflowing?r.style.display="block":r.style.display="none"},e.hideNativeScrollbar=function(){this.offsetEl.style[this.isRtl?"left":"right"]=this.axis.y.isOverflowing||this.axis.y.forceVisible?"-"+this.scrollbarWidth+"px":0,this.offsetEl.style.bottom=this.axis.x.isOverflowing||this.axis.x.forceVisible?"-"+this.scrollbarWidth+"px":0},e.onMouseMoveForAxis=function(t){void 0===t&&(t="y"),this.axis[t].track.rect=this.axis[t].track.el.getBoundingClientRect(),this.axis[t].scrollbar.rect=this.axis[t].scrollbar.el.getBoundingClientRect(),this.isWithinBounds(this.axis[t].scrollbar.rect)?this.axis[t].scrollbar.el.classList.add(this.classNames.hover):this.axis[t].scrollbar.el.classList.remove(this.classNames.hover),this.isWithinBounds(this.axis[t].track.rect)?(this.showScrollbar(t),this.axis[t].track.el.classList.add(this.classNames.hover)):this.axis[t].track.el.classList.remove(this.classNames.hover)},e.onMouseLeaveForAxis=function(t){void 0===t&&(t="y"),this.axis[t].track.el.classList.remove(this.classNames.hover),this.axis[t].scrollbar.el.classList.remove(this.classNames.hover)},e.showScrollbar=function(t){void 0===t&&(t="y");var e=this.axis[t].scrollbar.el;this.axis[t].isVisible||(e.classList.add(this.classNames.visible),this.axis[t].isVisible=!0),this.options.autoHide&&this.hideScrollbars()},e.onDragStart=function(t,e){void 0===e&&(e="y");var r=this.axis[e].scrollbar,n="y"===e?t.pageY:t.pageX;this.axis[e].dragOffset=n-r.rect[this.axis[e].offsetAttr],this.draggedAxis=e,this.el.classList.add(this.classNames.dragging),document.addEventListener("mousemove",this.drag,!0),document.addEventListener("mouseup",this.onEndDrag,!0),null===this.removePreventClickId?(document.addEventListener("click",this.preventClick,!0),document.addEventListener("dblclick",this.preventClick,!0)):(window.clearTimeout(this.removePreventClickId),this.removePreventClickId=null)},e.onTrackClick=function(t,e){var r=this;void 0===e&&(e="y"),this.axis[e].scrollbar.rect=this.axis[e].scrollbar.el.getBoundingClientRect();var n=this.axis[e].scrollbar.rect[this.axis[e].offsetAttr],i=parseInt(this.elStyles[this.axis[e].sizeAttr],10),o=this.contentWrapperEl[this.axis[e].scrollOffsetAttr],s=("y"===e?this.mouseY-n:this.mouseX-n)<0?-1:1,a=-1===s?o-i:o+i;!function t(){var n,i;-1===s?o>a&&(o-=40,r.contentWrapperEl.scrollTo(((n={})[r.axis[e].offsetAttr]=o,n)),window.requestAnimationFrame(t)):o<a&&(o+=40,r.contentWrapperEl.scrollTo(((i={})[r.axis[e].offsetAttr]=o,i)),window.requestAnimationFrame(t))}()},e.getContentElement=function(){return this.contentEl},e.getScrollElement=function(){return this.contentWrapperEl},e.getScrollbarWidth=function(){return"none"===getComputedStyle(this.contentWrapperEl,"::-webkit-scrollbar").display||"scrollbarWidth"in document.documentElement.style?0:function(){if(null===pi){if("undefined"==typeof document)return pi=0;var t=document.body,e=document.createElement("div");e.classList.add("simplebar-hide-scrollbar"),t.appendChild(e);var r=e.getBoundingClientRect().right;t.removeChild(e),pi=r}return pi}()},e.removeListeners=function(){var t=this;this.options.autoHide&&this.el.removeEventListener("mouseenter",this.onMouseEnter),["mousedown","click","dblclick"].forEach((function(e){t.el.removeEventListener(e,t.onPointerEvent,!0)})),["touchstart","touchend","touchmove"].forEach((function(e){t.el.removeEventListener(e,t.onPointerEvent,{capture:!0,passive:!0})})),this.el.removeEventListener("mousemove",this.onMouseMove),this.el.removeEventListener("mouseleave",this.onMouseLeave),this.contentWrapperEl.removeEventListener("scroll",this.onScroll),window.removeEventListener("resize",this.onWindowResize),this.mutationObserver.disconnect(),this.resizeObserver.disconnect(),this.recalculate.cancel(),this.onMouseMove.cancel(),this.hideScrollbars.cancel(),this.onWindowResize.cancel()},e.unMount=function(){this.removeListeners(),t.instances.delete(this.el)},e.isWithinBounds=function(t){return this.mouseX>=t.left&&this.mouseX<=t.left+t.width&&this.mouseY>=t.top&&this.mouseY<=t.top+t.height},e.findChild=function(t,e){var r=t.matches||t.webkitMatchesSelector||t.mozMatchesSelector||t.msMatchesSelector;return Array.prototype.filter.call(t.children,(function(t){return r.call(t,e)}))[0]},t}();gi.defaultOptions={autoHide:!0,forceVisible:!1,classNames:{contentEl:"simplebar-content",contentWrapper:"simplebar-content-wrapper",offset:"simplebar-offset",mask:"simplebar-mask",wrapper:"simplebar-wrapper",placeholder:"simplebar-placeholder",scrollbar:"simplebar-scrollbar",track:"simplebar-track",heightAutoObserverWrapperEl:"simplebar-height-auto-observer-wrapper",heightAutoObserverEl:"simplebar-height-auto-observer",visible:"simplebar-visible",horizontal:"simplebar-horizontal",vertical:"simplebar-vertical",hover:"simplebar-hover",dragging:"simplebar-dragging"},scrollbarMinSize:25,scrollbarMaxSize:0,timeout:1e3},gi.instances=new WeakMap;var yi=function(t){return function(e,r,n,i){kt(r);var o=Mt(e),s=y(o),a=st(o.length),c=t?a-1:0,l=t?-1:1;if(n<2)for(;;){if(c in s){i=s[c],c+=l;break}if(c+=l,t?c<0:a<=c)throw TypeError("Reduce of empty array with no initial value")}for(;t?c>=0:a>c;c+=l)c in s&&(i=r(i,s[c],c,o));return i}},bi={left:yi(!1),right:yi(!0)}.left;At({target:"Array",proto:!0,forced:Vt("reduce")},{reduce:function(t){return bi(this,t,arguments.length,arguments.length>1?arguments[1]:void 0)}});var mi=R.f,xi=Function.prototype,Ei=xi.toString,wi=/^\s*function ([^ (]*)/;!l||"name"in xi||mi(xi,"name",{configurable:!0,get:function(){try{return Ei.call(this).match(wi)[1]}catch(t){return""}}});var Oi,_i,Si=function(){var t=j(this),e="";return t.global&&(e+="g"),t.ignoreCase&&(e+="i"),t.multiline&&(e+="m"),t.dotAll&&(e+="s"),t.unicode&&(e+="u"),t.sticky&&(e+="y"),e},Ai=RegExp.prototype.exec,ki=String.prototype.replace,Li=Ai,Mi=(Oi=/a/,_i=/b*/g,Ai.call(Oi,"a"),Ai.call(_i,"a"),0!==Oi.lastIndex||0!==_i.lastIndex),ji=void 0!==/()??/.exec("")[1];(Mi||ji)&&(Li=function(t){var e,r,n,i,o=this;return ji&&(r=new RegExp("^"+o.source+"$(?!\\s)",Si.call(o))),Mi&&(e=o.lastIndex),n=Ai.call(o,t),Mi&&n&&(o.lastIndex=o.global?n.index+n[0].length:e),ji&&n&&n.length>1&&ki.call(n[0],r,(function(){for(i=1;i<arguments.length-2;i++)void 0===arguments[i]&&(n[i]=void 0)})),n});var Ti=Li;At({target:"RegExp",proto:!0,forced:/./.exec!==Ti},{exec:Ti});var Ri=zt("species"),Wi=!c((function(){var t=/./;return t.exec=function(){var t=[];return t.groups={a:"7"},t},"7"!=="".replace(t,"$<a>")})),zi=!c((function(){var t=/(?:)/,e=t.exec;t.exec=function(){return e.apply(this,arguments)};var r="ab".split(t);return 2!==r.length||"a"!==r[0]||"b"!==r[1]})),Ci=function(t,e,r,n){var i=zt(t),o=!c((function(){var e={};return e[i]=function(){return 7},7!=""[t](e)})),s=o&&!c((function(){var e=!1,r=/a/;return r.exec=function(){return e=!0,null},"split"===t&&(r.constructor={},r.constructor[Ri]=function(){return r}),r[i](""),!e}));if(!o||!s||"replace"===t&&!Wi||"split"===t&&!zi){var a=/./[i],l=r(i,""[t],(function(t,e,r,n,i){return e.exec===Ti?o&&!i?{done:!0,value:a.call(e,r,n)}:{done:!0,value:t.call(r,e,n)}:{done:!1}})),u=l[0],f=l[1];J(String.prototype,t,u),J(RegExp.prototype,i,2==e?function(t,e){return f.call(t,this,e)}:function(t){return f.call(t,this)}),n&&W(RegExp.prototype[i],"sham",!0)}},Ni=Ue.charAt,Ii=function(t,e,r){return e+(r?Ni(t,e).length:1)},Di=function(t,e){var r=t.exec;if("function"==typeof r){var n=r.call(t,e);if("object"!=typeof n)throw TypeError("RegExp exec method returned something other than an Object or null");return n}if("RegExp"!==v(t))throw TypeError("RegExp#exec called on incompatible receiver");return Ti.call(t,e)};Ci("match",1,(function(t,e,r){return[function(e){var r=b(this),n=null==e?void 0:e[t];return void 0!==n?n.call(e,r):new RegExp(e)[t](String(r))},function(t){var n=r(e,t,this);if(n.done)return n.value;var i=j(t),o=String(this);if(!i.global)return Di(i,o);var s=i.unicode;i.lastIndex=0;for(var a,c=[],l=0;null!==(a=Di(i,o));){var u=String(a[0]);c[l]=u,""===u&&(i.lastIndex=Ii(o,st(i.lastIndex),s)),l++}return 0===l?null:c}]}));var Pi=Math.max,Vi=Math.min,Fi=Math.floor,Bi=/\$([$&'`]|\d\d?|<[^>]*>)/g,Hi=/\$([$&'`]|\d\d?)/g;Ci("replace",2,(function(t,e,r){return[function(r,n){var i=b(this),o=null==r?void 0:r[t];return void 0!==o?o.call(r,i,n):e.call(String(i),r,n)},function(t,i){var o=r(e,t,this,i);if(o.done)return o.value;var s=j(t),a=String(this),c="function"==typeof i;c||(i=String(i));var l=s.global;if(l){var u=s.unicode;s.lastIndex=0}for(var f=[];;){var h=Di(s,a);if(null===h)break;if(f.push(h),!l)break;""===String(h[0])&&(s.lastIndex=Ii(a,st(s.lastIndex),u))}for(var d,p="",v=0,g=0;g<f.length;g++){h=f[g];for(var y=String(h[0]),b=Pi(Vi(it(h.index),a.length),0),m=[],x=1;x<h.length;x++)m.push(void 0===(d=h[x])?d:String(d));var E=h.groups;if(c){var w=[y].concat(m,b,a);void 0!==E&&w.push(E);var O=String(i.apply(void 0,w))}else O=n(y,a,b,m,E,i);b>=v&&(p+=a.slice(v,b)+O,v=b+y.length)}return p+a.slice(v)}];function n(t,r,n,i,o,s){var a=n+t.length,c=i.length,l=Hi;return void 0!==o&&(o=Mt(o),l=Bi),e.call(s,l,(function(e,s){var l;switch(s.charAt(0)){case"$":return"$";case"&":return t;case"`":return r.slice(0,n);case"'":return r.slice(a);case"<":l=o[s.slice(1,-1)];break;default:var u=+s;if(0===u)return e;if(u>c){var f=Fi(u/10);return 0===f?e:f<=c?void 0===i[f-1]?s.charAt(1):i[f-1]+s.charAt(1):e}l=i[u-1]}return void 0===l?"":l}))}}));var qi=function(t){return Array.prototype.reduce.call(t,(function(t,e){var r=e.name.match(/data-simplebar-(.+)/);if(r){var n=r[1].replace(/\W+(.)/g,(function(t,e){return e.toUpperCase()}));switch(e.value){case"true":t[n]=!0;break;case"false":t[n]=!1;break;case void 0:t[n]=!0;break;default:t[n]=e.value}}return t}),{})};return gi.initDOMLoadedElements=function(){document.removeEventListener("DOMContentLoaded",this.initDOMLoadedElements),window.removeEventListener("load",this.initDOMLoadedElements),Array.prototype.forEach.call(document.querySelectorAll('[data-simplebar]:not([data-simplebar="init"])'),(function(t){gi.instances.has(t)||new gi(t,qi(t.attributes))}))},gi.removeObserver=function(){this.globalObserver.disconnect()},gi.initHtmlApi=function(){this.initDOMLoadedElements=this.initDOMLoadedElements.bind(this),"undefined"!=typeof MutationObserver&&(this.globalObserver=new MutationObserver(gi.handleMutations),this.globalObserver.observe(document,{childList:!0,subtree:!0})),"complete"===document.readyState||"loading"!==document.readyState&&!document.documentElement.doScroll?window.setTimeout(this.initDOMLoadedElements):(document.addEventListener("DOMContentLoaded",this.initDOMLoadedElements),window.addEventListener("load",this.initDOMLoadedElements))},gi.handleMutations=function(t){t.forEach((function(t){Array.prototype.forEach.call(t.addedNodes,(function(t){1===t.nodeType&&(t.hasAttribute("data-simplebar")?!gi.instances.has(t)&&new gi(t,qi(t.attributes)):Array.prototype.forEach.call(t.querySelectorAll('[data-simplebar]:not([data-simplebar="init"])'),(function(t){!gi.instances.has(t)&&new gi(t,qi(t.attributes))})))})),Array.prototype.forEach.call(t.removedNodes,(function(t){1===t.nodeType&&(t.hasAttribute('[data-simplebar="init"]')?gi.instances.has(t)&&gi.instances.get(t).unMount():Array.prototype.forEach.call(t.querySelectorAll('[data-simplebar="init"]'),(function(t){gi.instances.has(t)&&gi.instances.get(t).unMount()})))}))}))},gi.getOptions=qi,Yt&&gi.initHtmlApi(),gi}));

/**
 * jquery.scrollto
 * Copyright (c) 2007-2015 Ariel Flesler - aflesler<a>gmail<d>com | http://flesler.blogspot.com
 * Licensed under MIT
 * @author Ariel Flesler
 * @version 2.1.2
 */
;(function(f){"use strict";"function"===typeof define&&define.amd?define(["jquery"],f):"undefined"!==typeof module&&module.exports?module.exports=f(require("jquery")):f(jQuery)})(function($){"use strict";function n(a){return!a.nodeName||-1!==$.inArray(a.nodeName.toLowerCase(),["iframe","#document","html","body"])}function h(a){return $.isFunction(a)||$.isPlainObject(a)?a:{top:a,left:a}}var p=$.scrollTo=function(a,d,b){return $(window).scrollTo(a,d,b)};p.defaults={axis:"xy",duration:0,limit:!0};$.fn.scrollTo=function(a,d,b){"object"=== typeof d&&(b=d,d=0);"function"===typeof b&&(b={onAfter:b});"max"===a&&(a=9E9);b=$.extend({},p.defaults,b);d=d||b.duration;var u=b.queue&&1<b.axis.length;u&&(d/=2);b.offset=h(b.offset);b.over=h(b.over);return this.each(function(){function k(a){var k=$.extend({},b,{queue:!0,duration:d,complete:a&&function(){a.call(q,e,b)}});r.animate(f,k)}if(null!==a){var l=n(this),q=l?this.contentWindow||window:this,r=$(q),e=a,f={},t;switch(typeof e){case "number":case "string":if(/^([+-]=?)?\d+(\.\d+)?(px|%)?$/.test(e)){e= h(e);break}e=l?$(e):$(e,q);case "object":if(e.length===0)return;if(e.is||e.style)t=(e=$(e)).offset()}var v=$.isFunction(b.offset)&&b.offset(q,e)||b.offset;$.each(b.axis.split(""),function(a,c){var d="x"===c?"Left":"Top",m=d.toLowerCase(),g="scroll"+d,h=r[g](),n=p.max(q,c);t?(f[g]=t[m]+(l?0:h-r.offset()[m]),b.margin&&(f[g]-=parseInt(e.css("margin"+d),10)||0,f[g]-=parseInt(e.css("border"+d+"Width"),10)||0),f[g]+=v[m]||0,b.over[m]&&(f[g]+=e["x"===c?"width":"height"]()*b.over[m])):(d=e[m],f[g]=d.slice&& "%"===d.slice(-1)?parseFloat(d)/100*n:d);b.limit&&/^\d+$/.test(f[g])&&(f[g]=0>=f[g]?0:Math.min(f[g],n));!a&&1<b.axis.length&&(h===f[g]?f={}:u&&(k(b.onAfterFirst),f={}))});k(b.onAfter)}})};p.max=function(a,d){var b="x"===d?"Width":"Height",h="scroll"+b;if(!n(a))return a[h]-$(a)[b.toLowerCase()]();var b="client"+b,k=a.ownerDocument||a.document,l=k.documentElement,k=k.body;return Math.max(l[h],k[h])-Math.min(l[b],k[b])};$.Tween.propHooks.scrollLeft=$.Tween.propHooks.scrollTop={get:function(a){return $(a.elem)[a.prop]()}, set:function(a){var d=this.get(a);if(a.options.interrupt&&a._last&&a._last!==d)return $(a.elem).stop();var b=Math.round(a.now);d!==b&&($(a.elem)[a.prop](b),a._last=this.get(a))}};return p});

/**
 * jquery.localscroll
 * Copyright (c) 2007 Ariel Flesler - aflesler<a>gmail<d>com | https://github.com/flesler
 * Licensed under MIT
 * @author Ariel Flesler
 * @version 2.0.0
 */
!function(e){"function"==typeof define&&define.amd?define(["jquery"],e):e(jQuery)}(function(e){function t(t,o,n){var i=o.hash.slice(1),a=document.getElementById(i)||document.getElementsByName(i)[0];if(a){t&&t.preventDefault();var l=e(n.target);if(!(n.lock&&l.is(":animated")||n.onBefore&&!1===n.onBefore(t,a,l))){if(n.stop&&l.stop(!0),n.hash){var r=a.id===i?"id":"name",s=e("<a> </a>").attr(r,i).css({position:"absolute",top:e(window).scrollTop(),left:e(window).scrollLeft()});a[r]="",e("body").prepend(s),location.hash=o.hash,s.remove(),a[r]=i}l.scrollTo(a,n).trigger("notify.serialScroll",[a])}}}var o=location.href.replace(/#.*/,""),n=e.localScroll=function(t){e("body").localScroll(t)};return n.defaults={duration:1e3,axis:"y",event:"click",stop:!0,target:window,autoscroll:!0},e.fn.localScroll=function(i){function a(){return!!this.href&&!!this.hash&&this.href.replace(this.hash,"")===o&&(!i.filter||e(this).is(i.filter))}return(i=e.extend({},n.defaults,i)).autoscroll&&i.hash&&location.hash&&(i.target&&window.scrollTo(0,0),t(0,location,i)),i.lazy?this.on(i.event,"a,area",function(e){a.call(this)&&t(e,this,i)}):this.find("a,area").filter(a).bind(i.event,function(e){t(e,this,i)}).end().end()},n.hash=function(){},n});


/*global jQuery */
/*! BigText - v1.0.1 - 2017-10-02
 * https://github.com/zachleat/bigtext
 * Copyright (c) 2017 Zach Leatherman (@zachleat)
 * MIT License */

(function(window, $) {
  "use strict";

  var counter = 0,
    $headCache = $('head'),
    oldBigText = window.BigText,
    oldjQueryMethod = $.fn.bigtext,
    BigText = {
      DEBUG_MODE: false,
      DEFAULT_MIN_FONT_SIZE_PX: null,
      DEFAULT_MAX_FONT_SIZE_PX: 528,
      GLOBAL_STYLE_ID: 'bigtext-style',
      STYLE_ID: 'bigtext-id',
      LINE_CLASS_PREFIX: 'bigtext-line',
      EXEMPT_CLASS: 'bigtext-exempt',
      noConflict: function(restore)
      {
        if(restore) {
          $.fn.bigtext = oldjQueryMethod;
          window.BigText = oldBigText;
        }
        return BigText;
      },
      supports: {
        wholeNumberFontSizeOnly: (function() {
          return true;

          if( !( 'getComputedStyle' in window ) ) {
            return true;
          }
          var test = $('<div/>').css({
              position: 'absolute',
              'font-size': '14.1px'
            }).insertBefore( $('script').eq(0) ),
            computedStyle = window.getComputedStyle( test[0], null );

          var ret = computedStyle && computedStyle.getPropertyValue( 'font-size' ) === '14px';
          test.remove();
          return ret;
        })()
      },
      init: function() {
        if(!$('#'+BigText.GLOBAL_STYLE_ID).length) {
          $headCache.append(BigText.generateStyleTag(BigText.GLOBAL_STYLE_ID, ['.bigtext * { white-space: nowrap; } .bigtext > * { display: block; }',
                                          '.bigtext .' + BigText.EXEMPT_CLASS + ', .bigtext .' + BigText.EXEMPT_CLASS + ' * { white-space: normal; }']));
        }
      },
      bindResize: function(eventName, resizeFunction) {
        var timeoutId;
        $(window).off(eventName).on(eventName, function() {
          if( timeoutId ) {
            clearTimeout( timeoutId );
          }
          timeoutId = setTimeout( resizeFunction, 100 );
        });
      },
      getStyleId: function(id)
      {
        return BigText.STYLE_ID + '-' + id;
      },
      generateStyleTag: function(id, css)
      {
        return $('<style>' + css.join('\n') + '</style>').attr('id', id);
      },
      clearCss: function(id)
      {
        var styleId = BigText.getStyleId(id);
        $('#' + styleId).remove();
      },
      generateCss: function(id, linesFontSizes, lineWordSpacings, minFontSizes)
      {
        var css = [];

        BigText.clearCss(id);

        for(var j=0, k=linesFontSizes.length; j<k; j++) {
          css.push('#' + id + ' .' + BigText.LINE_CLASS_PREFIX + j + ' {' +
            (minFontSizes[j] ? ' white-space: normal;' : '') +
            (linesFontSizes[j] ? ' font-size: ' + linesFontSizes[j] + 'px;' : '') +
            (lineWordSpacings[j] ? ' word-spacing: ' + lineWordSpacings[j] + 'px;' : '') +
            '}');
        }

        return BigText.generateStyleTag(BigText.getStyleId(id), css);
      },
      jQueryMethod: function(options)
      {
        BigText.init();

        options = $.extend({
          minfontsize: BigText.DEFAULT_MIN_FONT_SIZE_PX,
          maxfontsize: BigText.DEFAULT_MAX_FONT_SIZE_PX,
          childSelector: '',
          resize: true
        }, options || {});

        this.each(function()
        {
          var $t = $(this).addClass('bigtext'),
            maxWidth = $t.width(),
            id = $t.attr('id'),
            $children = options.childSelector ? $t.find( options.childSelector ) : $t.children();

          if(!id) {
            id = 'bigtext-id' + (counter++);
            $t.attr('id', id);
          }

          if(options.resize) {
            BigText.bindResize('resize.bigtext-event-' + id, function()
            {
              // TODO only call this if the width has changed.
              BigText.jQueryMethod.call($('#' + id), options);
            });
          }

          BigText.clearCss(id);

          $children.addClass(function(lineNumber, className)
          {
            // remove existing line classes.
            return [className.replace(new RegExp('\\b' + BigText.LINE_CLASS_PREFIX + '\\d+\\b'), ''),
                BigText.LINE_CLASS_PREFIX + lineNumber].join(' ');
          });

          var sizes = BigText.calculateSizes($t, $children, maxWidth, options.maxfontsize, options.minfontsize);
          $headCache.append(BigText.generateCss(id, sizes.fontSizes, sizes.wordSpacings, sizes.minFontSizes));
        });

        return this.trigger('bigtext:complete');
      },
      testLineDimensions: function($line, maxWidth, property, size, interval, units, previousWidth)
      {
        var width;
        previousWidth = typeof previousWidth === 'number' ? previousWidth : 0;
        $line.css(property, size + units);

        width = $line.width();

        if(width >= maxWidth) {
    // console.log(width, ' previous: ' + previousWidth, property + ' at ' + interval, 'prior: ' + (parseFloat(size) - interval), 'new:' + parseFloat(size));
          $line.css(property, '');

          if(width === maxWidth) {
            return {
              match: 'exact',
              size: parseFloat((parseFloat(size) - 0.1).toFixed(3))
            };
          }

          // Since this is an estimate, we calculate how far over the width we went with the new value.
          // If this is word-spacing (our last resort guess) and the over is less than the under, we keep the higher value.
          // Otherwise, we revert to the underestimate.
          var under = maxWidth - previousWidth,
            over = width - maxWidth;

          return {
            match: 'estimate',
            size: parseFloat((parseFloat(size) - (property === 'word-spacing' && previousWidth && ( over < under ) ? 0 : interval)).toFixed(3))
          };
        }

        return width;
      },
      calculateSizes: function($t, $children, maxWidth, maxFontSize, minFontSize)
      {
        var $c = $t.clone(true)
          .addClass('bigtext-cloned')
          .css({
            fontFamily: $t.css('font-family'),
            textTransform: $t.css('text-transform'),
            wordSpacing: $t.css('word-spacing'),
            letterSpacing: $t.css('letter-spacing'),
            position: 'absolute',
            left: BigText.DEBUG_MODE ? 0 : -9999,
            top: BigText.DEBUG_MODE ? 0 : -9999
          })
          .appendTo(document.body);

        // font-size isn't the only thing we can modify, we can also mess with:
        // word-spacing and letter-spacing. WebKit does not respect subpixel
        // letter-spacing, word-spacing, or font-size.
        // TODO try -webkit-transform: scale() as a workaround.
        var fontSizes = [],
          wordSpacings = [],
          minFontSizes = [],
          ratios = [];

        $children.css('float', 'left').each(function() {
          var $line = $(this),
            // TODO replace 8, 4 with a proportional size to the calculated font-size.
            intervals = BigText.supports.wholeNumberFontSizeOnly ? [8, 4, 1] : [8, 4, 1, 0.1],
            lineMax,
            newFontSize;

          if($line.hasClass(BigText.EXEMPT_CLASS)) {
            fontSizes.push(null);
            ratios.push(null);
            minFontSizes.push(false);
            return;
          }

          // TODO we can cache this ratio?
          var autoGuessSubtraction = 32, // font size in px
            currentFontSize = parseFloat($line.css('font-size')),
            ratio = ( $line.width() / currentFontSize ).toFixed(6);

          newFontSize = parseInt( maxWidth / ratio, 10 ) - autoGuessSubtraction;

          outer: for(var m=0, n=intervals.length; m<n; m++) {
            inner: for(var j=1, k=10; j<=k; j++) {
              if(newFontSize + j*intervals[m] > maxFontSize) {
                newFontSize = maxFontSize;
                break outer;
              }

              lineMax = BigText.testLineDimensions($line, maxWidth, 'font-size', newFontSize + j*intervals[m], intervals[m], 'px', lineMax);
              if(typeof lineMax !== 'number') {
                newFontSize = lineMax.size;

                if(lineMax.match === 'exact') {
                  break outer;
                }
                break inner;
              }
            }
          }

          ratios.push(maxWidth / newFontSize);

          if(newFontSize > maxFontSize) {
            fontSizes.push(maxFontSize);
            minFontSizes.push(false);
          } else if(!!minFontSize && newFontSize < minFontSize) {
            fontSizes.push(minFontSize);
            minFontSizes.push(true);
          } else {
            fontSizes.push(newFontSize);
            minFontSizes.push(false);
          }
        }).each(function(lineNumber) {
          var $line = $(this),
            wordSpacing = 0,
            interval = 1,
            maxWordSpacing;

          if($line.hasClass(BigText.EXEMPT_CLASS)) {
            wordSpacings.push(null);
            return;
          }

          // must re-use font-size, even though it was removed above.
          $line.css('font-size', fontSizes[lineNumber] + 'px');

          for(var m=1, n=3; m<n; m+=interval) {
            maxWordSpacing = BigText.testLineDimensions($line, maxWidth, 'word-spacing', m, interval, 'px', maxWordSpacing);
            if(typeof maxWordSpacing !== 'number') {
              wordSpacing = maxWordSpacing.size;
              break;
            }
          }

          $line.css('font-size', '');
          wordSpacings.push(wordSpacing);
        }).removeAttr('style');

        if( !BigText.DEBUG_MODE ) {
          $c.remove();
        } else {
          $c.css({
            'background-color': 'rgba(255,255,255,.4)'
          });
        }

        return {
          fontSizes: fontSizes,
          wordSpacings: wordSpacings,
          ratios: ratios,
          minFontSizes: minFontSizes
        };
      }
    };

  $.fn.bigtext = BigText.jQueryMethod;
  window.BigText = BigText;

})(this, jQuery);


// JavaScript for vonH template.

initHomeCollectionSliders = function () {
  var $homeHeroSlider = $('.home-hero.slider .content');

  if ($homeHeroSlider) {
    $homeHeroSlider.slick({
      
      prevArrow: '<button type="button" title="Previous" class="slick-prev"><span class="sprite sprite-prev" aria-hidden="true">Previous</span></button>',
      nextArrow: '<button type="button" title="Next" class="slick-next"><span class="sprite sprite-next" aria-hidden="true">Next</span></button>',
      dots: false,
      mobileFirst: true,
      adaptiveHeight: false,
      autoplay: true,
      infinite: false,
      autoplaySpeed: 3000,
      speed: 1500,
      cssEase: 'ease-in-out',
      responsive: [
        {
          breakpoint: 800,
          settings: "unslick"
        }
      ]
    });
  }
}

initHomeBannerSliders = function () {
  var $homeHeroSlider = $('.home-hero.desktop-slideshow .desktop-images');
  var $mobileHomeHeroSlider = $('.home-hero.mobile-slideshow .mobile-images');
  // var $homeHeroLinks = $('.home-hero.mobile-slideshow .slide-links');

  // console.log("initHomeBannerSliders", $homeHeroSlider);

  if ($homeHeroSlider) {
    $homeHeroSlider.slick({
      dots: false,
      arrows: false,
      mobileFirst: false,
      adaptiveHeight: false,
      autoplay: true,
      infinite: true,
      autoplaySpeed: 3000,
      touchThreshold: 7,
      swipeToSlide: true,
      // asNavFor: $homeHeroLinks,
      speed: 500,
      cssEase: 'ease-in-out',
      responsive: [
        {
          breakpoint: 800,
          settings: "unslick"
        }
      ]
    });
  }
  if ($mobileHomeHeroSlider) {
    $mobileHomeHeroSlider.slick({
      
      // prevArrow: '<button type="button" title="Previous" class="slick-prev"><span class="sprite sprite-prev" aria-hidden="true">Previous</span></button>',
      // nextArrow: '<button type="button" title="Next" class="slick-next"><span class="sprite sprite-next" aria-hidden="true">Next</span></button>',
      dots: true,
      arrows: false,
      mobileFirst: true,
      adaptiveHeight: false,
      autoplay: true,
      infinite: true,
      autoplaySpeed: 3000,
      touchThreshold: 7,
      swipeToSlide: true,
      // asNavFor: $homeHeroLinks,
      speed: 500,
      cssEase: 'ease-in-out',
      responsive: [
        {
          breakpoint: 800,
          settings: "unslick"
        }
      ]
    });
  }
  // if ($homeHeroLinks) {
  //   $homeHeroSlider.slick({
      
  //     prevArrow: '<button type="button" title="Previous" class="slick-prev"><span class="sprite sprite-prev" aria-hidden="true">Previous</span></button>',
  //     nextArrow: '<button type="button" title="Next" class="slick-next"><span class="sprite sprite-next" aria-hidden="true">Next</span></button>',
  //     dots: false,
  //     arrows: false,
  //     mobileFirst: true,
  //     adaptiveHeight: false,
  //     autoplay: true,
  //     infinite: false,
  //     autoplaySpeed: 3000,
  //     asNavFor: $homeHeroSlider,
  //     speed: 1500,
  //     cssEase: 'ease-in-out',
  //     responsive: [
  //       {
  //         breakpoint: 800,
  //         settings: "unslick"
  //       }
  //     ]
  //   });
  // }
}

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    let observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        let imageId = entry.target.dataset.imageId;
        if (entry.intersectionRatio == 1) {
          $('div.slide.active').removeClass('active')
          $('div[data-thumb="' + imageId + '"]').first().addClass('active')
        }
      });
    }, { threshold: 1 });

    document.querySelectorAll('.gallery-slide').forEach(slide => { observer.observe(slide) });
  }, 350);
})

initProductSliders = function () {


   // bundles pdp
  $ImageContainer = $('#ImageContainer', 'body.product-bundle');

  if ($ImageContainer.length) {
    $ImageContainer.slick({
      dots: true,
      arrows: true,
      prevArrow: '<button type="button" title="Previous" class="slick-prev"><span class="sprite sprite-prev" aria-hidden="true">Previous</span></button>',
      nextArrow: '<button type="button" title="Next" class="slick-next"><span class="sprite sprite-next" aria-hidden="true">Next</span></button>',
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      adaptiveHeight: false,
      mobileFirst: true
    });
   }


  $thumbSlider = $('#ProductThumbs');
  $productSlider = $('#ProductPhotos');

  if ($productSlider.length) {

    $('.thumb-slide-trigger').on('click', function (event) {
      event.preventDefault();
      var $scrollToElement = $(event.currentTarget.dataset.scrollTo);
      
      // $scrollToElement[0].scrollIntoView({ behavior: "smooth", block: "center" })

      console.log('thumb-slide-trigger click', event.currentTarget.dataset.scrollTo, $scrollToElement);

      // safari doesn't support the standard browser-based smooth scroll
      $('html, body').animate({
        scrollTop: $scrollToElement.offset().top - 130
      }, 350);
    })

    // console.log('initProductSliders');

    $productSlider.slick({
      dots: true,
      arrows: false,
      slidesToShow: 1,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 768,
          settings: "unslick"
        }
      ]
    });

    if ($(window).width() > 768) {

      // setHeight = function() {
      //   var height = $('.product-description').position().top + $('.product-description').height() - 49 + 'px';
      //   console.log('setHeight', height);
      //   // $('#ImageContainer .photos').height(height);
      // };

      // $('#ProductDetails').on('click', function() {
      //   console.log("ProductDetails click");
      //   setTimeout(setHeight, 500);
      // });

      // setTimeout(setHeight, 2000);
      // setHeight();

      $thumbSlider.on('click', '.thumb-slide-trigger', function(evt) {
        $('.slide', $thumbSlider).removeClass('active');
        $(this).parents(1).addClass('active');
      });

    }


    var $StyleInspiration = $('#StyleInspiration .images');

    $StyleInspiration.slick({
      dots: true,
      arrows: false,
      slidesToShow: 1,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 800,
          settings: "unslick"
        }
      ]
    });


    var $MaterialSliderImages = $('#MaterialSliderImages');
    var $MaterialSliderText = $('#MaterialSliderText');

    $MaterialSliderImages.slick({
      dots: false,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      adaptiveHeight: false,
      asNavFor: $MaterialSliderText,
      mobileFirst: false,
      responsive: [
        {
          breakpoint: 800,
          settings: {
            "dots": true
          }
        }
      ]
    });

    $MaterialSliderText.slick({
      dots: true,
      arrows: true,
      prevArrow: '<button type="button" title="Previous" class="slick-prev"><span class="sprite sprite-prev" aria-hidden="true">Previous</span></button>',
      nextArrow: '<button type="button" title="Next" class="slick-next"><span class="sprite sprite-next" aria-hidden="true">Next</span></button>',
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      asNavFor: $MaterialSliderImages,
      mobileFirst: false,
      responsive: [
        {
          breakpoint: 800,
          settings: {
            "dots": false
          }
        }
      ]
    });

    return;
  }
}

initNav = function () {
  var $nav = $('#AccessibleNav');
  // var $nav1 = $('#TestGlass');
  // var $nav2 = $('#TestGlass2');
  // var $nav3 = $('#TestGlass3');
  var $nav4 = $('#TestGlass4');
  // var $nav5 = $('#TestGlass5');

  var $parents = $('#AccessibleNav .site-nav--has-dropdown');
  // var $background = $('#AccessibleNav .filler');
  var $topLinks = $('#AccessibleNav .site-nav__main-link');
  var $background = $('.frosted-panel, .liquidGlass-wrapper');
  var $body = $('body');

  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);
    var $menus = $('.scroll-container:not([data-simplebar="init"])', $el);
    if (!$menus.length){
      new SimpleBar($menus[0], {

      });
    }
    // console.log('mouseenter', $el, evt);
    $nav.addClass('hovered');
    // if ($el.hasClass('materials')) {
    //   $nav1.addClass('hovered');
    // }
    // else if ($el.hasClass('shop')) {
    //   $nav5.addClass('hovered');
    // }
    // else if ($el.hasClass('design-lab')) {
    //   $nav3.addClass('hovered');
    // }
    // else if ($el.hasClass('company')) {
    //   $nav2.addClass('hovered');
    // }
    // else {
      $nav4.addClass('hovered');
    // }
    // $body.on('mousemove', function (evt) {
    //   console.log('body mousemove', evt, this);
       // $nav.removeClass('hovered');
       // $nav1.removeClass('hovered');
       // $nav2.removeClass('hovered');
       // $nav3.removeClass('hovered');
       // $nav4.removeClass('hovered');
       // $nav5.removeClass('hovered');
     // });
  });

  // Mouseout
  $parents.on('mouseleave', function () {
  // $topLinks.on('mouseleave', function () {
    $nav.removeClass('hovered');
    // $nav1.removeClass('hovered');
    // $nav2.removeClass('hovered');
    // $nav3.removeClass('hovered');
    $nav4.removeClass('hovered');
    // $nav5.removeClass('hovered');
  });
  $background.on('mouseleave', function () {
    $nav.removeClass('hovered');
    // $nav1.removeClass('hovered');
    // $nav2.removeClass('hovered');
    // $nav3.removeClass('hovered');
    $nav4.removeClass('hovered');
    // $nav5.removeClass('hovered');
  });
  

  var $sub_links = $('#AccessibleNav .site-nav__subchild a');

  $sub_links.on('mouseenter touchstart', function(evt) {
    var $el = $(this);
    showMenuImage($el);
  });

  // Mouseout
  $sub_links.on('mouseleave', function () {
    hideMenuImage($(this));
  });

  function showMenuImage($el) {
    var img = $el.data('image');
    var $menu = $el.parents('.site-nav--has-dropdown');
    if (img) {
      $menu.addClass('submenu');
      $('.site-nav__dropdown .submenu', $menu).append('<img src="' + img + '"><h5>' + $el.html() + '</h5>');
    }

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideMenuImage($el);
      });
    }, 250);
  }

  function hideMenuImage ($el) {
    var $menu = $el.parents('.site-nav--has-dropdown');
      $menu.removeClass('submenu');
      $('.site-nav__dropdown .submenu', $menu).empty();
  }
}

initMobileNav = function () {

  $('.mobile-nav__return').on('click', function() {
    event.preventDefault();
    $(this).parents('.mobile-nav__sublist').siblings('.mobile-nav__has-sublist').toggleClass('mobile-nav--expanded');
    $('html, body').removeClass('js-drawer-subnav-open-left');
  });

  $('.mobile-nav__toggle').on('click', function() {
    event.preventDefault();
    $('html, body').toggleClass('js-drawer-subnav-open-left');
  });

  $('.site-nav__link.js-drawer-open-left').on('click', function() {
    event.preventDefault();
    $('html.js-drawer-open, body.js-drawer-open').removeClass('js-drawer-subnav-open-left');
    $('#NavDrawer .mobile-nav__has-sublist').removeClass('mobile-nav--expanded');
  });

}

initCartDropdown = function () {
  var $breakpoint = { window: $(window), element: $('.site-header') };
  var $inlineButtonContainer = $('#inlineButtonContainer');
  var $fixedButtonContainer = $('#fixedButtonContainer');
  
  // function to check if abandoned cart popup should be shown on mobile
  function handleMobileACP() {
    var mql = window.matchMedia('(max-width: 767px)');
    return mql.matches ? true : false;
  }

  $('#quickview-cart-screen').on('click.quickview', function() {
    timber.cartClose;
    if (handleMobileACP() && typeof hasCartItems == 'function') hasCartItems();
  });

  var closeQuickview = function (evt) {
     evt.preventDefault();
     evt.stopImmediatePropagation();
     timber.cartClose();
     if (handleMobileACP() && typeof hasCartItems == 'function') hasCartItems()
   }

  $('#CartDropdown, #CartDrawer').on('click.quickview', '.close, .btn-close', 
      closeQuickview
   );
   $('#quickview-cart-screen').on('click.quickview',
      closeQuickview
   );

  $breakpoint.refreshValue = function () {
    this.width = this.window.width();
    this.point = null;
    if (this.width >= 500) //old: 768 //1000 - 15
      this.point = 'desktop';
    // else if (this.width > 480)
    //  this.point = 'tablet';
    else
      this.point = 'phone';

    if (this.value != this.point) {
      this.value = this.point;
      $breakpoint.element.trigger('resize.breakpoint', this.value);
    }
  };
  $(window).resize(function () {
    $breakpoint.refreshValue();
  }).resize();

  $breakpoint.element.on('resize.breakpoint', function(e, breakpoint) {
    if (breakpoint === 'phone') {
      // console.log('trigger breakpoint', breakpoint);
      // $('#ProductPhotos').scrollbar('destroy');
      timber.RightDropdown.close();
      ajaxCart.setCartContainer('#CartContainer');
      // $productSlider.slick({
      //  dots: true,
      //  arrows: false,
      //  slidesToShow: 1,
      //  slidesToScroll: 1
      // })

      // console.log('checking', $('#AddToCart', $inlineButtonContainer), $('#AddToCart', $inlineButtonContainer).attr('disabled') == undefined);

      // if ($('#AddToCart', $inlineButtonContainer).attr('disabled') == undefined) {
        $('#AddToCartProxy', $fixedButtonContainer).addClass('show').on('click', function (e) { $('#AddToCart, #AddToCartX', $inlineButtonContainer)[0].click(); });

        /*$('button.bold_clone', $inlineButtonContainer).waitUntilExists(function(ex) {
          var cloneButton = this;
          $('#AddToCartProxy', $fixedButtonContainer).addClass('show').off('click').click(function () { $(cloneButton).trigger('click') });
          // $(this).clone(false).appendTo($fixedButtonContainer).attr('id', 'AddToCartProxy').on('click', function () { $(this).trigger('click') });
        }, true);*/

        // setTimeout( function() {
        //  // console.log('setting after timeout', $('#AddToCart', $inlineButtonContainer).attr('class'));
        //  $('#inlineButtonContainer button').each((i, el) => {console.log('after', i, el.className)})
        //  console.log('setting after timeout', $('#inlineButtonContainer button').length, $('#inlineButtonContainer button'));
        //  $('#AddToCart', $inlineButtonContainer).last().clone(true).appendTo($fixedButtonContainer).attr('id', 'AddToCartProxy'); //.on('click', function () { $('#AddToCart').trigger('click') });
        // }, 5000);

        // var newButton = document.getElementById('AddToCart').cloneNode(true);
        // $(newButton).appendTo($fixedButtonContainer).attr('id', 'AddToCartProxy'); //.on('click', function () { $('#AddToCart').trigger('click') });
        
        // $inlineButtonContainer.hide();
      // }

    }
    else { // if (breakpoint === 'phone')
      // console.log('UNSLICK', breakpoint);
      // console.log('trigger breakpoint', breakpoint);
      timber.RightDrawer.close();
      ajaxCart.setCartContainer('#CartDropdown');
      // try {
      //  $productSlider.slick('unslick');
      // }
      // catch (e) {}
      // $('#ProductPhotos').scrollbar({
      //  ignoreMobile: true,
      //  ignoreOverlay: false
      // });
      $fixedButtonContainer.empty();
      $inlineButtonContainer.show();
    }
  }).trigger('resize.breakpoint', $breakpoint.value);

  $('body').on('ajaxCart.afterCartLoad', function(evt, cart) {
    if (typeof(window.lastAddedProduct) == 'undefined') {
      window.lastAddedProduct = { price: 0 };
    }
    if (document.location.search.indexOf('view=bundle') >= 0 && window.lastAddedProduct.price > 20000) {
      ajaxCart.updateCountPrice(cart);
      setTimeout( function () {
        $.scrollTo('[name="accessories"]', 750);
      }, 750);
    }
    else {
      timber.cartOpen();
    }
    // re-enable this when it can be set to only close on cart add.
    // setTimeout(function(){ timber.cartClose(); }, 5000);
  });
}

initActionTracking = function () {

   getPrice = function(event) {
      try {
         const form = event.currentTarget.closest('#AddToCartForm');
         let price = form.querySelector('[data-currency-usd]').dataset.currencyUsd.replace('$', '').replace(',', '');
         let quantity = form.querySelector('#Quantity')
         quantity = quantity ? quantity.value : 1;
         return price * quantity;
      }
      catch (e) { /*console.log('obApi', 'getPrice', 'e', e);*/ }
      return null;
   }

   $("body").on( "click", "#AddToCart, .add-to-cart, .addtocart", function(event) {
    try {
      ga('send', {
        hitType: 'event',
        eventCategory: 'EnhancedEcommerce',
        eventAction: 'Add to Cart Initiated'
      });
    }
    catch (e) {}

    try {
      twq('track','AddToCart');
    }
    catch (e) {}

    try {
      price = getPrice(event);
      obApi('track', 'Add to Cart', {
         orderValue: price, 
         currency: 'USD'
      });
    }
    catch (e) {}

    return true;
  });

  $("body").on( "click", "[name='checkout'], .additional_checkout_buttons [role='button'], #paypal-button", function(event) {

    try {
      ga('send', {
        hitType: 'event',
        eventCategory: 'EnhancedEcommerce',
        eventAction: 'Checkout Initiated'
      });
    }
    catch (e) {}

    try {
      twq('track','InitiateCheckout');
    }
    catch (e) {}

    try {
      let price = document.querySelector('.cart__total [data-currency-usd]').dataset.currencyUsd.replace('$', '').replace(',', '');
      obApi('track', 'Checkout', {
         orderValue: price, 
         currency: 'USD'
      });
    }
    catch (e) {}

    return true;
  });
}

initButtonTracking = function () {
   const pageButtons = document.querySelectorAll('#PageContainer .btn, main .btn,.product-description .downloads a');

   pageButtons.forEach((btn) => {
      if (btn.nodeName == 'A') {
         let label = new URL(btn.href);
         let category = 'Button Click';
         let action = 'Action';

         label = label.pathname.substring(1).split('/');
         // console.log('label', label);
         switch (label[0]) {
            case 'pages':
               action = 'View Page';               
            break;
            case 'collections':
               action = 'View Collection';               
            break;
            case 'products':
               action = 'View Product';
            break;
            case 'blogs':
               action = 'View Blog';
            break;
            case 'articles':
               action = 'View Article';
            break;
            case 'cdn':
               if (label[2] == 'files') {
                  action = 'Download File';
               }
            break;
            case 's':
               if (label[1] == 'files') {
                  action = 'Download File';
               }
            break;
         }
         // console.log("action", action);
         //label = label.replaceAll('pages', 'view page').replaceAll('collections', 'view collection').replaceAll('products', 'view product');
         //label.replaceAll('/', ' - ');
         if (label.length > 1) {
            if (action == 'Download File') {
               label = document.getElementById('AddToCartForm').dataset.productType + ' ' + btn.textContent.replace('Download ', '').replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
            }
            else {
               label = label[1].replaceAll('-', ' ');
               label = label.replace(/\b\w+/g,function(s){return s.charAt(0).toUpperCase() + s.substr(1).toLowerCase();});
            }
            label = label.replaceAll('&nbsp;', ' ').replaceAll('  ', ' ');
         }
         else if (!label[0].length) {
            label = btn.href;
         }
         else {
            label = label[0];
         }
         // console.log('pageButton', btn, category, action, label);

         btn.dataset.pageTitle = document.body.dataset.pageTitle;
         btn.dataset.eventCategory = category;
         btn.dataset.eventAction = action;
         btn.dataset.eventLabel = label;

         btn.addEventListener('click', (evt) => {
            // e.preventDefault();
            // e.stopImmediatePropagation();
            let btn = evt.target;
            // console.log('clicked button', evt, btn.dataset);

            // try {
            //    ga('send', {
            //       hitType: 'event',
            //       eventCategory: btn.dataset.eventCategory,
            //       eventAction: btn.dataset.eventAction,
            //       eventLabel: btn.dataset.eventLabel
            //    });
            //    console.trace('google ga send event', btn.dataset);
            // }
            // catch (e) {
            //    console.trace('google ga error', e, this);
            // }

            try {
               gtag('event', btn.dataset.eventCategory, {
                 'event_category': btn.dataset.eventAction,
                 'event_label': btn.dataset.eventLabel,
                 'page_title': btn.dataset.pageTitle
               });
               console.trace('google gtag event', btn.dataset);
            }
            catch (e) {
               console.trace('google gtag error', e, this);
            }

         });

      }

   });
   
}

initImageZoom = function(e) {
  $('#ProductPhotos .zoom .toggle').each( function (i, el) {
    var $el = $(el);
    var zoom = $el.closest('.zoom');
    var img = zoom.find('img');
    var url = img.data('zoomimg');
    // var target = zoom;
    var target = 
      zoom.zoom({
        on:'click',
        url: url,
        target: target,
        trigger: $el,
        duration: 300,
        touch: false,
        onZoomIn: function () {
          $el.find('.sprite').removeClass('sprite-plus').addClass('sprite-close');
      $('.back_link, .slick-arrow').hide();
        },
        onZoomOut: function () {
          $el.find('.sprite').removeClass('sprite-close').addClass('sprite-plus');
          $('.back_link, .slick-arrow').show();
        }
      });
  });
};

initImageZoomXXX = function(e) {


  return false;


  $('#ProductPhotos .zoom').each( function (i, el) {
    el = $(el);
    el.zoom({
      on:'click.zoom',
      url: $('a', el).attr('href'),
      onZoomIn: function(e) {
        el.addClass('zoomed')
      },
      onZoomOut: function(e) {
        el.removeClass('zoomed')
      }
    });
    // console.log('initImageZoom.each', el);
  });

  fixZoom = function(e) {
    var el = $(e.target).closest('.zoom');
    // console.log('initImageZoom.on - el', el);
    // console.log('initImageZoom.on - e', e);
    // console.log('initImageZoom.on - .target.className', e.target.className);
    // console.log('initImageZoom.on - e.type', e.type);
    // console.log('initImageZoom.on - e.originalEvent.type', e.originalEvent.type);
    // , e.originalEvent.touches[0].type
    // $('#ProductDetails p').html(el[0].className + '<br/>' + e.target.className + '<br/>' + e.currentTarget.className + '<br/>' + e.type + '<br/>' + e.originalEvent.type);
    // if (e.originalEvent.touches)
    //  $('#ProductDetails p').html($('#ProductDetails p').html() + '<br/>' + e.originalEvent.touches[0].type);

    if (e.target.className == 'zoomImg' && !el.hasClass('zoomed')) {
      e.stopImmediatePropagation();
      // start( e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] );
      // console.log('initImageZoom.match', el);
    }
    // else {
    //  console.log('initImageZoom.NOMATCH', e);
    // }
  }

  fixPan = function(e) {
    e.preventDefault();
    if (e.target.className == 'zoomImg' && el.hasClass('zoomed')) {
      zoom.move( e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] );
    }
  }

  $('#ProductPhotos .zoom').on('click.zoom', fixZoom);
  $('#ProductPhotos .zoom').on('touchstart.zoom', fixZoom).on('touchmove.zoom', fixPan);
}

initWaitlistForm = function(form) {
   $form = $(form);
   if (!$form.length)
      var $form = $('#WaitlistForm form');

   // console.log('initWaitlistForm', $form, $form.length);

  if ($form.length) {

    $form.submit(
      function(e, c) {
        e.preventDefault();
        var email = $('#waitlist_email', $form).val(),
            variant_id = $('#wl_variant_id', $form).val();
            public_key = $('#wl_a', $form).val();

        if (!email.length) {
          $('.response .message', $form).html("Please enter your email address."); //.slideDown(500).delay(4000).slideUp(500);
          return false;
        }

        console.log('submit waitlist form', $form.serialize());

        const payload = {
          "data": {
            "type": "back-in-stock-subscription",
            "attributes": {
              "profile": {
                "data": {
                    "type": "profile",
                    "attributes": {
                        "email": email,
                    }
                }
              },
              "channels": ["EMAIL"],
            },
            "relationships": {
              "variant": {
                "data": {
                  "type": "catalog-variant",
                  "id": `$shopify:::$default:::${variant_id}`
                }
              }
            }
          }
        }

        var requestOptions = {
            method: 'POST',
            headers: {
              "Content-Type": "application/json",
              "revision":"2024-06-15"
            },
            body: JSON.stringify(payload),
        };

        fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${public_key}`, requestOptions)
          .then(result => {
            console.log('submit waitlist form result',  result);
            if (result.ok) {
              $('.fields', $form).hide();
              $('.response .message', $form).removeClass('error').html('Thank You! We will let you know when this item becomes available.').slideDown(500); //.delay(4000).slideUp(500);
            }
            else {
              $('.response .message', $form).addClass('error').html('There was a problem with your signup.').slideDown(500);
            }
          
          })
          .catch(error => {
            console.log('submit waitlist form error', error);
            $('.response .message', $form).addClass('error').html('There was a problem with your signup.').slideDown(500);
          })
          .catch(err => {
            console.error('submit waitlist form err', err);
            $('.response .message', $form).addClass('error').html('There was a problem with your signup.').slideDown(500);
          });


          // $.ajax({
          //     method: 'POST',
          //     url: $form.data('waitlist-action'),
          //     data: $form.serialize(),
          //     timeout: 5000,
          //     success: function(data, status, xhr) {
          //         console.log('waitlist success', data, status, xhr);
          //         $('.fields', $form).hide();
          //         $('.response .message', $form).html('Thank You! We will let you know when this item becomes available.').slideDown(500); //.delay(4000).slideUp(500);
          //     }
          // });

        var $subscribe = $('[name="Product Gender"]:checked', $form);

        console.log('waitlist form.submit', $form, $subscribe, $subscribe.length, $('#MCUrl', $form));

        if ($subscribe && $subscribe.length) {

          var subscribeData = $form.serialize();
          subscribeData['$timezone_offset'] = (new Date()).getTimezoneOffset()/60 * -1;
          subscribeData['$source'] = '$embed';

          $.ajax({
            method: 'POST',
            url: $form.data('ajax-action'),
            data: subscribeData,
            timeout: 5000,
            success: function(data, status, xhr) {
              console.log('subscribe success', data, status, xhr);
              try {
                fbq('track', 'Lead', {
                  content_name: 'Waitlist Signup',
                  content_category: 'Mailing List'
                });
              } catch (e) {}
              try {
                ga('send', {
                  hitType: 'event',
                  eventCategory: 'Lead',
                  eventAction: 'Waitlist List Signup',
                  eventLabel: 'Email Signup'
                });
              } catch (e) {}
              try {
                twq('track','Signup');
              } catch (e) {}
              
            }

          });

        }

      }

    );

  }

}

initNewsletterForms = function(mode) {

  hideForm = function($form) {
    $form.toggleClass('show');
    $('.form-fields', $form).show();
    $('.message', $form).hide().html('');
    $('input[type="email"]', $form).val('');
  };

  $('.attentive-trigger, #MobileNewsletterLink, .banner-signup button, .footer-nav__link[data-title="Sign up for Texts"]').on('click', function(evt) {
      evt.preventDefault();

      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', window.current_klaviyo_form_d2c]);

      // hideForm($(this).siblings('form'));
      // let CREATIVE_ID = window.innerWidth > 850 ? 249235 : 249252; // desktop : mobile - evergreen
      // let CREATIVE_ID = window.innerWidth > 850 ? 293583 : 293566; // desktop : mobile - evergreen
      // let CREATIVE_ID = window.innerWidth > 850 ? 293537 : 293531;  // desktop : mobile - evergreen 10%
      // let CREATIVE_ID = window.innerWidth > 850 ? 358366 : 358362; // desktop : mobile - Holiday 15%
      // let CREATIVE_ID = window.innerWidth > 850 ? 384116 : 384109; // desktop : mobile - evergreen 10%
      let CREATIVE_ID = window.innerWidth > 850 ? 979984 : 977845; // desktop : mobile - evergreen
      // let CREATIVE_ID = window.innerWidth > 850 ? 950567 : 950569; // desktop : mobile - evergreen
      // let counter = 0;

      /*let attentiveTrigger = setInterval( () => {
         counter += 1;
         console.log('window.__attentive', window.__attentive);
         if (CREATIVE_ID && window.__attentive && window.__attentive.trigger) {
            window.__attentive.hide();
            window.__attentive.trigger(null,null,null,CREATIVE_ID)
              .then(response => {console.log('window.__attentive promise', response);});
            console.log('triggering window.__attentive', CREATIVE_ID);
            clearInterval(attentiveTrigger);
         }
         else if (counter > 200) {
            clearInterval(attentiveTrigger);
         }

      }, 50);*/

  });

  $('.banner-signup .close').on('click', function(evt) {
    evt.preventDefault();
    hideForm($(this).parents('form'));
  });

  $('#signup-toggle').on('click', function(e) {
    // console.log(this, e);
    // if (window.innerWidth >= 960) {
    //  $('.banner-signup form').addClass('show').data('send-file', true);
    //  $('.banner-signup input[name="SOURCE"]').val('10 Ethical Gifting Tips');
    // }
    // else {
      $(this).data('send-file', true).data('source', '10 Ethical Gifting Tips');
      showEmailSignupModal.bind(this)();
    // }
  });

  initNewsletterForm($('.banner-klaviyo-subscribe #email_form'));

  // initNewsletterForm($('.banner-signup .mc-embedded-subscribe-form'));

  initNewsletterForm($('#join-our-mission #email_form'));
}

initModalNewsletterForm = function(mode) {
  var $form = $('#quickview .mc-embedded-subscribe-form');
  initNewsletterForm($form, mode);
}

initLanderNewsletterForm = function() {
   var $form = $('#KlaviyoSignup .mc-embedded-subscribe-form');
   initNewsletterForm($form);
}

initArticleNewsletterForm = function() {
   var $form = $('.sidebar-form.mc-embedded-subscribe-form');
   initNewsletterForm($form);
}

initNewsletterForm = function($form, mode) {
    // console.log('initNewsletterForm', $form, mode);
    $form.submit(
        function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var form = $(this);
            var action = form.data('ajax-action');
            var source = $('input[name="source"]', form).val();
            var download = false;
            var resultMessage = '';
            var response = $('.response .message', form);

            if (!$('[name="email"]', form).val()) {
                resultMessage = 'Please enter your email address.';
            }
            if (!$('[name="Product Gender"]:checked', form).val()) {
                if (resultMessage.length) {
                  resultMessage += '<br/>';
                }
                resultMessage += 'Please choose the Women&rsquo;s or Men&rsquo;s list.';
            }

            if (resultMessage.length) {
              response.html(resultMessage).fadeIn(500);
              return;
            }

            $.ajax({
                method: 'POST',
                url: action,
                data: form.serialize(),
                timeout: 5000,
                success: function(data, status, xhr) {
                    console.log('success', data, status, xhr);
                    var resultMessage = "Sorry. Unable to subscribe. Please try again later.";
                    var clear = false;
                    if (data.success !== true) {
                        if (typeof data.errors === 'object' && data.errors.length) {
                            resultMessage = data.errors.join(' ');
                        }
                    } else {
                        resultMessage = "Thank you for subscribing. <br/>Check your inbox!";
                        try {
                            if (form.data('early-access'))
                                var trackContent = 'Early Access Signup';
                            else
                                var trackContent = 'Email Signup';
                            fbq('track', 'Lead', {
                                content_name: trackContent,
                                content_category: 'Mailing List'
                            });
                        } catch (e) {}

                        try {
                            if (form.data('early-access'))
                                var trackContent = 'Early Access Signup';
                            else
                                var trackContent = 'Mailing List Signup';
                            console.log('ga send lead', trackContent, ga);
                            ga('send', {
                                hitType: 'event',
                                eventCategory: 'Lead',
                                eventAction: trackContent,
                                eventLabel: 'Email Signup'
                            });
                        } catch (e) {}

                        try {
                            console.log('twq send signup', twq);
                            
                            twq('track','Signup');
                        } catch (e) {}

                        try {
                            pintrk('track', 'signup');
                        } catch (e) {}

                        download = true;

                        clear = true;
                    }

                    if (download && form.data('send-file')) {
                        clear = false;
                        Cookies.set('dlgate2', 'true', { expires: 365, domain: domain, path: '/' });
                        document.location.href = 'https://monogrampreview.creori.com/download/vonHolzhausen-20SustainableTravelTips.png';
                    }

                    var domain = document.location.hostname.split('.');
                    domain = domain.slice(domain.length - 2, domain.length).join('.');

                    if (form.data('close-on-complete')) {
                        Cookies.set('dlgate2', 'true', { expires: 365, domain: domain, path: '/' });
                        $('#TenTips').removeClass('blurred');
                        $('#TenTipsDownload').removeClass('hidden');
                        doCloseQv(e) // Cookie the successful email signup
                    }

                    thankyou_redirect = form.data('thankyou-redirect');

                    if (form.data('early-access')) {
                        Cookies.set('vhea', 'true', { expires: 365, domain: domain, path: '/' });

                       let expires = new Date(2021, 10, 24 + 1);
                       let code = 'VONHOLIDAY';
                       Cookies.set('_promo_coupon', code, { expires: expires, path: '/' });
                       Cookies.set('saleSeen', 'true', { expires: expires, path: '/' });

                       window.promoCoupon = code;
                       window.saleSeen = true;

                       console.log('success', window.promoCoupon, window.saleSeen, thankyou_redirect);

                        $('#early-access .items, #PageContainer').removeClass('blurred');

                        setTimeout( function () {
                          doCloseQv(e) // Cookie the successful email signup
                           if(thankyou_redirect) {
                              document.location.href = thankyou_redirect;
                           }
                        }, 2000);
                    } else if (download && thankyou_redirect) {
                        clear = false;

                        Cookies.set('dlgate2', 'true', { expires: 365, domain: domain, path: '/' });
                        document.location.href = thankyou_redirect;
                    }

                    if ($('.response.modal', form).length && clear) {
                        console.log('here1', $('.response.modal', form).length , clear);

                        if (form.data('thankyou-load')) {
                            console.log('qv', $('#quickview'), form.data('thankyou-load'), eval(form.data('thankyou-load')));
                            $('#quickview').load(eval(form.data('thankyou-load')));
                        }
                        else {
                            $('.input-group.modal', form).hide();
                            $('.signup-notice').hide();
                            $('.signup-success-coupon').addClass('active');
                            let code = $('#couponField').data('code');
                            if (!code) code = 'PLANET10';
                            $('#couponField').text(code);
                            $('.response .message', form).html(resultMessage).fadeIn(500);
                            $('#subscribe, input', form).fadeOut(500, function() {
                                $('.btn-close, .close', form).fadeIn(500);
                                // setTimeout( function () {
                                //     doCloseQv(e); // Cookie the successful email signup
                                // }, 4000);
                            });
                        }
                    }
                    else {
                        console.log('else, close');
                        console.log('here2a', $('.response.footer input, .response.header input', form))
                        console.log('here2b', $('.response .message', form))
                        // resultMessage = resultMessage.replace('<br>', ' ');
                        // resultMessage = resultMessage.split('<br>')[0];
                        if ($('#EnterToWin').length) {
                            // $('.response.footer input, .response.header input', form).slideUp(500).delay(4000).slideDown(500);
                            $('.response .message', form).html(resultMessage).slideDown(500).delay(4000).slideUp(500, function() {
                                // form.delay(500).fadeOut(1000, function() {
                                //  form.removeClass('show');
                                // });
                            });
                        }
                        else if (form.hasClass('a-better-campaign') || form.hasClass('sidebar-form')) {
                            console.log('here2c', resultMessage);
                            $('.response .message', form).html(resultMessage).slideDown(500);
                        }
                        else {
                            console.log('here2d', data);
                            $('#EarlyAccessModal .message').slideUp(500);
                            $('.form-fields, .response.footer input, .response.header input', form).slideUp(500);
                            $('.response .message', form).html(resultMessage).slideDown(500);
                            if (data.success) {
                              form.delay(6000).fadeOut(500, function() {
                                form.removeClass('show');
                                $('.form-fields', form).show();
                                $('.message', form).hide().html('');
                                $('input[type="email"]', form).val('');
                              });
                            }
                              //.delay(4000).slideDown(500);
                             //.delay(4000).removeClass('show');
                            // $('.response', form).slideDown(500).delay(4000).slideUp(500
                            //   , function() {
                            //     form.delay(500).fadeOut(1000, function() {
                            //         form.removeClass('show');
                            //     });
                            // }
                              // );
                        }
                    }

                    if (clear) {
                        console.log('clear');
                        $('input[type="email"], input[type="text"]', form).val(''); //'.response input'
                        $('#quickview').trigger('quickview.closed'); // Cookie the successful email signup
                    }
                },
                error: function(data, status, xhr) {
                    console.log('post error', data, status, xhr);
                    form.off('submit'); 
                    form.attr('target', '_self');
                    form.submit();
                }
            });
        }
    );
}

initYotpoHooks = function () {

   // let ip_address = null;

   // fetch('https://api.ipify.org/?format=json')
   //   .then(response => response.json())
   //   .then(response => (ip_address = response.ip))
   //   .then(response => console.log("trackSMSSignup", "ip_address", response, ip_address))
   //   .catch(err => console.error(err));


   let trackSMSSignup = function (email, sms) {
      console.log("trackSMSSignup", 'fn', email);

      let endpoint = new URL('https://monogrampreview.creori.com/applyReward/');
      endpoint.searchParams.append('email', email);

      fetch(endpoint)
        .then(response => response.json())
        .then(response => console.log("trackSMSSignup", "response", response))
        .then(response => { if (email) document.querySelector('[aria-label="CustomActionCampaign"]:nth-child(7) .yotpo-tile-wrapper').classList.add('yotpo-tile-wrapper-completed'); })
        .catch(err => console.error(err));
   }

   // window.trackSMSSignup = trackSMSSignup;

   // setTimeout(() =>{
   //    trackSMSSignup('jonah@creori.com');
   // }, 2000);

   let registeredSMS = false;
   let attentiveEmail = null;
   let attentiveSMS = false;
   let completedSMS = false;
   console.log('completedSMS', completedSMS);

   window.addEventListener("message", (event) => {
      // console.log('trackSMSSignup', 'message.event', attentiveSMS, event);
      if (!completedSMS && event.origin.indexOf('attn') > 0 && event.data && event.data.__attentive) {
         // console.log('seen:', seen, 'gate:', gate, 'registered:', registered);
         // console.log('attn', event.data.__attentive.action, event.data.__attentive);
         switch (event.data.__attentive.action) {
            case "OPEN":
               if (registeredSMS) {
                  trackSMSSignup(attentiveEmail, attentiveSMS);
                  completedSMS = true;
               }
               break;
            case "EMAIL_LEAD":
               if (event.data.__attentive.email && event.data.__attentive.email.length) {
                  registered = true;
                  attentiveEmail = event.data.__attentive.email;
               }
               break;
            case "LEAD":
               if (event.data.__attentive.email && event.data.__attentive.email.length) {
                  attentiveEmail = event.data.__attentive.email;
               }
               if (event.data.__attentive.phone && event.data.__attentive.phone.length) {
                  registeredSMS = true;
                  attentiveSMS = event.data.__attentive.phone;
               }
               registered = true;
               break;
            default:
               //Statements executed when none of
               //the values match the value of the expression
               // console.log('default');
               break;
         }
      }

   }, false);

}

showSizeChart = function (e) {
  e.preventDefault();
  e.stopImmediatePropagation();
  var url = globalShoeSizeChart;
  console.log('showSizeGuide', e, url);
  $.ajax({
    url: url,
    success: function(data, status, xhr) {
      try {
        var qv = $('#quickview');
        qv.html(data);
        initQuickview();
      }
      catch (e) {
        console.log('error', e);
      }

      // try {
        // fbq('track', 'ViewContent');
      // }
      // catch (e) {}

      // try {
        // ga('send', {
        //   hitType: 'pageview',
        //   page: url
        // });
      // }
      // catch (e) {}

      // twq('track','ViewContent');

      // try {
        // pintrk('track', 'pagevisit');
        // console.log('pintrk', pintrk);
      // }
      // catch (e) {}

      if (!qv.hasClass('vis')) {
        qv.css('top', $(window).scrollTop() + 'px').fadeIn(500).addClass('vis');
        $('#quickview-screen').fadeIn(250).addClass('vis');
      }
    },
    error: function(data, status, xhr) {
      // alert('there was an error loading this product.');
    }
  });
}

initSizeChartPopup = function () {
   // console.log('initSizeChartPopup');
   $('#sizeChartTrigger').on('click', showSizeChart);
}

doQvClick = function (e) {
  e.preventDefault();
  e.stopImmediatePropagation();
  var url = $(e.target).closest('a').attr('href') + '?view=quickview';
  // console.log('doQvClick', e, url);
  $.ajax({
    url: url,
    success: function(data, status, xhr) {
      try {
        var qv = $('#quickview');
        qv.html(data);
        // ajaxCart.init({
        //  addToCartSelector : 'button[type="submit"]',
        //  moneyFormat : '$ {{ amount_no_decimals }}',
        //  enableQtySelectors : false
        // });
        // Take over the add to cart form submit action if ajax enabled
        ajaxCart.formOverride($('#AddToCartForm'));
        initSocialShareModals();
        // initWaitlistForm();
        initWaitlistModal();
      }
      catch (e) {
        // console.log('error', e);
      }

      // try {
        fbq('track', 'ViewContent');
      // }
      // catch (e) {}

      // try {
        ga('send', {
          hitType: 'pageview',
          page: url
        });
      // }
      // catch (e) {}

      twq('track','ViewContent');

      // try {
        pintrk('track', 'pagevisit');
        console.log('pintrk', pintrk);
      // }
      // catch (e) {}

      if (!qv.hasClass('vis')) {
        qv.css('top', $(window).scrollTop() + 'px').fadeIn(500).addClass('vis');
        $('#quickview-screen').fadeIn(250).addClass('vis');
      }
    },
    error: function(data, status, xhr) {
      // alert('there was an error loading this product.');
    }
  });

  // BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
}

doCloseQv = function (e) {
  if (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
  }
  // console.log('doCloseQv', e);
  document.onkeydown = null;
  $('#quickview-screen, #quickview').trigger('quickview.closing').fadeOut(500, function(e) {
    // console.log('doCloseQv - closing', e, this);
    $('body').css({'overflow': 'unset'});
    $('.site-header, .pick_currency').removeClass('hide');
    $('#cdr-slides').css({'overflow': 'hidden scroll'});
    $(this).css('top', '').removeClass('vis').removeClass('signup').removeClass('download').removeClass('waitlist').removeClass('ver-b').html('').trigger('quickview.closed');
    if (document.location.search.indexOf('waitlist') > -1) {
      document.location.search = '';
    }
  });
}

initQuickview = function() {
  // $('.btn.quickview, .thumb.quickview').on('click.quickview', doQvClick );
  var qv = $('#quickview');
  // qv.on('click.quickview', '#next-prev a', doQvClick );
  qv.on('click.quickview', '.close, .btn-close', doCloseQv );
  $('#quickview-screen').on('click.quickview', doCloseQv );
  $('body').on('ajaxCart.afterCartLoad', doCloseQv);
}

doBuyNow = function(e) {
  e.preventDefault();
  e.stopImmediatePropagation();
  var $target = $(e.target)
  document.location.href = "/cart/" + $target.data('variant_id') + ":" + $target.data('quantity');
}

initBuyNow = function() {
  $('.btn.buy-now').on('click.buynow', doBuyNow);
}

doAddToCart = function(e) {
  e.preventDefault();
  e.stopImmediatePropagation();
  var $target = $(e.target);
    console.log('doAddToCart', e,$target);
  document.location.href = "/cart/add?id=" + $target.data('variant_id') + "&quantity=" + $target.data('quantity');

  // $.ajax({
  //  type: "POST",
  //  url: "/cart/add.js",
  //  data: {
  //    'id[]': $target.data('variant_id'),
  //    'quantity[]': $target.data('quantity')
  //  },
  //  success: function(data, status, xhr) {
  //    console.log('success', data);
  //    document.location.href = "/cart";
  //  },
  //  error: function(data, status, xhr) {
  //    console.log('error', data);
  //    document.location.href = "/cart";
  //  }
  // });
}

initAddToCart = function() {
  $('.btn.add-to-cart').on('click.addtocart', doAddToCart);
}

initGiftSetForms = function() {
  ajaxCart.formOverride($('.gift-set-form'));
}

initHomeHeroScroll = function() {
  if ($('body').hasClass('template-index')) {
    var elem = $('body.template-index.index #PageContainer .home-title');

    elem.doReposition = function(e) {
      var newTop = (elem.startTop + $(window).scrollTop());
      if (newTop < 125)
        newTop = 125;
      elem.css('top', newTop + 'px');
    }

    $(window).resize(function (e) {
      elem.startTop = $(window).height() * 0.45;
      elem.doReposition();
    }).resize();

    $(document).on('scroll', elem.doReposition);
  }
}

initAltHome = function() {
  if ($('body').hasClass('index-stacked')) {
  // if ($('body').hasClass('index-stacked')) {
    var elem = $('#PageContainer .home-title');
    // var elem = $('body.index-stacked #PageContainer .home-title');
    elem.on('click', function(e) {
      document.location.href = $(this).find('a').attr('href');
    });
  }
}

initItemScroll = function() {
  $('#ProductDetails').css('position', 'relative');
  var startTop = $('#ProductDetails').position().top;
  $(document).on('scroll', function(e) {
    $('#ProductDetails').css('top', ($(window).scrollTop()) + 'px');
  });
}

initSocialShareModals = function() {
  $('#SocialShare a').on('click', function(e) {
    if (this.href.substring(0, 6) != 'mailto') {
      e.preventDefault();
      if (this.href.indexOf('pinterest') > 0)
        var dims = 'width=770,height=560';
      else
        var dims = 'width=600,height=350';
      window.open(this.href, 'sharer', 'top=' + (screen.height / 2) - 175 + ',left=' + (screen.width / 2) - 300 + ',toolbar=0,status=0,' + dims);
    }
  });
}

disableSignupOnClose = function(qv) {
  qv.on('quickview.closed', function (e) {
    var domain = document.location.hostname.split('.');
    var cookieName = 'signupSeen';
    if ($('#quickview.vis #EarlyAccessModal form').length) {
      var prod = "test";
      var sku = $('#ProductDetails').data('sku');
      if (sku) {
        cookieName = 'waitlistSeen_' + sku.replace(/ /g, '');
      }
    }
    domain = domain.slice(domain.length - 2, domain.length).join('.');
    // console.log('disableSignupOnClose', 'setting cookie', cookieName);
    Cookies.set(cookieName, 'true', { expires: 365, domain: domain, path: '/' });
    qv.off('quickview.closed');
  });
}

//resultMessage = "Thank you for signing up! Please confirm your subscription in your inbox.<br/>The winner will be announced on November 28th.";
showEmailSignupModal = function(mode) {
  if (event) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  var qv = $('#quickview'),
    ver = getQueryParams(document.location.search),
    emailModal = globalEmailModal,
    classes = 'signup',
    defaultVariant = 'a';
  var sendFile = $(this).data('send-file'),
    signupSource = $(this).data('source');

  ver = ver.v ? ver.v.toLowerCase() : defaultVariant;


  // don't show modal if it's already open.
  if (qv.hasClass('vis'))
    return false;

  if (sendFile || mode == "ethical-gifting-tips") {
    emailModal = globalEmailModalDownload;
  }
  else if (ver == 'h' || mode == "early-access") {
    emailModal = globalEmailModalEarlyAccess;
    classes += ' ver-h early-access';
  }
  else if (ver == 'a') {
    emailModal = globalEmailModal;
  }
  else if (ver == 'b') {
    emailModal = globalEmailModalB;
    classes += ' ver-b';
  }
  else if (ver == 'c') {
    emailModal = globalEmailModalCoupon;
    classes += ' ver-c';
  }
  else if (ver == 'd') {
    emailModal = globalWaitlistModal;
    classes += ' ver-d';
  }
  else if (ver == 'e') {
    emailModal = globalGiveawayModal;
    classes += ' ver-e';
  }
  else if (ver == 'f') {
    emailModal = globalEarlyAccessModal;
    classes += ' ver-f';
  }
  else if (ver == 'g') {
    emailModal = globalEmailModalBottom;
    classes += ' ver-g';
  }
  else if (ver == 'h') {
   emailModal = globalEmailModalMission50;
   classes += ' ver-h';
  }
  else if (ver == 'i' || ver == 'giveaway-thankyou') {
   emailModal = globalModalGiveawayThankyou;
   classes = 'ver-i giveaway-thankyou';
   document.body.classList.add('hide_attentive');
  }

  // console.log('classes', classes);

  // console.trace('showEmailSignupModal B', ver, mode, emailModal, classes);


  if(ver == "i" || ver == 'giveaway-thankyou') {

      // give away expired
      return false;

         var ver = getQueryParams(document.location.search);
         var email = ver.e;
         var utm_source = ver.utm_source;
         var friendList = 'SBf7Bg';
         var masterList = 'LkacF3';

         if (typeof(email) !== 'undefined') {

             email = email.replace(' ', '+');

             if (typeof(utm_source) === 'undefined') {

             }

             masterFields = {
               'g': masterList,
               '$fields': '$source,$email,FriendOptIn,Source,$consent_method,$consent_form_id,$consent_form_version',
               '$list_fields': '',
               '$source': 'Labor Day Giveaway for Friends',
               '$email': email,
               'FriendOptIn': 'Clicked Email',
               'Source': 'Clicked Friend Invite Email Subscribe',
               '$consent_method': 'Klaviyo Form',
               '$consent_form_id': 'PcnAqw',
               '$consent_form_version': '516306'
            };

             friendFields = {
               g: friendList,
               '$fields': '$source,$email,FriendOptIn,Source,$consent_method,$consent_form_id,$consent_form_version',
               '$list_fields': '',
               '$source': 'Labor Day Giveaway for Friends',
               '$email': email,
               'FriendOptIn': 'Clicked Email',
               'Source': 'Clicked Friend Invite Email Subscribe',
               '$consent_method': 'Klaviyo Form',
               '$consent_form_id': 'VhTFuv',
               '$consent_form_version': '3589645'
             };
             
             console.log('friend subscribe');

             $.ajax({
               method: 'POST',
               url: '//manage.kmail-lists.com/ajax/subscriptions/subscribe',
               data: masterFields,
               timeout: 5000,
               success: function(data, status, xhr) {
                  console.log('friend subscribe success', data, status, xhr);
                 

                $.ajax({
                  method: 'POST',
                  url: '//manage.kmail-lists.com/ajax/subscriptions/subscribe',
                  data: friendFields,
                  timeout: 5000,
                  success: function(data, status, xhr) {
                     console.log('master subscribe success', data, status, xhr);
                     qv.load(
                      emailModal,
                      '',
                      function(data, status, xhr) {

                        disableSignupOnClose(qv);

                        if (!qv.hasClass('vis')) {
                          if (ver != 'g' ) {
                            var qvTop = $(window).scrollTop() + ($(window).height()/2) - 300;
                            if (qvTop < 0) qvTop = 0;
                            qv.css('top', qvTop + 'px');
                          }
                          qv.fadeIn(500).removeClass('ver-g').addClass('vis ' + classes);
                          $('#quickview-screen').fadeIn(250).addClass('signup vis ' + classes);
                        }
                      }
                    );

                    return true;
                  }
                });


                 return true;
               }
             });


         }


  }
  else {


     qv.load(
       emailModal,
       '',
       function(data, status, xhr) {

         try {
           // initNewsletterForms(mode);
           initModalNewsletterForm(mode);

           if (signupSource && signupSource.length)
             $('input[name="SOURCE"]', qv).val(signupSource);

           if (sendFile) {
             $('form', qv).data('send-file', sendFile);
             classes = 'download';
           }

           disableSignupOnClose(qv);
         }
         catch (e) {
           console.log('error', e);
         }
         if (!qv.hasClass('vis')) {
           if (ver != 'g' ) {
             var qvTop = $(window).scrollTop() + ($(window).height()/2) - 300;
             if (qvTop < 0) qvTop = 0;
             qv.css('top', qvTop + 'px');
           }
           qv.fadeIn(500).removeClass('ver-g').addClass('vis ' + classes);
           $('#quickview-screen').fadeIn(250).addClass('signup vis ' + classes);
         }
       }
     );
   

  }

}

klaviyoSignupSuccess = function($form) {
    // console.log('klaviyoSignupSuccess callback', $form, event);
    var _event = event;
    setTimeout( function(event) {
        // console.log('klaviyoSignupSuccess timeout', $form, _event);
        doCloseQv(_event);
    }, 3000);
}

showDownloadEmailGate = function() {
  // console.log('showDownloadEmailGate');
  if ($('body#ethical-gifting-tips, body#20-ethically-minded-summer-travel-tips').length) {

        var gate = true;
        var submitted = false;
        var queryParams = getQueryParams(document.location.search);

        if (queryParams.vhea == 'true' || queryParams.gate == 'false' || queryParams.utm_medium == 'email') {
            var domain = document.location.hostname.split('.');
            domain = domain.slice(domain.length - 2, domain.length).join('.');
            Cookies.set('vhea', 'true', { expires: 365, domain: domain, path: '/' });
            Cookies.set('signupSeen', 'true', { expires: 365, domain: domain, path: '/' });
            Cookies.set('dlgate2', 'true', { expires: 365, domain: domain, path: '/' });
            gate = false;
        }

        var seen = Cookies.get('vhea');
        var submitted = Cookies.get('dlgate2');

        // console.log('queryParams', queryParams, 'seen', seen, 'gate', gate, 'submitted', submitted);

        if (queryParams.vhea == 'false' || queryParams.gate == 'true') {
            gate = true;
            seen = false;
            submitted == false;
        }

    if (gate || submitted) {
      $('#TenTips').removeClass('blurred');
      $('#TenTipsDownload').removeClass('hidden');
    }
    else {
      $('#TenTips').addClass('blurred');
      $('#TenTipsDownload').addClass('hidden');
      showEmailSignupModal.bind(this, "ethical-gifting-tips")();
      $('#quickview-screen').off('click.quickview');
    }
  }
}

showSampleSaleEmailGate = function() {
   // console.log('showSampleSaleEmailGate');

   setSignupSeenCookies = function () {
      Cookies.set('vhss', 'true', { expires: 365, domain: domain, path: '/' });
      Cookies.set('signupSeen', 'true', { expires: 365, domain: domain, path: '/' });
      console.log('setting cookies', Cookies.get('vhss'), Cookies.get('signupSeen'));
      seen = Cookies.get('vhss') || false;
   }

   var domain = document.location.hostname.split('.');
   domain = domain.slice(domain.length - 2, domain.length).join('.');

   var gate = true;
   var registered = false;
   var registeredEmail = false;
   var registeredSMS = false;
   var queryParams = getQueryParams(document.location.search);
   // console.log('queryParams', queryParams, typeof(queryParams.externalId), queryParams.externalId != '');

   if (queryParams.vhss == 'true' || queryParams.utm_medium == 'email' || queryParams.utm_medium == 'text' || queryParams.utm_source == 'attentive' || typeof(queryParams.externalId) !== 'undefined') {
      Cookies.set('vhss', 'true', { expires: 365, domain: domain, path: '/' });
      Cookies.set('signupSeen', 'true', { expires: 365, domain: domain, path: '/' });
      gate = false;
   }

   var seen = Cookies.get('vhss') || false;
   
   if (seen) {
      gate = false;
   }

   // if ($('body#early-access').length || document.location.pathname.indexOf('early-access') >= 0) {
   if (document.querySelectorAll('body#sample-sale').length || document.location.pathname.indexOf('sample-sale') >= 0) {

      var handleSignupSuccess = function() {
         const url = null;
         const timeout = 3000;
         setSignupSeenCookies();
         $('#PageContainer').removeClass('blurred');
         setTimeout(() => {
            window.__attentive.hide();
         }, timeout);
      }

      var handleSignupFailure = function() {
         const url = '/';
         $('#PageContainer').addClass('blurred');
         document.location.href = url;
      }

      var doBlur = function() {
         $('#PageContainer').addClass('blurred');
      }

      var forcePopup = function () {
         console.log('forcePopup');
         // $('#PageContainer').addClass('blurred');
         // showEmailSignupModal.bind(this, "early-access")();
         // $('#quickview-screen').off('click').off('click.quickview');

         window._klOnsite = window._klOnsite || [];
         window._klOnsite.push(['openForm', window.current_klaviyo_form_d2c]);
         Cookies.set('signupSeen', 'true', { expires: 365, domain: domain, path: '/' });


         // let CREATIVE_ID = window.innerWidth > 850 ? 210943 : 210944; // desktop : mobile - sample sale evergreen
         // let CREATIVE_ID = window.innerWidth > 850 ? 210869 : 210887; // desktop : mobile - sample sale, sale
         let CREATIVE_ID = window.innerWidth > 850 ? 216275 : 216268; // desktop : mobile - current sample sale

         /*let attentiveTrigger = setInterval( () => {
            console.log('window.__attentive', window.__attentive);
            if (window.__attentive && window.__attentive.trigger) {
               window.__attentive.trigger(null,null,null,CREATIVE_ID);
               console.log('triggering window.__attentive');
               // Cookies.set('vhss', 'true', { expires: 365, domain: domain, path: '/' });
               Cookies.set('signupSeen', 'true', { expires: 365, domain: domain, path: '/' });
               clearInterval(attentiveTrigger);
            }
         }, 50);*/
      }

      // console.log('queryParams =', queryParams, 'seen =', seen, 'gate =', gate);

      // var code = Cookies.get('_promo_coupon');
      // var saleSeen = Cookies.get('saleSeen');
      // if (code === 'VONHOLIDAY') {
      //   seen = true;
      // }

      if (queryParams.vhss == 'false') {
         gate = true;
         seen = false;
      }

      console.log('pre interval', 'seen', seen, 'gate', gate);

      if (seen || !gate) {
         $('#PageContainer').removeClass('blurred');
      }
      else {
         forcePopup();
      }

   }

   else {

      var handleSignupSuccess = function() {
         // all other pages -- disabled post-sample-sale
         // const url = '/collections/sample-sale';
         // const timeout = 3000;
         // setSignupSeenCookies();
         // $('#PageContainer').removeClass('blurred');
         // setTimeout(() => {
         //    window.__attentive.hide();
         //    if (url) {
         //       document.location.href = url;
         //    }
         // }, timeout);
      }


      var handleSignupFailure = function() {
         return false;
      }


      var doBlur = function() {
         return false;
      }


      var forcePopup = function () {
         return false;
      }


   }

   window.addEventListener("message", (event) => {
      // console.log('showSampleSaleEmailGate', 'message.event', event);
      if (event.origin.indexOf('attn') > 0 && event.data && event.data.__attentive) {
         // console.log('seen:', seen, 'gate:', gate, 'registered:', registered);
         // console.log('attn', event.data.__attentive.action, event.data.__attentive);
         switch (event.data.__attentive.action) {
            case "DETECT_EXIT_INTENT":
               // creativeType: "DESKTOP"
               // isBubbleCreative: true
               // console.log('creativeType', event.data.__attentive.creativeType, 'isBubbleCreative', event.data.__attentive.isBubbleCreative);
               break;
            case "IMPRESSION":
               // creativeId: "216276"
               // console.log('creativeId', event.data.__attentive.creativeId);
               break;
            case "EXPAND":
               //Statements executed when the
               //result of expression matches value1
               //creativeId: "216276"
               // console.log('creativeId', event.data.__attentive.creativeId);
               break;
            case "OPEN":
               //Statements executed when the
               //result of expression matches value2
               // layout: "fullscreen"
               // pageType: "field_capture"
               // ||
               // layout: "fullscreen"
               // pageType: "success"
               if (event.data.__attentive.pageType == "field_capture") {
                  if (registeredSMS) {
                    handleSignupSuccess();
                  }
                  else {
                     doBlur();
                  }
               }
               else if (event.data.__attentive.pageType == "bubble") {
                  if (registeredSMS) {
                     handleSignupSuccess();
                  }
                  else if (gate) {
                     forcePopup();
                  }
               }
               else if (event.data.__attentive.pageType == "success") {
                  handleSignupSuccess();
               }
               // console.log('layout', event.data.__attentive.layout, 'pageType', event.data.__attentive.pageType);
               break;
            case "EMAIL_LEAD":
               // creativeId: "216276"
               // email: "jonah@creori.com"
               // visitorId: "150a1fa592c24c539f0e3b4c03bf94a2"
               registered = true;
               registeredEmail = true;
               setSignupSeenCookies();
               break;
            case "LEAD":
               // anonymousId: ""
               // attentiveAPI: "https://api.attentivemobile.com"
               // attnDomain: "vonholz.attn.tv"
               // companyExternalId: "LJD"
               // creativeId: "216276"
               // email: "jonah@creori.com"
               // encodedSubscriberExternalId: "0"
               // environment: "prod"
               // impressionId: "0"
               // mobile: false
               // pageview: "2"
               // pageviewRuleLowerBound: undefined
               // phone: "(805) 570-1140"
               // sourceUrl: "https://vonholzhausen.com/"
               // templateId: 5
               // userId: "150a1fa592c24c539f0e3b4c03bf94a2"
               // visitorId: "150a1fa592c24c539f0e3b4c03bf94a2"
               registered = true;
               registeredSMS = true;
               setSignupSeenCookies();
               break;
            case "CLOSE":
               // closeType: undefined
               // creativeId: "216276"
               if (registered) {
                  handleSignupSuccess();
               }
               else {
                  handleSignupFailure();
               }
               // console.log('closeType', event.data.__attentive.closeType, 'creativeId', event.data.__attentive.creativeId, 'registered', registered);
               break;
            case "SHRINK":
               // creativeId: "216276"
               if (registered) {
                  handleSignupSuccess();
               }
               else if (seen) {
                  $('#PageContainer').removeClass('blurred');
               }
               else if (gate) {
                  handleSignupFailure();
               }
               break;
            default:
               //Statements executed when none of
               //the values match the value of the expression
               // console.log('default');
               break;
         }
      }

   }, false);

   return;
   //////////// ending here /////////////////
   if (document.querySelectorAll('body#sample-sale').length || document.location.pathname.indexOf('sample-sale') >= 0) {

      var shown = false;

     waitForAttentive = setInterval(function () {
       let op1a = $("#attentive_creative[style*='opacity: 1']");
       let op1b = $("#attentive_creative[style*='width: 100%']");
       let op0a = $("#attentive_creative[style*='opacity: 0']");
       let op0b = $("#attentive_creative[style*='bottom: 16px']");

       if(op1a.length && op1b.length) {
         $('#PageContainer').addClass('blurred');

         // document.querySelector('#attentive_creative').addEventListener('click', e => {
         //    e.preventDefault();
         //    e.stopImmediatePropagation();
         //    console.log('clicked #attentive_creative', e);
         // });

         shown = true;
       }
       else if(op0a.length && !op0b.length) {
         if (shown) {
            $('#PageContainer').removeClass('blurred');
            clearInterval(waitForAttentive);
         }
       }
     }, 500);

  }
}

show12DaysEmailGate = function() {
   console.log('show12DaysEmailGate');

   setSignupSeenCookies = function () {
      Cookies.set('vh12days', 'true', { expires: 30, domain: domain, path: '/' });
      console.log('setting cookies', Cookies.get('vh12days'), Cookies.get('signupSeen'));
      seen = Cookies.get('vh12days') || false;
   }

   var domain = document.location.hostname.split('.');
   domain = domain.slice(domain.length - 2, domain.length).join('.');

   var gate = true;
   var registered = false;
   var registeredEmail = false;
   var registeredSMS = false;
   var queryParams = getQueryParams(document.location.search);
   // console.log('queryParams', queryParams, typeof(queryParams.externalId), queryParams.externalId != '');

   if (queryParams.vh12days == 'true' || queryParams.utm_medium == 'email' || queryParams.utm_medium == 'text' || queryParams.utm_source == 'attentive' || typeof(queryParams.externalId) !== 'undefined') {
      Cookies.set('vh12days', 'true', { expires: 365, domain: domain, path: '/' });
      // Cookies.set('signupSeen', 'true', { expires: 365, domain: domain, path: '/' });
      gate = false;
   }

   var seen = Cookies.get('vh12days') || false;
   
   if (seen) {
      gate = false;
   }


   if (document.querySelectorAll('body#shop.page-shop').length) {

      var handleSignupSuccess = function() {
         const url = null;
         const timeout = 2000;
         setSignupSeenCookies();
         // $('#PageContainer').removeClass('blurred');
         setTimeout(() => {
            window.__attentive.hide();
         }, timeout);
      }

      // var handleSignupFailure = function() {
      //    const url = '/';
      //    $('#PageContainer').addClass('blurred');
      //    document.location.href = url;
      // }

      // var doBlur = function() {
      //    $('#PageContainer').addClass('blurred');
      // }

      var handleSignupFailure = function() {
         return false;
      }

      var doBlur = function() {
         return false;
      }


      // var forcePopup = function () {
      //    return false;
      // }

      var forcePopup = function () {
         console.log('forcePopup');
         // $('#PageContainer').addClass('blurred');
         // showEmailSignupModal.bind(this, "early-access")();
         // $('#quickview-screen').off('click').off('click.quickview');

         window._klOnsite = window._klOnsite || [];
         window._klOnsite.push(['openForm', window.current_klaviyo_form_d2c]);
         Cookies.set('signupSeen', 'true', { expires: 365, domain: domain, path: '/' });


         // let CREATIVE_ID = window.innerWidth > 850 ? 210943 : 210944; // desktop : mobile - sample sale evergreen
         // let CREATIVE_ID = window.innerWidth > 850 ? 210869 : 210887; // desktop : mobile - sample sale, sale
         // let CREATIVE_ID = window.innerWidth > 850 ? 216275 : 216268; // desktop : mobile - current sample sale
         let CREATIVE_ID = window.innerWidth > 850 ? 942127 : 942126 //  desktop : mobile - Holiday: 12 Days

         /*let attentiveTrigger = setInterval( () => {
            console.log('window.__attentive', window.__attentive);
            if (window.__attentive && window.__attentive.trigger) {
               window.__attentive.trigger(null,null,null,CREATIVE_ID);
               console.log('triggering window.__attentive');
               Cookies.set('vh12days', 'true', { expires: 365, domain: domain, path: '/' });
               // Cookies.set('signupSeen', 'true', { expires: 365, domain: domain, path: '/' });
               clearInterval(attentiveTrigger);
            }
         }, 50);*/
      }

      // console.log('queryParams =', queryParams, 'seen =', seen, 'gate =', gate);

      // var code = Cookies.get('_promo_coupon');
      // var saleSeen = Cookies.get('saleSeen');
      // if (code === 'VONHOLIDAY') {
      //   seen = true;
      // }

      if (queryParams.vh12days == 'false') {
         gate = true;
         seen = false;
      }

      // console.log('pre interval', 'seen', seen, 'gate', gate);

      if (seen || !gate) {
         $('#PageContainer').removeClass('blurred');
      }
      else {
         forcePopup();
      }

   }

   window.addEventListener("message", (event) => {
      // console.log('show12DaysEmailGate', 'message.event', event);
      if (event.origin.indexOf('attn') > 0 && event.data && event.data.__attentive) {
         // console.log('seen:', seen, 'gate:', gate, 'registered:', registered);
         // console.log('attn', event.data.__attentive.action, event.data.__attentive);
         switch (event.data.__attentive.action) {
            case "DETECT_EXIT_INTENT":
               // creativeType: "DESKTOP"
               // isBubbleCreative: true
               // console.log('creativeType', event.data.__attentive.creativeType, 'isBubbleCreative', event.data.__attentive.isBubbleCreative);
               break;
            case "IMPRESSION":
               // creativeId: "216276"
               // console.log('creativeId', event.data.__attentive.creativeId);
               break;
            case "EXPAND":
               //Statements executed when the
               //result of expression matches value1
               //creativeId: "216276"
               // console.log('creativeId', event.data.__attentive.creativeId);
               break;
            case "OPEN":
               //Statements executed when the
               //result of expression matches value2
               // layout: "fullscreen"
               // pageType: "field_capture"
               // ||
               // layout: "fullscreen"
               // pageType: "success"
               if (event.data.__attentive.pageType == "field_capture") {
                  if (registeredSMS) {
                    handleSignupSuccess();
                  }
                  else {
                     doBlur();
                  }
               }
               else if (event.data.__attentive.pageType == "bubble") {
                  if (registeredSMS) {
                     handleSignupSuccess();
                  }
                  else if (gate) {
                     forcePopup();
                  }
               }
               else if (event.data.__attentive.pageType == "success") {
                  handleSignupSuccess();
               }
               // console.log('layout', event.data.__attentive.layout, 'pageType', event.data.__attentive.pageType);
               break;
            case "EMAIL_LEAD":
               // creativeId: "216276"
               // email: "jonah@creori.com"
               // visitorId: "150a1fa592c24c539f0e3b4c03bf94a2"
               registered = true;
               registeredEmail = true;
               setSignupSeenCookies();
               break;
            case "LEAD":
               // anonymousId: ""
               // attentiveAPI: "https://api.attentivemobile.com"
               // attnDomain: "vonholz.attn.tv"
               // companyExternalId: "LJD"
               // creativeId: "216276"
               // email: "jonah@creori.com"
               // encodedSubscriberExternalId: "0"
               // environment: "prod"
               // impressionId: "0"
               // mobile: false
               // pageview: "2"
               // pageviewRuleLowerBound: undefined
               // phone: "(805) 570-1140"
               // sourceUrl: "https://vonholzhausen.com/"
               // templateId: 5
               // userId: "150a1fa592c24c539f0e3b4c03bf94a2"
               // visitorId: "150a1fa592c24c539f0e3b4c03bf94a2"
               registered = true;
               registeredSMS = true;
               setSignupSeenCookies();
               break;
            case "CLOSE":
               // closeType: undefined
               // creativeId: "216276"
               if (registered) {
                  handleSignupSuccess();
               }
               else {
                  handleSignupFailure();
               }
               // console.log('closeType', event.data.__attentive.closeType, 'creativeId', event.data.__attentive.creativeId, 'registered', registered);
               break;
            case "SHRINK":
               // creativeId: "216276"
               if (registered) {
                  handleSignupSuccess();
               }
               else if (seen) {
                  $('#PageContainer').removeClass('blurred');
               }
               else if (gate) {
                  handleSignupFailure();
               }
               break;
            default:
               //Statements executed when none of
               //the values match the value of the expression
               // console.log('default');
               break;
         }
      }

   }, false);

   return;
   //////////// ending here /////////////////
   if (document.querySelectorAll('body#sample-sale').length || document.location.pathname.indexOf('sample-sale') >= 0) {

      var shown = false;

     waitForAttentive = setInterval(function () {
       let op1a = $("#attentive_creative[style*='opacity: 1']");
       let op1b = $("#attentive_creative[style*='width: 100%']");
       let op0a = $("#attentive_creative[style*='opacity: 0']");
       let op0b = $("#attentive_creative[style*='bottom: 16px']");

       if(op1a.length && op1b.length) {
         $('#PageContainer').addClass('blurred');

         // document.querySelector('#attentive_creative').addEventListener('click', e => {
         //    e.preventDefault();
         //    e.stopImmediatePropagation();
         //    console.log('clicked #attentive_creative', e);
         // });

         shown = true;
       }
       else if(op0a.length && !op0b.length) {
         if (shown) {
            $('#PageContainer').removeClass('blurred');
            clearInterval(waitForAttentive);
         }
       }
     }, 500);

  }
}

doEarlyAccessEmailRedirect = function() {

   // disabled below, not called
   console.log('doEarlyAccessEmailRedirect');

   setSignupSeenCookies = function () {
      Cookies.set('vhea', 'true', { expires: 365, domain: domain, path: '/' });
      Cookies.set('signupSeen', 'true', { expires: 365, domain: domain, path: '/' });
      console.log('setting cookies - ea', Cookies.get('vhea'), Cookies.get('signupSeen'));
      seen = Cookies.get('vhea') || false;
   }

   var domain = document.location.hostname.split('.');
   domain = domain.slice(domain.length - 2, domain.length).join('.');

   var gate = true;
   var registered = false;
   var registeredEmail = false;
   var registeredSMS = false;
   var queryParams = getQueryParams(document.location.search);
   // console.log('queryParams', queryParams, typeof(queryParams.externalId), queryParams.externalId != '');

   if (queryParams.vhea == 'true' || queryParams.utm_medium == 'email' || queryParams.utm_medium == 'text' || queryParams.utm_source == 'attentive' || queryParams.utm_source == 'facebook' || typeof(queryParams.externalId) !== 'undefined') {
      Cookies.set('vhea', 'true', { expires: 365, domain: domain, path: '/' });
      Cookies.set('signupSeen', 'true', { expires: 365, domain: domain, path: '/' });
      gate = false;
   }

   var seen = Cookies.get('vhea') || false;
   
   if (seen) {
      gate = false;
   }

   if (document.location.pathname.indexOf('sample-sale') >= 0) {
      console.log('skipping doEarlyAccessEmailRedirect');
      return;
   }

   if ($('body#early-access').length || document.location.pathname.indexOf('early-access') >= 0 || $('body#the-design-lab').length || document.location.pathname.indexOf('design-lab') >= 0) {
   // if (document.querySelectorAll('body#sample-sale').length || document.location.pathname.indexOf('sample-sale') >= 0) {

      return; // not using this path due to custom EA popup.

      var handleSignupSuccess = function() {
         const url = null;
         const timeout = 3000;
         setSignupSeenCookies();
         $('#PageContainer').removeClass('blurred');
         setTimeout(() => {
            window.__attentive.hide();
         }, timeout);
      }

      var handleSignupFailure = function() {
         const url = '/';
         $('#PageContainer').addClass('blurred');
         document.location.href = url;
      }

      var doBlur = function() {
         $('#PageContainer').addClass('blurred');
      }

      var forcePopup = function () {
         console.log('forcePopup');
         // $('#PageContainer').addClass('blurred');
         // showEmailSignupModal.bind(this, "early-access")();
         // $('#quickview-screen').off('click').off('click.quickview');

         window._klOnsite = window._klOnsite || [];
         window._klOnsite.push(['openForm', window.current_klaviyo_form_d2c]);
         Cookies.set('signupSeen', 'true', { expires: 365, domain: domain, path: '/' });

         // let CREATIVE_ID = window.innerWidth > 850 ? 210943 : 210944; // desktop : mobile - sample sale evergreen
         // let CREATIVE_ID = window.innerWidth > 850 ? 210869 : 210887; // desktop : mobile - sample sale, sale
         let CREATIVE_ID = window.innerWidth > 850 ? 216275 : 216268; // desktop : mobile - current sample sale

         /*let attentiveTrigger = setInterval( () => {
            console.log('window.__attentive', window.__attentive);
            if (window.__attentive && window.__attentive.trigger) {
               window.__attentive.trigger(null,null,null,CREATIVE_ID);
               console.log('triggering window.__attentive');
               // Cookies.set('vhea', 'true', { expires: 365, domain: domain, path: '/' });
               Cookies.set('signupSeen', 'true', { expires: 365, domain: domain, path: '/' });
               clearInterval(attentiveTrigger);
            }
         }, 50);*/
      }

      // console.log('queryParams =', queryParams, 'seen =', seen, 'gate =', gate);

      // var code = Cookies.get('_promo_coupon');
      // var saleSeen = Cookies.get('saleSeen');
      // if (code === 'VONHOLIDAY') {
      //   seen = true;
      // }

      if (queryParams.vhea == 'false') {
         gate = true;
         seen = false;
      }

      console.log('pre interval', 'seen', seen, 'gate', gate);

      if (seen || !gate) {
         $('#PageContainer').removeClass('blurred');
      }
      else {
         forcePopup();
      }

   }

   else {
      // all other pages

      var handleSignupSuccess = function() {
         return false;
         // Not needed for shoe ea.
         // const url = '/collections/design-lab';
         // const timeout = 3000;
         // setSignupSeenCookies();
         // $('#PageContainer').removeClass('blurred');
         // setTimeout(() => {
         //    window.__attentive.hide();
         //    if (url) {
         //       console.trace('handleSignupSuccess', url);
         //       document.location.href = url;
         //    }
         // }, timeout);
      }


      var handleSignupFailure = function() {
         return false;
      }


      var doBlur = function() {
         return false;
      }


      var forcePopup = function () {
         return false;
      }

   }

   window.addEventListener("message", (event) => {
      // console.log('doEarlyAccessEmailRedirect', 'message.event', event);
      if (event.origin.indexOf('attn') > 0 && event.data && event.data.__attentive) {
         // console.log('seen:', seen, 'gate:', gate, 'registered:', registered);
         // console.log('attn', event.data.__attentive.action, event.data.__attentive);
         switch (event.data.__attentive.action) {
            case "DETECT_EXIT_INTENT":
               // creativeType: "DESKTOP"
               // isBubbleCreative: true
               // console.log('creativeType', event.data.__attentive.creativeType, 'isBubbleCreative', event.data.__attentive.isBubbleCreative);
               break;
            case "IMPRESSION":
               // creativeId: "216276"
               // console.log('creativeId', event.data.__attentive.creativeId);
               break;
            case "EXPAND":
               //Statements executed when the
               //result of expression matches value1
               //creativeId: "216276"
               // console.log('creativeId', event.data.__attentive.creativeId);
               break;
            case "OPEN":
               //Statements executed when the
               //result of expression matches value2
               // layout: "fullscreen"
               // pageType: "field_capture"
               // ||
               // layout: "fullscreen"
               // pageType: "success"
               if (event.data.__attentive.pageType == "field_capture") {
                  if (registeredSMS) {
                    handleSignupSuccess();
                  }
                  else {
                     doBlur();
                  }
               }
               else if (event.data.__attentive.pageType == "bubble") {
                  if (registeredSMS) {
                     handleSignupSuccess();
                  }
                  else if (gate) {
                     forcePopup();
                  }
               }
               else if (event.data.__attentive.pageType == "success") {
                  handleSignupSuccess();
               }
               // console.log('layout', event.data.__attentive.layout, 'pageType', event.data.__attentive.pageType);
               break;
            case "EMAIL_LEAD":
               // creativeId: "216276"
               // email: "jonah@creori.com"
               // visitorId: "150a1fa592c24c539f0e3b4c03bf94a2"
               registered = true;
               registeredEmail = true;
               setSignupSeenCookies();
               break;
            case "LEAD":
               // anonymousId: ""
               // attentiveAPI: "https://api.attentivemobile.com"
               // attnDomain: "vonholz.attn.tv"
               // companyExternalId: "LJD"
               // creativeId: "216276"
               // email: "jonah@creori.com"
               // encodedSubscriberExternalId: "0"
               // environment: "prod"
               // impressionId: "0"
               // mobile: false
               // pageview: "2"
               // pageviewRuleLowerBound: undefined
               // phone: "(805) 570-1140"
               // sourceUrl: "https://vonholzhausen.com/"
               // templateId: 5
               // userId: "150a1fa592c24c539f0e3b4c03bf94a2"
               // visitorId: "150a1fa592c24c539f0e3b4c03bf94a2"
               registered = true;
               registeredSMS = true;
               setSignupSeenCookies();
               break;
            case "CLOSE":
               // closeType: undefined
               // creativeId: "216276"
               if (registered) {
                  handleSignupSuccess();
               }
               else {
                  handleSignupFailure();
               }
               // console.log('closeType', event.data.__attentive.closeType, 'creativeId', event.data.__attentive.creativeId, 'registered', registered);
               break;
            case "SHRINK":
               // creativeId: "216276"
               if (registered) {
                  handleSignupSuccess();
               }
               else if (seen) {
                  $('#PageContainer').removeClass('blurred');
               }
               else if (gate) {
                  handleSignupFailure();
               }
               break;
            default:
               //Statements executed when none of
               //the values match the value of the expression
               // console.log('default');
               break;
         }
      }

   }, false);

   return;
   //////////// ending here /////////////////

   if (document.querySelectorAll('body#sample-sale').length || document.location.pathname.indexOf('sample-sale') >= 0) {

      var shown = false;

     waitForAttentive = setInterval(function () {
       let op1a = $("#attentive_creative[style*='opacity: 1']");
       let op1b = $("#attentive_creative[style*='width: 100%']");
       let op0a = $("#attentive_creative[style*='opacity: 0']");
       let op0b = $("#attentive_creative[style*='bottom: 16px']");

       if(op1a.length && op1b.length) {
         $('#PageContainer').addClass('blurred');

         // document.querySelector('#attentive_creative').addEventListener('click', e => {
         //    e.preventDefault();
         //    e.stopImmediatePropagation();
         //    console.log('clicked #attentive_creative', e);
         // });

         shown = true;
       }
       else if(op0a.length && !op0b.length) {
         if (shown) {
            $('#PageContainer').removeClass('blurred');
            clearInterval(waitForAttentive);
         }
       }
     }, 500);

  }
}



doBalletFlatEmailRedirect = function() {

   // disabled - not called

   console.log('doBalletFlatEmailRedirect');

   setSignupSeenCookies = function () {
      Cookies.set('vhbf', 'true', { expires: 365, domain: domain, path: '/' });
      Cookies.set('signupSeen', 'true', { expires: 365, domain: domain, path: '/' });
      console.log('setting cookies - bf', Cookies.get('vhbf'), Cookies.get('signupSeen'));
      seen = Cookies.get('vhbf') || false;
   }

   var domain = document.location.hostname.split('.');
   domain = domain.slice(domain.length - 2, domain.length).join('.');

   var gate = true;
   var registered = false;
   var registeredEmail = false;
   var registeredSMS = false;
   var queryParams = getQueryParams(document.location.search);
   // console.log('queryParams', queryParams, typeof(queryParams.externalId), queryParams.externalId != '');

   if (queryParams.vhbf == 'true' || queryParams.utm_medium == 'email' || queryParams.utm_medium == 'text' || queryParams.utm_source == 'attentive' || queryParams.utm_source == 'facebook' || typeof(queryParams.externalId) !== 'undefined') {
      Cookies.set('vhbf', 'true', { expires: 365, domain: domain, path: '/' });
      Cookies.set('signupSeen', 'true', { expires: 365, domain: domain, path: '/' });
      gate = false;
   }

   var seen = Cookies.get('vhbf') || false;
   
   if (seen) {
      gate = false;
   }

   if (document.location.pathname.indexOf('sample-sale') >= 0) {
      console.log('skipping doBalletFlatEmailRedirect');
      return;
   }

   if (document.querySelector("body[id*='the-ballet-flat'].template-product") || document.location.pathname.indexOf('products/the-ballet-flat') >= 0) {
   // if (document.querySelectorAll('body#sample-sale').length || document.location.pathname.indexOf('sample-sale') >= 0) {

      //return; // not using this path due to custom EA popup.

      var handleSignupSuccess = function() {
         const url = null;
         const timeout = 3000;
         setSignupSeenCookies();
         $('#PageContainer').removeClass('blurred');
         setTimeout(() => {
            window.__attentive.hide();
         }, timeout);
      }

      var handleSignupFailure = function() {
         const url = '/';
         $('#PageContainer').addClass('blurred');
         document.location.href = url;
      }

      var doBlur = function() {
         $('#PageContainer').addClass('blurred');
      }

      var forcePopup = function () {
         console.log('forcePopup');
         // $('#PageContainer').addClass('blurred');
         // showEmailSignupModal.bind(this, "early-access")();
         // $('#quickview-screen').off('click').off('click.quickview');

         window._klOnsite = window._klOnsite || [];
         window._klOnsite.push(['openForm', window.current_klaviyo_form_d2c]);
         Cookies.set('signupSeen', 'true', { expires: 365, domain: domain, path: '/' });

         // let CREATIVE_ID = window.innerWidth > 850 ? 210943 : 210944; // desktop : mobile - sample sale evergreen
         // let CREATIVE_ID = window.innerWidth > 850 ? 210869 : 210887; // desktop : mobile - sample sale, sale
         // let CREATIVE_ID = window.innerWidth > 850 ? 216275 : 216268; // desktop : mobile - current sample sale
         let CREATIVE_ID = window.innerWidth > 850 ? 247960 : 247962; // desktop : mobile - ballet flat early access

         /*let attentiveTrigger = setInterval( () => {
            console.log('window.__attentive', window.__attentive);
            if (window.__attentive && window.__attentive.trigger) {
               window.__attentive.trigger(null,null,null,CREATIVE_ID);
               console.log('triggering window.__attentive');
               // Cookies.set('vhbf', 'true', { expires: 365, domain: domain, path: '/' });
               Cookies.set('signupSeen', 'true', { expires: 365, domain: domain, path: '/' });
               clearInterval(attentiveTrigger);
            }
         }, 50);*/
      }

      // console.log('queryParams =', queryParams, 'seen =', seen, 'gate =', gate);

      // var code = Cookies.get('_promo_coupon');
      // var saleSeen = Cookies.get('saleSeen');
      // if (code === 'VONHOLIDAY') {
      //   seen = true;
      // }

      if (queryParams.vhbf == 'false') {
         gate = true;
         seen = false;
      }

      console.log('pre interval', 'seen', seen, 'gate', gate);

      if (seen || !gate) {
         $('#PageContainer').removeClass('blurred');
      }
      else {
         forcePopup();
      }

   }

   else {
      // all other pages

      return; // only show popup on PDPs

      var handleSignupSuccess = function() {
         return false;
         // Not needed for shoe ea.
         // const url = '/collections/design-lab';
         // const timeout = 3000;
         // setSignupSeenCookies();
         // $('#PageContainer').removeClass('blurred');
         // setTimeout(() => {
         //    window.__attentive.hide();
         //    if (url) {
         //       console.trace('handleSignupSuccess', url);
         //       document.location.href = url;
         //    }
         // }, timeout);
      }


      var handleSignupFailure = function() {
         return false;
      }


      var doBlur = function() {
         return false;
      }


      var forcePopup = function () {
         return false;
      }

   }

   window.addEventListener("message", (event) => {
      // console.log('doEarlyAccessEmailRedirect', 'message.event', event);
      if (event.origin.indexOf('attn') > 0 && event.data && event.data.__attentive) {
         // console.log('seen:', seen, 'gate:', gate, 'registered:', registered);
         // console.log('attn', event.data.__attentive.action, event.data.__attentive);
         switch (event.data.__attentive.action) {
            case "DETECT_EXIT_INTENT":
               // creativeType: "DESKTOP"
               // isBubbleCreative: true
               // console.log('creativeType', event.data.__attentive.creativeType, 'isBubbleCreative', event.data.__attentive.isBubbleCreative);
               break;
            case "IMPRESSION":
               // creativeId: "216276"
               // console.log('creativeId', event.data.__attentive.creativeId);
               break;
            case "EXPAND":
               //Statements executed when the
               //result of expression matches value1
               //creativeId: "216276"
               // console.log('creativeId', event.data.__attentive.creativeId);
               break;
            case "OPEN":
               //Statements executed when the
               //result of expression matches value2
               // layout: "fullscreen"
               // pageType: "field_capture"
               // ||
               // layout: "fullscreen"
               // pageType: "success"
               if (event.data.__attentive.pageType == "field_capture") {
                  if (registeredSMS) {
                    handleSignupSuccess();
                  }
                  else {
                     doBlur();
                  }
               }
               else if (event.data.__attentive.pageType == "bubble") {
                  if (registeredSMS) {
                     handleSignupSuccess();
                  }
                  else if (gate) {
                     forcePopup();
                  }
               }
               else if (event.data.__attentive.pageType == "success") {
                  handleSignupSuccess();
               }
               // console.log('layout', event.data.__attentive.layout, 'pageType', event.data.__attentive.pageType);
               break;
            case "EMAIL_LEAD":
               // creativeId: "216276"
               // email: "jonah@creori.com"
               // visitorId: "150a1fa592c24c539f0e3b4c03bf94a2"
               registered = true;
               registeredEmail = true;
               setSignupSeenCookies();
               break;
            case "LEAD":
               // anonymousId: ""
               // attentiveAPI: "https://api.attentivemobile.com"
               // attnDomain: "vonholz.attn.tv"
               // companyExternalId: "LJD"
               // creativeId: "216276"
               // email: "jonah@creori.com"
               // encodedSubscriberExternalId: "0"
               // environment: "prod"
               // impressionId: "0"
               // mobile: false
               // pageview: "2"
               // pageviewRuleLowerBound: undefined
               // phone: "(805) 570-1140"
               // sourceUrl: "https://vonholzhausen.com/"
               // templateId: 5
               // userId: "150a1fa592c24c539f0e3b4c03bf94a2"
               // visitorId: "150a1fa592c24c539f0e3b4c03bf94a2"
               registered = true;
               registeredSMS = true;
               setSignupSeenCookies();
               break;
            case "CLOSE":
               // closeType: undefined
               // creativeId: "216276"
               if (registered) {
                  handleSignupSuccess();
               }
               else {
                  handleSignupFailure();
               }
               // console.log('closeType', event.data.__attentive.closeType, 'creativeId', event.data.__attentive.creativeId, 'registered', registered);
               break;
            case "SHRINK":
               // creativeId: "216276"
               if (registered) {
                  handleSignupSuccess();
               }
               else if (seen) {
                  $('#PageContainer').removeClass('blurred');
               }
               else if (gate) {
                  handleSignupFailure();
               }
               break;
            default:
               //Statements executed when none of
               //the values match the value of the expression
               // console.log('default');
               break;
         }
      }

   }, false);

   return;
   //////////// ending here /////////////////

   if (document.querySelectorAll('body#sample-sale').length || document.location.pathname.indexOf('sample-sale') >= 0) {

      var shown = false;

     waitForAttentive = setInterval(function () {
       let op1a = $("#attentive_creative[style*='opacity: 1']");
       let op1b = $("#attentive_creative[style*='width: 100%']");
       let op0a = $("#attentive_creative[style*='opacity: 0']");
       let op0b = $("#attentive_creative[style*='bottom: 16px']");

       if(op1a.length && op1b.length) {
         $('#PageContainer').addClass('blurred');

         // document.querySelector('#attentive_creative').addEventListener('click', e => {
         //    e.preventDefault();
         //    e.stopImmediatePropagation();
         //    console.log('clicked #attentive_creative', e);
         // });

         shown = true;
       }
       else if(op0a.length && !op0b.length) {
         if (shown) {
            $('#PageContainer').removeClass('blurred');
            clearInterval(waitForAttentive);
         }
       }
     }, 500);

  }
}


showEarlyAccessEmailGate = function() {
  console.log('showEarlyAccessEmailGate');
  // if ($('body#early-access').length || document.location.pathname.indexOf('early-access') >= 0) {
  if ($('body#limited-edition').length || document.location.pathname.indexOf('limited-edition') >= 0 || $('body#the-design-lab').length || document.location.pathname.indexOf('design-lab') >= 0) {

    var gate = true;
    var queryParams = getQueryParams(document.location.search);

    if (queryParams.vhea == 'true' || queryParams.utm_medium == 'email' || queryParams.utm_medium == 'text' || queryParams.utm_source == 'attentive' || typeof(queryParams.externalId) !== 'undefined') {
      var domain = document.location.hostname.split('.');
      domain = domain.slice(domain.length - 2, domain.length).join('.');
      Cookies.set('vhea', 'true', { expires: 365, domain: domain, path: '/' });
      Cookies.set('signupSeen', 'true', { expires: 365, domain: domain, path: '/' });
      console.log('setting vhea cookies', queryParams);
      gate = false;
    }

    var seen = Cookies.get('vhea');

    // console.log('queryParams =', queryParams, 'seen =', seen, 'gate =', gate);

    // var code = Cookies.get('_promo_coupon');
    var saleSeen = Cookies.set('saleSeen');
    // if (code === 'VONHOLIDAY') {
    //   seen = true;
    // }

    if (queryParams.vhea == 'false') {
      gate = true;
      seen = false;
    }

    if (seen || !gate) {
      $('#PageContainer').removeClass('blurred');
    }
    else {
      $('#PageContainer').addClass('blurred');
      showEmailSignupModal.bind(this, "early-access")();
      $('#quickview-screen').off('click').off('click.quickview');

      $('.btn.early-access, .mobile-nav__link.limited-edition').on('click', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showEmailSignupModal("early-access");
      });

    }
  }
}

initEmailSignupModal = function() {
   var seen = Cookies.get('signupSeen'),
   ver = getQueryParams(document.location.search);
   console.log('initEmailSignupModal', 'ver', ver, 'seen', seen);

   // console.log('initEmailSignupModal', seen, ver);

   if (ver.preview)
     seen = false;

   if ( "175740354591,176145924127".indexOf($('#ProductDetails').data('id')) > -1)
     seen = true;

   if ($('.page-redirect').length)
     seen = true;

   if ($('body#banbu-leather').length)
     seen = true;

   if (ver.v == 'i' || ver.v == 'giveaway-thankyou')
      seen = false;

   if (!seen) {
     //setTimeout(showEmailSignupModal, 500); // DISABLE AUTOMATIC EMAIL POPUP
     showEmailSignupModal();
   }

   $('#MobileNewsletterLink').on('click', function(event) {
     $('[href="/pages/subscribe"]').click();
   });

   $('[href="/pages/subscribe"]').on('click', function(event) {
     showEmailSignupModal();
   });
  
  // $('#EnterToWin .btn').on('click', showEmailSignupModal);

   // $('.index-stacked #slide_0, #slide_0 a, #Waitlist').on('click', showEmailSignupModal);
   $('.index-stacked .home-wrapper').each(function(i) {
     $this = $(this);
     link = $('a', $this).attr('href');
     if (link == 'javascript:;')
       $this.on('click', showEmailSignupModal);
   });

   $('body.index .home-wrapper a').each(function(i) {
     $this = $(this);
     link = $this.attr('href');

     if (link == 'javascript:;')
        $this.on('click', showEmailSignupModal);
   });

   // $('#Waitlist').on('click', showEmailSignupModal);

   if (document.location.search.indexOf('signup') > -1) {
     showEmailSignupModal();
   }
}

initProductDescriptionTabs = function() {
  $('#ProductDetails .product-description ul.tabs').each(function() {
    // For each set of tabs, we want to keep track of
    // which tab is active and it's associated content
    var $active, $body = $('.tab-body'), $content, $links = $(this).find('a');

    // $('.tab-body h5').on('click', function() { console.log($(this).next('p').slideUp()) });

    // If the location.hash matches one of the links, use that as the active tab.
    // If no match is found, use the first link as the initial active tab.
    // $active = $($links.filter('[href="'+location.hash+'"]')[0] || $links[0]);
    // $active.addClass('active');
    $active = $links;
    $links.addClass('active');

    if (!$active.length) {
      // No tabs
      return false;
    }

    $content = $($active[0].hash);

    // Hide the remaining content
    $links.not($active).each(function () {
      $(this.hash).removeClass('active');
    });

    // Bind the click event handler
    $(this).on('click', 'a', function(e){
      // Make the old tab inactive.

      $active.removeClass('active');
      $content.removeClass('active');


      // Update the variables with the new link and content
      $active = $(this);
      $content = $(this.hash);

      // Make the tab active.
      $active.addClass('active');
      $content.addClass('active');

      // document.location.hash = this.hash;

      // Prevent the anchor's default click action
      e.preventDefault();
    });

    // Bind the click event handler
    $body.on('click', 'h5', function(e) {
      var $target = $(e.target);
      var $sect = $target.parent();
      var $content = $target.siblings('p, ul, ol, div, span, table');
      // $('> div', $body).removeClass('active');
      if ($sect.hasClass('active')) {
        $content.slideUp({
          done: function(e) {
            $sect.removeClass('active');
            $content.removeAttr('style');
          }
        });
      }
      else {
        $content.slideDown({
          done: function(e) {
            $sect.addClass('active');
            $content.removeAttr('style');
          }
        });
      }
      
      // document.location.hash = this.hash;
      // $content.slideToggle(400, 'swing', function(e) {
      //  console.log(e, this);
      // });
      // console.log('click h5', e.target, this, $content);
    });
  });
}

initAccordions = function() {
  let $body = $('.accordion-terms .tab-body');
  let $links = $('a', $body);
  let $images = $('.accordion-terms .image-body img');

  if ($body.length < 1) {
    return;
  }

  console.log('initAccordions', $body);

  toggleImages = function ($section) {
    console.log('toggleImages', );
    let imgNum = 0;
    if (typeof($section) == 'object')
      imgNum = parseInt($section.attr('id').substr(3,2)) - 1;
    else if (typeof($section) == 'number')
      imgNum = $section;
    if ($images.length >= imgNum + 1) {
      $images.removeClass('open');
      $($images[imgNum]).addClass('open');
    }
  }

  // Bind the click event handler
  $body.on('click', '.row', function(e) {
    var $target = $(e.currentTarget);
   console.log('initAccordions onclick', $target);
    var $sect = $target;
    var $content = $('.body', $target);
    if ($sect.hasClass('active')) {
      $sect.removeClass('open');
      toggleImages(0);
      $content.slideUp({
        done: function(e) {
          $sect.removeClass('active');
          $content.removeAttr('style');
        }
      });
    }
    else {
      $sect.addClass('open');
      toggleImages($sect);
      $content.slideDown({
        done: function(e) {
          $sect.addClass('active');
          $content.removeAttr('style');
        }
      });
    }
    
    // document.location.hash = this.hash;
    // $content.slideToggle(400, 'swing', function(e) {
    //  console.log(e, this);
    // });
    // console.log('click h5', e.target, this, $content);
  });

  // Prevent toggling when clicking on a link in accordion content
  $links.on('click', function(el) {
    event.stopImmediatePropagation();
  })

  return;

  $('.accordion-terms ol.tab-body li').each(function() {
    // For each set of tabs, we want to keep track of
    // which tab is active and it's associated content
    var $active, $body = $('.tab-body'), $content, $links = $(this).find('a');


    // $('.tab-body h5').on('click', function() { console.log($(this).next('p').slideUp()) });

    // If the location.hash matches one of the links, use that as the active tab.
    // If no match is found, use the first link as the initial active tab.
    $active = $($links.filter('[href="'+location.hash+'"]')[0] || $links[0]);
    $active.addClass('active');

    if (!$active.length) {
      // No tabs
      return false;
    }

    $content = $($active[0].hash);

    // Hide the remaining content
    $links.not($active).each(function () {
      $(this.hash).removeClass('active');
    });

    // Bind the click event handler
    $(this).on('click', 'a', function(e){
      // Make the old tab inactive.

      $active.removeClass('active');
      $content.removeClass('active');


      // Update the variables with the new link and content
      $active = $(this);
      $content = $(this.hash);

      // Make the tab active.
      $active.addClass('active');
      $content.addClass('active');

      // document.location.hash = this.hash;

      // Prevent the anchor's default click action
      e.preventDefault();
    });
  });
}



initProductCustomizer = function() {
  var $personalizer = $('#ProductPersonalizer');
  var $checkbox = $('#enable_personalization', $personalizer);
  var $sections = $('.sections > div', $personalizer);
  var $fields = $('input[type="text"]', $personalizer);
  var $swatches = $('.swatch_label', $personalizer);
  var $viewDetails = $('#viewDetails', $personalizer);
  var $initialsHiddenField = $("#properties_initials");
  var $initialsHiddenFieldAscii = $("#properties_initials_ascii");
  var $firstInputField = $('[name="initial_1"]')
  var $secondInputField = $('[name="initial_2"]')
  var $thirdInputField = $('[name="initial_3"]')
  var $addToCartButton = $("#AddToCart");

  $('#ProductPhotos').after($('#previewImage'));
  // $('#previewImage').wrap('<div class="monogram"></div>').after('<h3 class="text">ABC</h3>');
  // $('#ProductPhotos').after("<h1>AAA</h1>");
  $('#properties_color').val($('.swatch.active', $personalizer).data('hex'));

  $('#enable_personalization', $personalizer).on('click', function() {
    if ($checkbox.prop('checked')) {
      $('.sections', $personalizer).addClass('active');
      $('#ProductThumbs, #ProductPhotos').addClass('hide');
      $('#previewImage').show();
      $('#personalization_product, #properties_initials, #properties_initials_ascii, #personalization_title, #personalization_for_variant, #properties_color', $personalizer).attr('disabled', false);

      $("#AddToCartForm").append("<input type='hidden' name='properties[_LPROP]' value='Final Sale' id='LPROP'>")
      
      // personalizer has been enabled so we will disable the add to cart button until all 3 fields are filled out
      $addToCartButton.attr("disabled", "disabled");
    }
    else {
      $("#LPROP").remove();
      $('.sections', $personalizer).removeClass('active');
      $('#ProductThumbs, #ProductPhotos').removeClass('hide');
      $('#previewImage').hide();
      $('#personalization_product, #properties_initials, #properties_initials_ascii, #personalization_title, #personalization_for_variant, #properties_color', $personalizer).attr('disabled', true);
      $addToCartButton.removeAttr("disabled");
      $initialsHiddenField.val('');
      $initialsHiddenFieldAscii.val('');
      // $fields.each(function(){
        // $(this).val("")
      // })
    }
  });

  /*$sections.each(function() {
    // For each set of tabs, we want to keep track of
    // which tab is active and it's associated content
    var $active, $content, $this = $(this), $body = $('.body', this);

    // $('.tab-body h5').on('click', function() { console.log($(this).next('p').slideUp()) });

    // If the location.hash matches one of the links, use that as the active tab.
    // If no match is found, use the first link as the initial active tab.
    $active = $($sections.filter('[href="'+location.hash+'"]')[0] || [$sections[0], $sections[1]]);
    $active.addClass('active');

    $content = $($active[0].hash);

    // Hide the remaining content
    $sections.not($active).each(function () {
      $(this.hash).removeClass('active');
    });
  });*/

  // $('#ProductPhotos').after($('#previewImage'));
  // $('#properties_color').val($('.swatch.active', $personalizer).data('hex'));

  // $('#enable_personalization', $personalizer).on('click', function() {
  //   if ($checkbox.prop('checked')) {
  //     $('.sections', $personalizer).addClass('active');
  //     $('#ProductThumbs, #ProductPhotos').addClass('hide');
  //     $('#previewImage').show();
  //     $('#personalization_product, #properties_initials, #properties_initials_ascii, #personalization_title, #personalization_for_variant, #properties_color', $personalizer).attr('disabled', false);
  //   }
  //   else {
  //     $('.sections', $personalizer).removeClass('active');
  //     $('#ProductThumbs, #ProductPhotos').removeClass('hide');
  //     $('#previewImage').hide();
  //     $('#personalization_product, #properties_initials, #properties_initials_ascii, #personalization_title, #personalization_for_variant, #properties_color', $personalizer).attr('disabled', true);
  //   }
  // });

  $sections.each(function() {
    // For each set of tabs, we want to keep track of
    // which tab is active and it's associated content
    var $active, $content, $this = $(this), $body = $('.body', this);

    // $('.tab-body h5').on('click', function() { console.log($(this).next('p').slideUp()) });

    // If the location.hash matches one of the links, use that as the active tab.
    // If no match is found, use the first link as the initial active tab.
    $active = $($sections.filter('[href="'+location.hash+'"]')[0] || [$sections[0], $sections[1]]);
    $active.addClass('active');

    $content = $($active[0].hash);

    // Hide the remaining content
    $sections.not($active).each(function () {
      $(this.hash).removeClass('active');
    });

    // Bind the click event handler
    $this.on('click', 'h5', function(e) {
      var $target = $(e.target);
      var $sect = $target.parent();
      var $content = $target.siblings('.body');
      // $('> div', $body).removeClass('active');
      if ($sect.hasClass('active')) {
        $content.slideUp({
          done: function(e) {
            $sect.removeClass('active');
            $content.removeAttr('style');
          }
        });
      }
      else {
        $content.slideDown({
          done: function(e) {
            $sect.addClass('active');
            $content.removeAttr('style');
          }
        });
      }
      
      // document.location.hash = this.hash;
      // $content.slideToggle(400, 'swing', function(e) {
      //  console.log(e, this);
      // });
      // console.log('click h5', e.target, this, $content);
    });
  });

  $viewDetails.on('click', function(evt) {
    var id = $(this).data('section');
    var $section = $($sections).filter('#' + id);
    var delay = 400;
    if ($checkbox.prop('checked')) {
      evt.preventDefault();
      delay = 0;
    } else 
    if ($section.hasClass('active')) {
      return;
    }
    setTimeout(function() {
      $section.children('h5').trigger('click');
    }, delay);
  });

  // check if string contains only alpha characters, or if it is empty (empty is ok)
  function checkValueOrEmpty(value) {
   console.log('checkValueOrEmpty', value, /([a-z]|\s|^$)/i.test(value));
    
   return true; // disabling check for now

    if (value) {
      return /([a-z]|\s|^$)/i.test(value);
    }
    return true
  }

  function checkAndUpdate(_event) {
   var attribs = getAttribs();

   if (!document.getElementById('enable_personalization') || !document.getElementById('enable_personalization').checked || !attribs) {
      return;
   }

   var str = $initialsHiddenField.val();
   str = str.replace('★', ' star ');
   str = str.replace('♥', ' heart ');
   $initialsHiddenFieldAscii.val(str);

    // if (!checkValueOrEmpty($firstInputField.val()) || !checkValueOrEmpty($secondInputField.val()) || !checkValueOrEmpty($thirdInputField.val())) {
   if (!checkValueOrEmpty($initialsHiddenField.val())) {
      $("#initial_error_notice").show();
      $("#empty_initial_error_notice").hide();
      _event.preventDefault();
      $addToCartButton.attr("disabled", "disabled");
    // } else if (!$firstInputField.val() && !$secondInputField.val() && !$thirdInputField.val()) {
    } else if (!$initialsHiddenField.val()) {
      _event.preventDefault()
      $addToCartButton.attr("disabled", "disabled");
      $("#initial_error_notice").hide();
      $("#empty_initial_error_notice").show();
      doPreview(attribs.text, attribs.hex);
    } else {
      $("#initial_error_notice").hide();
      $("#empty_initial_error_notice").hide();
      doPreview(attribs.text, attribs.hex);

      if ($initialsHiddenField.val()) {
        $addToCartButton.removeAttr("disabled");
      }
    }
  }


            String.prototype.InsertAt = function(CharToInsert, Position){
           return this.slice(0, Position) + CharToInsert + this.slice(Position);
            }

            $initialsHiddenField.on('keyup', (evt) => {
               console.log('click', evt, this);
               const reg = /[^ABCDEFGHIJKLMNOPQRSTUVWXYZ★♥]/g;
               let string = $initialsHiddenField.val();
               string = string.toUpperCase();
               string = string.replace(reg, "");
               $initialsHiddenField.val(string);
               // $('#initialPreview').text(string);
            });

            $('#keyboard > div').on('click', (evt) => {
               const reg = /[^ABCDEFGHIJKLMNOPQRSTUVWXYZ★♥]/g;
               let string = $initialsHiddenField.val();
               // const reg = /\d{3}/g
               const el = document.getElementById('properties_initials');

               console.log('click0', evt, this, el);
               console.log('click1', string, el.selectionStart, el.selectionEnd);

               if (string.length < 3) {
                  string = string.InsertAt(evt.target.dataset.value, el.selectionEnd);
               }
               string = string.replace(reg, "");
               console.log('click2', string, el.selectionStart, el.selectionEnd);
               $initialsHiddenField.val(string).focus();
               // $('#initialPreview').text(string);
      checkAndUpdate(evt);
            });

            $('#clearPreview').on('click', (evt) => {
               let string = $initialsHiddenField.val();
               let el = document.getElementById('properties_initials');
               const se = el.selectionEnd;
               console.log('click', evt, this);
               console.log('click', string, se);
               if (string.length > 0) {
                  if (se) {
                     string = string.slice(0, se - 1) + string.slice(se);
                     el.setSelectionRange(se - 2, se - 2);
                     el.focus();
                  }
                  else {
                     string = string.slice(0, string.length - 1);
                  }
               }
               $initialsHiddenField.val(string); //.focus();
               // $('#initialPreview').text(string);
      checkAndUpdate(evt);
            });

   // $fields.on('change, keyup', function(event) {
   $initialsHiddenField.on('change, keyup', function(event) {
      checkAndUpdate(event);
   });

  $swatches.on('click', function() {
    var $this = $('.swatch', this);
    if (!$this.hasClass('disabled')) {
      $swatches.each(function() {
        $('.swatch', this).removeClass('active');
      });
      $this.addClass('active');
      var attribs = getAttribs();
      doPreview(attribs.text, attribs.hex);
    }
  });

  $('#AddToCart').on('click', function(event) {
   checkAndUpdate(event);
    getAttribs();
    return true;
  });

  var getAttribs = function() {
    if ($personalizer.length) {
      var attribs = {
        text: $initialsHiddenField.val().trim().toUpperCase(),
        /*text_old: ($('input[name="initial_1"]').val().trim() + $('input[name="initial_2"]').val().trim() + $('input[name="initial_3"]').val().trim()).toUpperCase(),*/
        hex: $('.swatch.active', $personalizer).data('hex'),
        color: $('.swatch.active', $personalizer).data('color')
      }

      $('#properties_initials', $personalizer).val(attribs.text);
      $('#properties_color', $personalizer).val(attribs.color);

      return attribs;
    }
  }

  var doPreview = function(text, color) {
    var url = 'https://monogrampreview.creori.com/';

    // if (text.length) {
      var source = url + '?' + $.param({text: text, color: color, productid: $personalizer.data('id'), handle: $personalizer.data('handle')});
      $.get( source, function( data ) {
        var img = url + 'previews/' + data;
        // bagPreviewButton.html('Preview').attr('disabled', false);
        $('#previewImage').attr('src', img);
        $('body').animate({scrollTop:0}, '500');
      });
    // }
  };

  $('.add-to-cart-form').on('submit', function() {
      var textFields = [
         $('input[name="initial_1"]'),
         $('input[name="initial_2   "]'),
         $('input[name="initial_3"]')
      ];
      var activeTextFields = 0;

      if(textFields[0].length) {
         textFields[0].val(textFields[0].val().toUpperCase());
         activeTextFields += 1;
      }
      if(textFields[1].length) {
         textFields[1].val(textFields[1].val().toUpperCase());
         activeTextFields += 1;
      }
      if(textFields[2].length) {
         textFields[2].val(textFields[2].val().toUpperCase());
         activeTextFields += 1;
      }

      var text1 = textFields[0].val() || '';
      var text2 = textFields[1].val() || '';
      var text3 = textFields[2].val() || '';
      var messageBox = $('.add-to-cart-message');

      if (activeTextFields && !(text1.length + text2.length + text3.length)) {
        event.preventDefault();
        console.log(messageBox, $('.note', messageBox));
        $('.note', messageBox).html('Please customize your bag with one or more lines of text before&nbsp;purchasing.');
        messageBox.hide().removeClass('hidden').fadeIn();
      }
      else {
        $('.note', messageBox).html('');
        messageBox.show().addClass('hidden');
      }

  });

}

initAccountTools = function() {
  $('#OrderTable .order_row > .grid').on('click', function(e) {
    // document.location.href = $(this).data('href');
    $this = $(this);
    $sprite = $('.sprite', $this);

    var qv = $('#order_row_' + $this.data('row'));

    // console.log($this, $sprite, $this.data('row'), qv);

    if (qv.hasClass('closed')) {

      // console.log('loading');
      qv.load(
        $this.data('href'),
        '',
        function(data, status, xhr) {
          // console.log('loaded');

          // qv.addClass('open');
          // qv.slideDown(2000);
          qv.css({height: $('div.table-wrap .full', qv).height()});
          qv.removeClass('closed'); //.css({height: 'auto'});
          $sprite.removeClass('sprite-plus').addClass('sprite-close');
          $this.parent().addClass('active');

          // if ($searchBar.hasClass('hide')) {
          //  $searchBar.removeClass('hide');
          //  var $searchContainer = $(e.currentTarget).siblings('.search-dropdown');
          //  $('.input-group-field', $searchContainer).focus();
          //  $body.one('click.searchBar', function(e) {
          //    console.log('hide');
          //    $searchBar.addClass('hide');
          //    // $body.off('click.searchBar');
          //  });
          // }
          // else {
          //  $searchBar.addClass('hide');
          //  $body.off('click.searchBar');
          // }


          try {
            // initNewsletterForms();
            // disableSignupOnClose(qv);
          }
          catch (e) {
            console.log('error', e);
          }
          // if (!qv.hasClass('vis')) {
          //  var qvTop = $(window).scrollTop() + ($(window).height()/2) - 300;
          //  if (qvTop < 0) qvTop = 0;
          //  qv.css('top', qvTop + 'px').fadeIn(500).addClass('signup').addClass('vis');
          //  $('#quickview-screen').fadeIn(250).addClass('vis');
          // }
        }
      );
    }
    else {
      qv.addClass('closed');
      $this.parent().removeClass('active');
      $sprite.removeClass('sprite-close').addClass('sprite-plus');
    }
  });
}

initSearch = function() {
  var $body = $('body');
  var $link = $('.search-toggle');
  var $searchBar = $link.siblings('.search-dropdown');

  // console.log('initSearch', $link); //, $searchBar

  var toggleSearch = function(e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    // console.log('on click.searchBar', e.currentTarget, $searchBar);

    if ($searchBar.hasClass('hide')) {
      $searchBar.removeClass('hide');
      var $searchContainer = $(e.currentTarget).siblings('.search-dropdown');
      $('.input-group-field', $searchContainer).focus();
      $body.one('click.searchBar', function(e) {
        // console.log('hide');
        $searchBar.addClass('hide');
        // $body.off('click.searchBar');
      });
    }
    else {
      $searchBar.addClass('hide');
      $body.off('click.searchBar');
    }
  }

  $searchBar.on('click.searchBar', function(e) {
    e.stopImmediatePropagation();
  });

  $('.search-bar button').on('click.searchButton', function(e) {
    try {
      twq('track','Search');
    } catch (e) {}
  });

  $link.on('click.searchBar', toggleSearch);

  $('.search-close').on('click.searchBar', toggleSearch );
}

initRelatedProducts = function() {
  if (typeof(relatedProducts) != 'undefined' && relatedProducts.length && relatedProducts[0] !== '') {
    var $container = $('.related-products');
    var $list = $('#relatedProducts', $container);
    var i = 0;
    var found = 0;

    var loadThumb = function() {
      if (++i <= 10 && relatedProducts.length) {
        var url = relatedProducts.shift();
        url += url.indexOf('?') == -1 ? '?view=thumb' : '&view=thumb';
        // console.log('loadThumb', i, found, url);

        $.get(url, function() {
          // console.log( "success", i, url );
        })
        .done(function(product) {
          // console.log( "second success", i, url );
          // console.log('result', i, found, product);
          $list.append($.trim(product));
          found++;
        })
        .fail(function() {
          // console.log( "error", i, url );
        })
        .always(function() {
          // console.log( "finished", "loadThumb", i, url );
          loadThumb();
        });

      }
      else {
      // else if (!relatedProducts.length && found) {
        $container.fadeIn();
        // initQuickview();
        initBuyNow();
        initAddToCart();
      }
    }

    loadThumb();

  }
}

initWaitlistModal = function() {
  var showWaitlistModal = function(e, modal) {
    e.preventDefault();
    e.stopImmediatePropagation();
        console.log("showWaitlistModal", e, modal);
    var $ct = $(e.currentTarget);
    var handle = $ct.data('handle');
    var qv = $('#quickview');
    qv.addClass('waitlist');

    if (handle) {
      modal = '/products/' + handle + '?view=waitlist-modal';
    }
    
    modal = modal || globalWaitlistModal;

    qv.load(
      modal,
      '',
      function(data, status, xhr) {
        // initNewsletterForms();
        initWaitlistForm($('form', qv));

                // istockInitQv(jQuery(this), handle);

                // $('#iStockmodal').on('submit', function(evt) {
                //     evt.preventDefault();
                // });

        disableSignupOnClose(qv);

        if (!qv.hasClass('vis')) {
          var qvTop = $(window).scrollTop() + ($(window).height()/2) - 300;
          if (qvTop < 0) qvTop = 0;
          qv.css('top', qvTop + 'px').fadeIn(500).addClass('vis');
          $('#quickview-screen').fadeIn(250).addClass('vis');
        }
      }
    );
    return false;
  }

  // $('.index-stacked #slide_0, #slide_0 a, #Waitlist').on('click', showWaitlistModal);
  $('.index-stacked .home-wrapper').each(function(i) {
    $this = $(this);
    link = $('a', $this).attr('href');
    if (link == 'javascript:;')
      $this.on('click', showWaitlistModal);
  });

  $('body.index .home-wrapper a').each(function(i) {
    $this = $(this);
    link = $this.attr('href');

    if (link == 'javascript:;')
      $this.on('click', showWaitlistModal);
  });

  $('#Waitlist').on('click', showWaitlistModal);

  $('.thumb .join-waitlist').on('click', showWaitlistModal);

  if (document.location.search.indexOf('waitlist') > -1) {
    showProductWaitlist(event);
  }

  // if ( "175740354591,176145924127".indexOf($('#ProductDetails').data('id')) > -1) {
  //  showProductWaitlist(event); 
  // }

  // var domain = document.location.hostname.split('.');
  // domain = domain.slice(domain.length - 2, domain.length).join('.');
  // Cookies.set('signupSeen', 'true', { expires: 365, domain: domain, path: '/' });
  function showProductWaitlist() {
    var prod = "test";
    var sku = $('#ProductDetails').data('sku');
    if (sku) {
      prod = sku.replace(/ /g, '');
    }

    var seen = Cookies.get('waitlistSeen_' + prod);

    if (!seen) {
      showWaitlistModal(event, globalEarlyAccessModal);
    }
  }

  
}

initTechnikPageScroll = function() {
  if ($('body.overlay-header, body.template-index.index').length) {

    $navFade = { startHeight: 0, offset: 30, scrollTop: 0, window: $(window), body: $('body'), hero: $('#hero'), header: $('.site-header'), prevState: false };

    if ($navFade.body.hasClass('template-index'))
      $navFade.hero = $('.home-hero, #hero');

    $navFade.refreshHeight = function () {
      this.startHeight = this.offset;
    };

    $navFade.window.on('resize', function () {
      $navFade.refreshHeight();
    }); //.trigger('resize');

    $navFade.doReposition = function(e) {
      this.scrollTop = this.window.scrollTop();
      if (this.scrollTop <= this.startHeight) {
        if (this.prevState) {
          this.header.removeClass('fade-bg');
          this.prevState = false;
        }
      }
      else {
        if (!this.prevState) {
          this.header.addClass('fade-bg');
          this.prevState = true;
        }
      }
    }

    $(document).on('scroll', $navFade.doReposition.bind($navFade));
    // $navFade.doReposition.bind($navFade);
    $(document).ready($navFade.doReposition.bind($navFade));
  }
}


loadYTPlayers = function (force = false) {

   let vbgElems = document.querySelectorAll('[data-vbg]');
   vbgElems.forEach((vbgElem) => {
      if (vbgElem) {
         var ytBreakpoint = vbgElem.dataset.ytBreakpoint;
         // console.log('vbgElem', vbgElem.dataset.vbgDesktopSrc, vbgElem.dataset);
         if (window.innerWidth <= ytBreakpoint) {
            if (vbgElem.dataset.vbgMobileSrc)
               vbgElem.dataset.vbg = vbgElem.dataset.vbgMobileSrc;
            if (vbgElem.dataset.vbgPosterMobile)
               vbgElem.dataset.vbgPoster = vbgElem.dataset.vbgPosterMobile;
         }
         else {
            if (vbgElem.dataset.vbgDesktopSrc)
               vbgElem.dataset.vbg = vbgElem.dataset.vbgDesktopSrc;
            if (vbgElem.dataset.vbgPosterDesktop)
               vbgElem.dataset.vbgPoster = vbgElem.dataset.vbgPosterDesktop;
         }
      }
   });

   const vbg = new VideoBackgrounds('[data-vbg]');

   // console.log('new VideoBackgrounds', vbg);

   let element = document.querySelector('.video-background');
   if (element) {
     'video-background-ready,XXXvideo-background-time-update,video-background-state-change,video-background-play,video-background-pause,video-background-ended,video-background-mute,video-background-unmute,video-background-volume-change,video-background-resize,video-background-destroyed'.split(',').forEach( evt => {
        element.addEventListener(evt, event => {
           // console.log('vbg event', event.type, event.detail.currentState, event.detail, vbg.get(element));
           if (event.type == 'video-background-ready') {
              // event.detail.element.style.opacity = 0;
              // vbg.get(element).pause();
              vbg.get(element).play();
           }
           else if (event.type == 'video-background-pause') {
              // event.detail.element.style.opacity = 0;
              // console.log('video-background-pause', event.type, event.detail.currentState, event.detail, vbg.get(element));
              if (event.detail.type == 'vimeo') {
                 vbg.get(element).play();
              }
           }
           else if (event.type == 'video-background-state-change' && event.detail.currentState == 'playing') {
              // setTimeout(() => {
              //    event.detail.element.style.opacity = 1;
              // }, 100);
           }
        });
     });
   }

   var ytStates = {
      '-1': '(unstarted)',
      '0': '(ended)',
      '1': '(playing)',
      '2': '(paused)',
      '3': '(buffering)',
      '5': '(video cued)'
   };

   // var topQuality = null;


 if (typeof(YT) !== 'object') {
   // Load the IFrame Player API code asynchronously.
   var tag = document.createElement('script');
   tag.src = "https://www.youtube.com/player_api";
   var firstScriptTag = document.getElementsByTagName('script')[0];
   firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
 }
 
 onPlayerError = function(data) {
   console.log('YT.onPlayerError', data); 
 }

 getVideoId = function(element) {
   console.trace('getVideoId', element);

   const ds = element.dataset;
   if (ds.ytMobileId && window.innerWidth <= ds.ytBreakpoint)
     return ds.ytMobileId;
   else
     return ds.ytId;
 }

 getDataValue = function (element, value) {
   if (element && element.dataset) {
      return typeof(element.dataset[value]) !== 'undefined' ? (element.dataset[value].match(/^(true|yes|t|y|1)$/i) != null) : false;
   }

   return;
 }

 onPlayerReady = function(event) {
   const ytAutoplay = getDataValue(event.target.h, 'ytAutoplay');
    window.ytarget = event.target;
    console.log('onPlayerReady', ytAutoplay, event);

   if (ytAutoplay) {
      event.target.loadVideoById(getVideoId(event.target.h));
      // topQuality = event.target.playerInfo.availableQualityLevels;
      event.target.setPlaybackQuality('hd1080');
      console.log('onPlayerReady', 'loadVideoById', ytAutoplay, event.data, ytStates[event.data], getVideoId(event.target.h), 'opacity:', event.target.h.style.opacity);
      // event.target.playVideo();
      // setTimeout(() => {
      // console.log('onPlayerReady', 'playVideo 250', event.data);
      //   event.target.playVideo();
      // }, 250);
      // setTimeout(() => {
      // console.log('onPlayerReady', 'playVideo 500', event.data);
      // $('#YTPlayer-shtQIwSHm0I').click();
      //   event.target.playVideo();
      // }, 500);
      // setTimeout(function () {
      //    console.log("setTimeout playVideo");
      //    window.ytarget.playVideo();
      // }, 1000);
      // $(document).on('scroll mousemove', function () {
      //    console.log("setTimeout playVideo", window.ytarget, window.ytarget.playVideo);
      //    window.ytarget.playVideo();
      // });
   }
    else if (event.target.h) {
      event.target.cueVideoById(getVideoId(event.target.h));
      event.target.setPlaybackQuality('hd1080');
      setTimeout(() => {
        event.target.playVideo();
      }, 250);
      setTimeout(() => {
        event.target.pauseVideo();
      }, 500);
    }
   setupResize(event.target);
 }

 onPlayerStateChange = function(event) {
    const ytAutoplay = getDataValue(event.target.h, 'ytAutoplay');
    const ytLoop = getDataValue(event.target.h, 'ytLoop');
    const ytCloseOnEnd = getDataValue(event.target.h, 'ytCloseOnEnd');
    let $parent = $(event.target.h).parents('.video-player');
    let $wrapper = $(event.target.h).parents('.video-wrapper');
    console.log('onPlayerStateChange', event.data, ytStates[event.data], event, event.target.getPlaybackQuality(), 'opacity:', event.target.h.style.opacity, {'ytAutoplay': ytAutoplay, 'ytLoop': ytLoop, 'ytCloseOnEnd': ytCloseOnEnd});
    // return; // aborted for testing
    /** YouTube API
            -1 (unstarted)
            0 (ended)
            1 (playing)
            2 (paused)
            3 (buffering)
            5 (video cued)
     **/
    if (event.data === 0) {
      if (ytAutoplay && ytLoop) {
      console.log('onPlayerStateChange', 'playVideo');
        event.target.setPlaybackQuality('hd1080');
        event.target.playVideo();
         setTimeout(() => {
            console.log('onPlayerStateChange', 'playVideo 250');
            event.target.setPlaybackQuality('hd1080');
           event.target.playVideo();
         }, 250);
         setTimeout(() => {
            console.log('onPlayerStateChange', 'playVideo 500');
            event.target.setPlaybackQuality('hd1080');
           event.target.playVideo();
           // $('#YTPlayer-shtQIwSHm0I').click();
         }, 500);
        setTimeout(() => {
         console.log('event.target.h.style.opacity A', 'opacity:', event.target.h.style.opacity, event.target.getPlayerState());
         if (event.target.getPlayerState() === 1) {
              event.target.h.style.opacity = 1;
              $wrapper.css('opacity', 1);
           }
         }, 100);
        if($parent.length) {
           $parent[0].classList.add('playing');
           $parent[0].classList.remove('paused');
        }
      } else {
        event.target.setPlaybackQuality('hd1080');
        event.target.playVideo();
        event.target.pauseVideo();
        if($parent.length) {
           $parent[0].classList.remove('playing');
           $parent[0].classList.add('paused');
         }
      }

      if (ytCloseOnEnd) {
        setTimeout(doCloseQv, 750);
      }
   }
   else if (event.data === 1) {
     setTimeout(() => {
      console.log('event.target.h.style.opacity B', 'opacity:', event.target.h.style.opacity, event.target.getPlayerState());
      if (event.target.getPlayerState() === 1) {
           event.target.h.style.opacity = 1;
           $wrapper.css('opacity', 1);
        }
      }, 100);
    }
   else if (event.data === 2) {
    if ($parent.length) {
        $parent[0].classList.remove('playing');
        $parent[0].classList.add('paused');
      }
    }
   else if (event.data === 3) {
      event.target.setPlaybackQuality('hd1080');
    }
   else if (event.data === -1) {
      const quality = event.target.getPlaybackQuality();
      console.log('onPlayerStateChange', 'playVideo status', event.data, ytStates[event.data], quality, event.target.getPlayerMode(), event.target.getPlayerState());
      // if (quality !== 'unknown') {


      // }

   }
   
 }

 var player = null;
 var player_settings = null;

 getPlayerSettings = function() {
   return {
     height: '540',
     width: '960',
     playerVars: {
       'autoplay':'1',
       'loop':'1',
       'api': '1',
       'controls':'1',
       'disablekb':'1',
       'enablejsapi':'1',
       'fs':'0',
       'modestbranding':'0',
       'mute': '1',
       'playsinline':'1',
       'rel':'0',
       'origin':'https://vonholzhausen.com',
       'host': 'https://www.youtube.com'
     },
     events: {
       'onReady': onPlayerReady,
       'onStateChange': onPlayerStateChange,
       'onError': onPlayerError
     }
   };
 }

  loadPlayers = function() {

    player_settings = getPlayerSettings();

    console.log('loadPlayers', player_settings, this.player_settings);

   let players = [];
   let buttons = [];
   document.querySelectorAll('[data-yt-id]').forEach((element) => {
      const ytAutoplay = getDataValue(element, 'ytAutoplay');
      const ytLoop = getDataValue(element, 'ytLoop');
      const ytMute = getDataValue(element, 'ytMute');

      const settings = $.extend(true, {}, player_settings);
      settings.playerVars = $.extend(true, player_settings.playerVars, {autoplay: ytAutoplay, loop: ytLoop, mute: ytMute});

      console.log('data youtube id', element, settings);

      let player = new YT.Player(element, settings);

      players.push(player);
   
      buttons.push(activateButtons(player));
   });
   window.players = players;
 }
 
 // called from youtube API.
 onYouTubePlayerAPIReady = function() {

   player_settings = getPlayerSettings();

   console.log('onYouTubePlayerAPIReady', player_settings);

   loadPlayers();
 }

 activateButtons = function (player) {
  console.log('activateButtons', player);

  if (!player.h) {
   return;
  }

  let container = player.h.parentElement;
  let $parent = $(player.h).parents('.video-player');

  if (!$parent.length) {
   return;
  }
  
  container.addEventListener('click', (element, event) => {
    player.h.style.opacity = 1;
    const state = player.getPlayerState();
    switch(state) {
      case 1: // playing
        player.pauseVideo();
        $parent[0].classList.remove('playing');
        $parent[0].classList.add('paused');
      break;
      case 2: // paused
        player.playVideo();
        $parent[0].classList.add('playing');
        $parent[0].classList.remove('paused');
      break;
      default:
        player.playVideo();
        $parent[0].classList.add('playing');
        $parent[0].classList.remove('paused');
    }
  });
  container.addEventListener('mousover', (element, event) => {
    let $parent = $(player.h).parents('.video-player');
    $parent[0].classList.remove('hidden');
  });
  container.addEventListener('mousout', (element, event) => {
    let $parent = $(player.h).parents('.video-player');
    setTimeout( () => {
      $parent[0].classList.add('hidden');
    }, 500);
  });
 }

 setupResize = function(player) {
   if (typeof(player.h) == 'undefined' || typeof(player.h.dataset) == 'undefined') {
      return;
   }

   var ytBreakpoint = player.h.dataset.ytBreakpoint;
   var ytMobileview = null;

   function onResize (x) {
     const player = this;
     const newView = window.innerWidth <= ytBreakpoint;

     if (ytBreakpoint && player && newView !== ytMobileview) {
       player.loadVideoById(getVideoId(player.h));
     }

     ytMobileview = newView;
   }

   onResize.call(player);

   window.addEventListener('resize', onResize.bind(player));
 }

 if (force) {
   loadPlayers();
 }

}

initVideoPlayers = function() {
  var players = $('.media-player, .video.vimeo');

  players.toggleVideo = function(e) {
    var banner = $(e.currentTarget).hide();
    var videoContainer = banner.siblings('.video').show();
    var video = $('video', videoContainer)[0];
    video.play();
  }

  if (players.length) {
    $('.banner', players).on('click', players.toggleVideo);

    $('video', players).each( function() {
        this.addEventListener('click', function(e) {
        this.paused ? this.play() : this.pause();
      }, false);
    });
  }

  // initYouTubePlayersOLD();
  initVimeoPlayers();

}

initYouTubePlayersOLD = function() {

  var youtubes = $('.yt-player');
  var banner = $('.banner', youtubes);
  var videoContainer = banner.siblings('.video');
  var videoWrapper = $('.video-wrapper', videoContainer);
  var videoSection = youtubes.closest('.video');
  var ytID = videoWrapper.data('yt-id');
  var iOS = false; //!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);


  function onPlayerError(event) {
    console.log("yt-onPlayerError", event.data, event.target);
  }

  function onPlayerStateChange(event) {
    console.log("yt-onPlayerStateChange", event.data, event.target, YT.PlayerState);
    if (event.data == YT.PlayerState.ENDED) {
      banner.removeClass('playing');
      videoContainer.removeClass('playing');
      videoSection.removeClass('playing');
    }
  }

  function onPlayerReady(event) {
    console.log("yt-onPlayerReady", event.target);
    event.target.playVideo();
  }

  youtubes.toggleVideo = function(e) {
    console.trace('yt-toggleVideo', e, this);
    // var options = {
    //   autoplay: 1,
    //   enablejsapi: 1,
    //   hd: 1,
    //   html5: 1,
    //   playsinline: 1,
    //   rel: 0,
    //   showinfo: 0,
    //   modestbranding: 0,
    //   version: 3,
    //   wmode: 'opaque'
    // };

    // function onPlayerReady(event) {
    //   console.log("yt-onPlayerReady", event.target);
    //   event.target.playVideo();
    // }


    // player = new YT.Player('YTPlayer', {
    //     videoId: ytID,
    //     playerVars: options,
    //     events: {
    //       'onError': onPlayerError,
    //       'onStateChange': onPlayerStateChange
    //     }
    // });

    // var state = player.getPlayerState();

    // if (state == 1) {
    //   console.log('yt-pause');
    //   player.pauseVideo();
    // }
    // else {
    //   console.log('yt-play');
    //   player.playVideo();
    // }


    if (typeof(player) == 'undefined') {

      videoWrapper.html('<iframe allow="autoplay; fullscreen" type="text/html" src="https://www.youtube.com/embed/' + ytID + '?autoplay=1&version=3&enablejsapi=1&html5=1&hd=1&wmode=opaque&showinfo=0&amp;rel=0&origin=https://vonholzhausen.com;&playsinline=1" allowfullscreen="" width="100%" height="100%" style="opacity: 1; visibility: visible; width: 100%; height: 132.916%; position: absolute; left: 0px; top: -16.458%; display: block;" class="resizelistener" id="YTVideo"></iframe>');
      
      player = new YT.Player('YTVideo', {
        events: {
          'onError': onPlayerError,
          'onStateChange': onPlayerStateChange
        }
      });

      setTimeout(function() {
        banner.addClass('playing');
        videoContainer.addClass('playing');
        videoSection.addClass('playing');
      }, 500);

      if (iOS) {
        banner.addClass('hide');
        videoSection.addClass('iOS');
      }

    } else {
      var state = player.getPlayerState();

      if (state == 1) {
        console.log('yt-pause', state);
        player.pauseVideo();
      }
      else {
        console.log('yt-play', state);
        player.playVideo();
        banner.addClass('playing');
        videoContainer.addClass('playing');
        videoSection.addClass('playing');
      }
    }
      
  }

  if (youtubes.length) {
    $('.banner', youtubes).on('click', youtubes.toggleVideo);

    if (iOS) {
      youtubes.toggleVideo();
    }
  }

}

initVimeoPlayers = function() {

  var vimeos = $('.vimeo-player:not(.autoplay)');

  vimeos.toggleVideo = function(e) {
    console.log('vimeos.toggleVideo', e);
    var banner = $(e.currentTarget).parent().hide();
    var videoContainer = banner.siblings('.video').show();
    var options = {
      loop: true,
      autoplay: 1,
      title: 0,
      muted: 0,
      byline: 0,
      portrait: 0,
      api: 1
    };
    // controls: 0,

    var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    // var selector = '.video-wrapper.' + (window.innerWidth > 999 ? 'desktop' : 'mobile');
    var selector = '.video-wrapper.' + (window.innerWidth > 800 ? 'desktop' : 'mobile');

    // if (isFirefox || isSafari) {
    //   options['muted'] = 1;
    // }
    var videos = $(selector, videoContainer);

    if (!videos.length) {
      return false;
    }

    var player = new Vimeo.Player($(selector, videoContainer)[0], options);
console.log("player", player, selector, videoContainer);
console.log('banner', banner);
    
    player.on('play', function(data) {
      console.log("on.play", data, $('img, svg', banner));
      $('img, svg', banner).addClass('hide');
      var muted = null;
      player.getMuted().then(function(muted) {
        console.log('getMuted', muted, banner);
        if (muted){
          $('#muteButton', banner).removeClass('hide');
        }
        else {
         $('#unmuteButton', banner).removeClass('hide'); 
        }
      });
      console.log('play', data, muted);
      player.getVolume().then(function(volume) {
        console.log('getVolume', volume);
      });
    });


    player.on('pause', function(data) {
      player.setMuted(false);
      $('#muteButton, #unmuteButton', banner).addClass('hide');
    });


    player.on('volumechange', function(data) {
      console.log("on.volumechange", data);
      player.setMuted(false);
      $('#muteButton, #unmuteButton', banner).addClass('hide');
    });


    player.on('timeupdate', function(data) {
      $('#playButton', banner).addClass('hide');
    });

    player.on('ended', function(data) {
      console.log('player.ended', data);
      player.getLoop().then(function(loop) {
        console.log('player.getLoop', loop);
        if (!loop) {
          banner.show();
          $('#playButton', banner).removeClass('hide');
          $(selector, videoContainer)[0].dataset.vimeoMuted = 'false';
          videoContainer.fadeOut();
          player.destroy();
        }
      });
         
    });


    // togglePause = function(e) {
    //   console.log('vimeos.togglePause', e);

    //   player.getPaused().then(function(paused) {
    //     console.log('getPaused', paused);
    //     if(paused) {
    //      player.play();
    //        $('#muteButton, #unmuteButton', banner).removeClass('hide');
    //     }
    //     else {
    //      player.pause();
    //        $('#muteButton, #unmuteButton', banner).addClass('hide');
    //     }
    //   });

    // }

    // $(banner).on('click', togglePause);

    toggleMute = function(e) {
      console.log('vimeos.toggleMute', e);

      player.getMuted().then(function(muted) {
        console.log('getMuted', muted);
        player.setMuted(!muted);
        $('#muteButton, #unmuteButton', banner).toggleClass('hide');
      });

    }

    $('#muteButton, #unmuteButton', banner).on('click', toggleMute);

  }

  // console.log('vimeos', vimeos, $('.banner', vimeos), vimeos.toggleVideo);

  if (vimeos.length) {
    $('#playButton', vimeos).on('click', vimeos.toggleVideo);
  }
}

initVideoScrollToPlay = function() {

  var raf = window.requestAnimationFrame;
  var each = [].forEach;

  var breakpoint = {
    'videos': document.querySelectorAll('.hero.video.scroll-play')
  };

  if (breakpoint.videos.length) {

    breakpoint.playVideo = function(video) {
      $video = $('.video-wrapper', video);

      $('#playButton', video).trigger('click');
      // var player = new Vimeo.Player($video);
      // player.play();
    }

    breakpoint.getWindowOffset = function() {
      var offset = [window.pageYOffset, 0];
      offset[1] = offset[0] + window.innerHeight;
      return offset;
    }

    breakpoint.refreshValue();

    breakpoint.checkVisibility = function(e) {
      raf(function() {
        breakpoint.offset = breakpoint.getWindowOffset();
        
        each.call(breakpoint.videos, function(video, i) {
          var vis = breakpoint.offset[1] > breakpoint.offsets[i][0] && breakpoint.offset[0] < breakpoint.offsets[i][0];
          if (vis != breakpoint.offsets[i][2]) {
            if (vis && breakpoint.offsets[i][2] != null) {
              breakpoint.playVideo(breakpoint.videos[i]);
            }
            breakpoint.offsets[i][2] = vis;

          }

        });

      });

    }

    breakpoint.refreshValue = function () {
      breakpoint.offset = breakpoint.getWindowOffset();
      breakpoint.offsets = [];

      each.call(breakpoint.videos, function(elem, i) {
        breakpoint.offsets[i] = [elem.offsetTop, 0];
        breakpoint.offsets[i][1] = breakpoint.offsets[i][0] + elem.offsetHeight;
        breakpoint.offsets[i][2] = 'initial';
      });

      breakpoint.checkVisibility();

    };

    setTimeout(breakpoint.refreshValue, 500);

    $(window).resize(function () {
      breakpoint.refreshValue();
    });

    $(document).on('scroll', breakpoint.checkVisibility);

  }

}

initProductVideos = function() {

  const $videoContainers = $('.gallery-slide .video-player');
  const players = {};

  $videoContainers.each((i, el) => {
    const player = new Vimeo.Player(el);
    const $el = $(el);
    const props = $el.data();

    const urlParams = new URLSearchParams($el.data('vimeo-url').split('?')[1]);
    urlParams.forEach((value, key) => {
      props[key] = value;
    });

    let firstPlay = true;
    let secondPlay = true;

    console.log("initProductVideos", "each", i, el);

    $el.on('click', () => {

      $el.addClass('active');

      player.getPaused().then((paused) => {
        if (paused) {
          $el.addClass('playing').removeClass('paused');
          if (!props.videoMuted) {
            player.setVolume(1);
          }
          player.play();
          return 1;
        } else {
          $el.removeClass('playing').addClass('paused');
          player.pause();
          return 0;
        }
      }).catch(() => {});

      setTimeout((elem) => {
        console.log('timeout', this, el, elem);
        // el.blur();
        $el.removeClass('active');
      }, 2000);
      // player.getVolume().then(function(volume) {
      //   console.log('volume', volume);
      //   if (!volume)
      //     player.setVolume(1);
      //   else
      //     player.setVolume(0);
      // });
    }).on('mouseout', () => {
      $el.removeClass('active');
    });

    player.on('play', () => {
      if (!firstPlay) {

        if (secondPlay) {
          player.setCurrentTime(0);
          secondPlay = false;
        }
        return;
      }

      if (props.videoAutoplay) {
        $el.addClass('playing').removeClass('paused');
      } else {
        $el.removeClass('playing').addClass('paused');
        player.pause();
      }

      if (props.videoStartTime) {
        player.setCurrentTime(props.videoStartTime);
      }

      if (!props.videoAutoplay || (props.videoAutoplay && !props.videoStartMuted)) {
        player.setVolume(1);
      }

      firstPlay = false;
    });
    players[el.id] = player;
  });
};


initCountdownClock = function() {

  // From: https://www.sitepoint.com/build-javascript-countdown-timer-no-dependencies/
  var getTimeRemaining = function(endtime) {
    var t = Date.parse(endtime) - Date.parse(new Date());
    var seconds = Math.floor((t / 1000) % 60);
    var minutes = Math.floor((t / 1000 / 60) % 60);
    var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
    var days = Math.floor(t / (1000 * 60 * 60 * 24));
    return {
      'total': t,
      'days': days,
      'hours': hours,
      'minutes': minutes,
      'seconds': seconds
    };
  }

  var initializeClock = function(id, endtime) {
    var clock = document.getElementById(id);

    if (clock) {

      var daysSpan = clock.querySelector('.countdown_days');
      var hoursSpan = clock.querySelector('.countdown_hours');
      var minutesSpan = clock.querySelector('.countdown_minutes');
      // var secondsSpan = clock.querySelector('.countdown_seconds');

      function updateClock() {
        var t = getTimeRemaining(endtime);
        daysSpan.innerHTML = t.days;
        hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
        minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
        // secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);

        if (t.total <= 0) {
          clearInterval(timeinterval);
        }
      }

      updateClock();

      var timeinterval = setInterval(updateClock, 10000);
    }
  }

  // var deadline = new Date(Date.parse(new Date()) + 15 * 24 * 60 * 60 * 1000);
  var deadline = new Date(2017, 7, 21);

  initializeClock('CountdownTimer', deadline);
}

initABetterFlip = function() {
  var $aBetterFlip = $('#aBetterFlip');
  var $maxFontSize = parseInt($aBetterFlip.css('font-size'));
  var width = 0;
  var lastWidths = [];
  var fired = false;
  $aBetterFlip.slick({
    dots: false,
    arrows: false,
    slidesToShow: 1,
    autoplay: true,
    pauseOnHover: false,
    autoplaySpeed: 1000,
    fade: true,
    speed: 0
  })
  .on('setPosition', function() {

    if (!fired) {
      setTimeout( function() {
        $('.slick-slide', $aBetterFlip).bigtext({maxfontsize: $maxFontSize, resize: false});
        width = window.innerWidth;
        fired = true;
      }, 10);
    }
  })
  .on('beforeChange', function(evt, slick, currentSlide, nextSlide) {
    var $nextSlide = $(slick['$slides'][nextSlide]);

    if (lastWidths[nextSlide] != window.innerWidth) {
      $nextSlide.bigtext({maxfontsize: $maxFontSize, resize: false});
      width = window.innerWidth;
      lastWidths[nextSlide] = width;
    }
  });
}


initAffiliates = function() {
  $affilateSlides = $('body.page-affiliates #hero .slides');
  $affilateSlides.slick({
    dots: true,
    arrows: false,
    slidesToShow: 1,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 480,
        settings: "unslick"
      }
    ]
  });
}

initMensCampaignAnimation = function() {
  if ($('body.page-mens-campaign').length) {

    ajaxCart.formOverride($('form.item-order'));

    $('#verticalNav a').on('click', function(e) {
      e.preventDefault();
      var hash = this.href.split('#')[1];
      var $target = $('[name=' + hash +']');
      var top = parseInt($target.position().top) + 1;
      // console.log(this, hash, $target, top);
      $('html, body').animate({ scrollTop: top }, 1000);
    });
  }
}

initWarrantyForm = function() {
  var $warrantyRegisterButton = $('body.page-warranty #warrantyRegisterButton');
  var $warrantyForm = $('body.page-warranty #warrantyForm');
  var $warrantyFormSubmit = $('input[type="submit"]', $warrantyForm);
  
  if ($warrantyForm.length < 1) {
   return;
  }

  console.log('initWarrantyForm', $warrantyRegisterButton, $warrantyForm, $warrantyFormSubmit);
  var params = getQueryParams(document.location.search);
  if (params.contact_posted) {
    // $warrantyRegisterButton.hide();
    $warrantyForm.show();
  }

  toggleWarrantyForm = function(evt) {
    evt.preventDefault();
    $warrantyForm.slideDown(1000);
    // $warrantyRegisterButton.slideUp(1000);
  }

  submitWarrantyForm = function(evt) {
    evt.stopImmediatePropagation();
    evt.preventDefault();

    var $form = $('#contact_form', $warrantyForm);
    var $subscribe = $('[name="contact[opt_in]"]:checked', $form);

    var warranty_list = 'SJeQeu';

    console.log('submitWarrantyForm', $form, $subscribe, $subscribe.length);    

    var subscribeData = $form.serialize();
    subscribeData['Product Gender'] = subscribeData['contact[product_gender]'];
    subscribeData['$timezone_offset'] = (new Date()).getTimezoneOffset()/60 * -1;
    // subscribeData['source'] = 'Warranty Registration';

    var name = $form.find('input[name="contact[your-name]"]').val().split(' ');
    var first_name = name.shift();
    var last_name = name.join(' ');
    var email = $form.find('input[name="contact[email]"]').val();
    var product_gender = $form.find('input[name="contact[product_gender]"]:checked').val();
    var purchase_country = $form.find('select[name="contact[country]"]').val();
    var product_registering = $form.find('select[name="contact[product_registering]"]').val();
    var purchase_location = $form.find('select[name="contact[purchase_location]"]').val();
    var purchase_date = $form.find('input[name="contact[purchase_date]"]').val();
    var g = $form.find('input[name="g"]').val();

    var payload = {
      'first_name': first_name,
      'last_name': last_name,
      'email': email,
      'g': g,
      '$source': 'Warranty Registration',
      'Source': 'Warranty Registration',
      'Product Registered': product_registering,
      'Purchase Country': purchase_country,
      'Purchase Source': purchase_location,
      'Purchase Date': purchase_date,
      'Product Gender': product_gender,
      '$consent': 'email',
      '$method_type': 'Warranty Form',
      '$method_id': 'form',
      '$fields': 'Product Gender,Product Registered,Source,$source,$consent,$method_type,$method_id',
      '$list_fields': 'Product Gender'
    };

    console.log('subscribeData', subscribeData, payload, payload['Product Registered']);

    payload['g'] = warranty_list;
    console.log('registrationSub submitting', payload);

    try {
      $.ajax({
          method: 'POST',
          url: $form.data('ajax-action'),
          data: payload,
          timeout: 5000,
          success: function(data, status, xhr) {
            console.log('registrationSub success', data, status, xhr);
            submitSubscription(evt);
            return true;
          }
      });
    } catch (e) {
      console.log('registrationSub error', payload, e);
      submitSubscription(evt);
    }

    function submitSubscription(evt) {
      evt.stopImmediatePropagation();
      evt.preventDefault();

      if ($subscribe && $subscribe.length) {

        payload['g'] = $form.find('input[name="g"]').val();

        console.log('submitSubscription', payload);

        $.ajax({
            method: 'POST',
            url: $form.data('ajax-action'),
            data: payload,
            timeout: 5000,
            success: function(data, status, xhr) {
              console.log('submitSubscription success', data, status, xhr);
              try {
                fbq('track', 'Lead', {
                  content_name: 'Warranty Registration',
                  content_category: 'Mailing List'
                });
              } catch (e) {}
              try {
                ga('send', {
                  hitType: 'event',
                  eventCategory: 'Lead',
                  eventAction: 'Warranty Registration Signup',
                  eventLabel: 'Email Signup'
                });
              } catch (e) {}
              try {
                twq('track','Signup');
              } catch (e) {}
              try {
                pintrk('track', 'signup');
              } catch (e) {}

              $form.submit();
              return true;
              // return false;
            }
        });
      } else {
        $form.submit();
        return true;
        // return false;
      }

    }

  }

  $warrantyFormSubmit.one('click', function(evt) {
    evt.stopImmediatePropagation();
    evt.preventDefault();
    console.log('click warrantyForm submit button', evt);
    return submitWarrantyForm(evt);
  });

  $('body.page-warranty #warrantyRegisterButton, body.page-warranty .warrantyToggleLink').on('click', function(evt) {
    toggleWarrantyForm(evt);
  });

}

initMaterialSelectionIcons = function() {

  var raf = window.requestAnimationFrame;
  var each = [].forEach;

  var breakpoint = {
    'icons': document.querySelectorAll('.materials-section img, #TL2Layers, [id*=__biodegradation-timeline] img.icon, [id*=__biodegradation-the-test] .icon')
  };

  if (breakpoint.icons.length) {

    breakpoint.reloadImage = function(img) {
      img.src = img.src + '1';
      img.data = img.data + '1';
    }

    breakpoint.getWindowOffset = function() {
      var offset = [window.pageYOffset, 0];
      offset[1] = offset[0] + window.innerHeight;
      return offset;
    }

    breakpoint.checkVisibility = function(e) {
      raf(function() {
        breakpoint.offset = breakpoint.getWindowOffset();
        each.call(breakpoint.icons, function(icon, i) {
          var vis = breakpoint.offset[1] > breakpoint.offsets[i][0] && breakpoint.offset[0] < breakpoint.offsets[i][1];

         // console.log('initMaterialSelectionIcons', i, `${vis} = ${breakpoint.offset[1]} > ${breakpoint.offsets[i][0]} && ${breakpoint.offset[0]} < ${breakpoint.offsets[i][1]}`, breakpoint.offsets[i]);
          if (vis != breakpoint.offsets[i][2]) {
            if (vis && breakpoint.offsets[i][2] != null) {
              breakpoint.reloadImage(breakpoint.icons[i]);
            }

            breakpoint.offsets[i][2] = vis;

          }

        });

      });

    }

    breakpoint.refreshValue = function () {
      breakpoint.offset = breakpoint.getWindowOffset();
      breakpoint.offsets = [];

      each.call(breakpoint.icons, function(elem, i) {
         // console.log('initMaterialSelectionIcons', i, elem, elem.offsetParent);
         if (elem.classList.contains('icon') && elem.offsetHeight) {
            breakpoint.offsets[i] = [elem.offsetTop + elem.offsetParent.offsetTop + 100, elem.offsetTop + elem.offsetParent.offsetTop + elem.offsetHeight - 400, null];
         }
         else {
            breakpoint.offsets[i] = [elem.offsetTop, elem.offsetTop + elem.offsetHeight, null];
         }
      });

      breakpoint.checkVisibility();

    };

    setTimeout(breakpoint.refreshValue, 500);

    $(window).resize(function () {
      breakpoint.refreshValue();
    });

    breakpoint.refreshValue();

    $(document).on('scroll', breakpoint.checkVisibility);

  }

}

initAdditionalCheckoutButtons = function() {
  $('[data-testid="grid-cell"]', '.additional-checkout-buttons').waitUntilExists(function(ex) {
    $('#paypal-button').addClass('show');
  }, true);
}

cookieSaleCollection = function() {
   var $collections = $('.handle-20-off-sale-womens, .handle-20-off-sale-mens');
   if ($collections.length) {
      Cookies.set('saleSeen', 'true', { expires: 5, path: '/' });
   }

   // var saleSeen = Cookies.get('saleSeen');
   // if (saleSeen) {
   //    $('body.template-cart form .cart-table').prepend('<thead class="sale-note"><tr><th colspan="4">20% off holiday sale, use code <div>VONHOLIDAY</div> during&nbsp;checkout.</th></tr></thead>');
   // }
}

// From: http://stackoverflow.com/questions/979975/how-to-get-the-value-from-the-get-parameters#1099670
getQueryParams = function(qs) {
  qs = qs.split('+').join(' ');

  var params = {},
    tokens,
    re = /[?&]?([^=]+)=([^&]*)/g;

  while (tokens = re.exec(qs)) {
    params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
  }

  return params;
}

// Default Klaviyo object
var _learnq = _learnq || [];

$(document).ready( function() {

  initNav();
  initMobileNav();
  initHomeBannerSliders();
  initHomeCollectionSliders();
  initAltHome();
  initCartDropdown();

  initTechnikPageScroll();
  initMensCampaignAnimation();
  initABetterFlip();
  initAffiliates();
  initActionTracking();
  initButtonTracking();
  initProductSliders();
  initQuickview();

  initAdditionalCheckoutButtons();

  // showSampleSaleEmailGate();
  // show12DaysEmailGate();
  // doEarlyAccessEmailRedirect();
  // showEarlyAccessEmailGate();
  // doBalletFlatEmailRedirect();
  showDownloadEmailGate();
  // initEmailSignupModal();
  initNewsletterForms();
  //initYotpoHooks();
  initBuyNow();
  initAddToCart();
  initImageZoom();
  initRelatedProducts();
  // initHomeHeroScroll();
  initSocialShareModals();

  initAccordions();

  initLanderNewsletterForm();
  initArticleNewsletterForm();

  // initWaitlistModal();
  initWaitlistForm();
  initProductDescriptionTabs();
  initProductCustomizer();
  initSizeChartPopup();
  initAccountTools();
  // initItemScroll();
  // initVideoPlayers();
  loadYTPlayers();
  initVideoScrollToPlay();
  // initProductVideos();
  initSearch();
  // initCountdownClock();
  initGiftSetForms();
  initWarrantyForm();
  initMaterialSelectionIcons();
  cookieSaleCollection();
  // showEmailSignupModal(); // Always show for development
  
});

;(function ($, window) {

    var intervals = {};
    var removeListener = function(selector) {

      if (intervals[selector]) {
        
        window.clearInterval(intervals[selector]);
        intervals[selector] = null;
      }
    };
    var found = 'waitUntilExists.found';

    /**
     * @function
     * @property {object} jQuery plugin which runs handler function once specified
     *           element is inserted into the DOM
     * @param {function|string} handler 
     *            A function to execute at the time when the element is inserted or 
     *            string "remove" to remove the listener from the given selector
     * @param {bool} shouldRunHandlerOnce 
     *            Optional: if true, handler is unbound after its first invocation
     * @example jQuery(selector).waitUntilExists(function);
     */
     
    $.fn.waitUntilExists = function(handler, shouldRunHandlerOnce, isChild) {

      var selector = this.selector;
      var $this = $(selector);
      var $elements = $this.not(function() { return $(this).data(found); });
      
      if (handler === 'remove') {
        
        // Hijack and remove interval immediately if the code requests
        removeListener(selector);
      }
      else {

        // Run the handler on all found elements and mark as found
        $elements.each(handler).data(found, true);
        
        if (shouldRunHandlerOnce && $this.length) {
          
          // Element was found, implying the handler already ran for all 
          // matched elements
          removeListener(selector);
        }
        else if (!isChild) {
          
          // If this is a recurring search or if the target has not yet been 
          // found, create an interval to continue searching for the target
          intervals[selector] = window.setInterval(function () {
            
            $this.waitUntilExists(handler, shouldRunHandlerOnce, true);
          }, 250);
        }
      }
      
      return $this;
    };

  // $('input[name="checkout"]').prop('disabled', true).prop('value', "Check Out Loading");
  // $('input.bold_clone').waitUntilExists(function(ex) {
  //  var cloneButton = this;
  //  $(cloneButton).prop('disabled', false).prop('value', "Check Out");
  // }, true);


  // function waitForElement() {
  //   if(typeof BOLD.common.eventEmitter !== "undefined" || waitCount++ > 70){
  //     // console.log('BOLD.common.eventEmitter defined', BOLD.common.eventEmitter);
  //     $('#AddToCart, #AddToCartProxy').prop("disabled", false).select('span').html(AddToCartText);
  //     // $('#AddToCart span').data('label')
  //   }
  //   else{
  //     console.log('undefined', waitCount);
  //     setTimeout(waitForElement, 250);
  //   }
  // }

  // if ($('#AddToCart').prop("disabled") != true) {
  //  var waitCount = 0;
  //  var AddToCartText = $('#AddToCart span').html();
  //  $('#AddToCart, #AddToCartProxy').prop("disabled", true).select('span').html('Loading&hellip;')
  //  waitForElement();
  // }

}(jQuery, window));

// new ClipboardJS('#copy', {
//   text: function () {
//     return "PLANET10";
//   }
// });
